(function () {
  'use strict';

  /* ================================================================
     UPT Vector 3 Configurator – Core Logic
     IIFE with central state, DOM cache, event delegation.
     ================================================================ */

  var STAGE_COUNT = 8; // 7 stages + summary
  // Navigation order: Colors → Wingsuit → Harness → Deploy → Measurements → Canopy → (skip 7) → Summary
  var STAGE_ORDER = [2, 3, 4, 5, 1, 6, 8];

  /* ---- PATTERNS ---- */
  var PATTERNS = {
    'standard':           { name: 'Standard',              zones: ['Body'],                   desc: 'Single color / fabric panels' },
    'half-and-half':      { name: 'Half & Half',           zones: ['Left', 'Right'],          desc: 'Symmetrical vertical split' },
    'diagonal':           { name: 'Diagonal',              zones: ['Upper', 'Lower'],         desc: 'Dynamic angled split' },
    'v-split':            { name: 'V-Split',               zones: ['Center V', 'Outer'],      desc: 'Classic V shape on main flap' },
    'tri-v-split':        { name: 'Tri-color V-Split',     zones: ['Center V', 'Body', 'Surround'], desc: 'Three distinct colors in the V' },
    'triple-v-split':     { name: 'Triple V-Split',        zones: ['Left', 'Center V', 'Right'], desc: 'Left/right split with center V stripe' },
    'lightning':          { name: 'Lightning Split',        zones: ['Left', 'Right'],          desc: 'Jagged lightning bolt pattern' },
    'triple-lightning':   { name: 'Triple Lightning',       zones: ['Left', 'Center', 'Right'], desc: 'Multiple bolt layers' },
    'zigzag':             { name: 'Zig-zag',               zones: ['Primary', 'Secondary'],   desc: 'Sharp alternating angles' },
    'full-custom':        { name: 'Full Custom',            zones: ['Every Zone'],             desc: 'Color every panel individually (Included)' }
  };

  /* ---- PATTERN → SVG ZONE MAP (maps abstract zone indices to actual SVG zone IDs) ---- */
  /* NOTE: hcut/hres are intentionally excluded from ALL patterns — they are always independently colorable */
  var SHARED_ZONES = ['c2', 'c4', 'c7c', 'backp'];
  var PATTERN_ZONE_MAP = {
    'standard': [
      { idx: 0, ids: ['c1a','c1b','c1c','c2','c3a','c3b','c4','c5a','c5b','c6a','c6b','c7a','c7b','c7c','c8a','c8b','cfa','cfb','cfc','cfd','cfe','cff','cfg','backp','c1astab','c1bstab','lpad','rpad'] }
    ],
    'half-and-half': [
      { idx: 0, ids: ['c1a','c1c','c3a','c5a','c6a','c7a','c8a','cfa','cfb','cfc','cfd','lpad','c1astab','c2','c4','c7c','backp'] },
      { idx: 1, ids: ['c1b','c1d','c3b','c5b','c6b','c7b','c7d','c8b','cfdb','cfe','cff','cfg','rpad','c1bstab','c2b','c4b'] }
    ],
    'diagonal': [
      { idx: 0, ids: ['c1a','c1c','c3a','c5a','c6a','c7a','c7c','c8a','cfa','cfb','cfc','backp','c1astab','lpad','c2'] },
      { idx: 1, ids: ['c1b','c1d','c3b','c5b','c6b','c7b','c8b','cfd','cfe','cff','cfg','c1bstab','rpad','c2b','c4'] }
    ],
    'v-split': [
      { idx: 0, ids: ['c9b','c7c','c2'] },
      { idx: 1, ids: ['c1a','c1b','c1c','c3a','c3b','c4','c5a','c5b','c6a','c6b','c7a','c7b','c8a','c8b','c9a','c9c','cfa','cfb','cfc','cfd','cfe','cff','cfg','backp','c1astab','c1bstab','lpad','rpad'] }
    ],
    'tri-v-split': [
      { idx: 0, ids: ['c9b','c7c','c2','cfd'] },
      { idx: 1, ids: ['c1a','c1b','c1c','c4','c1astab','c1bstab','backp','lpad','rpad'] },
      { idx: 2, ids: ['c3a','c3b','c5a','c5b','c6a','c6b','c7a','c7b','c8a','c8b','cfa','cfb','cfc','cfe','cff','cfg','c9a','c9c'] }
    ],
    'triple-v-split': [
      { idx: 0, ids: ['c1a','c1c','c3a','c5a','c6a','c7a','c8a','c9a','cfa','cfb','cfc','c1astab','lpad','c4','backp'] },
      { idx: 1, ids: ['c9b','c7c','c2','cfd'] },
      { idx: 2, ids: ['c1b','c1d','c3b','c5b','c6b','c7b','c8b','c9c','c4b','cfe','cff','cfg','c1bstab','rpad'] }
    ],
    'lightning': [
      { idx: 0, ids: ['c1a','c1b','c1c','c1d','c3a','c5a','c5b','c6a','c6b','c7a','c8a','c9a','c1astab','lpad','backp','c2','c4','cfa','cfb','cfc','cfd'] },
      { idx: 1, ids: ['c3b','c7b','c8b','c9b','c1bstab','rpad','c4b','c2b','c7c','cfe','cff','cfg'] }
    ],
    'triple-lightning': [
      { idx: 0, ids: ['c1a','c1c','c3a','c5a','c6a','c7a','c8a','c9a','c1astab','lpad','backp','c2','c4','cfa','cfb','cfc','cfd'] },
      { idx: 1, ids: ['c9b','c7c','c3b','c2b','c4b'] },
      { idx: 2, ids: ['c1b','c1d','c5b','c6b','c7b','c8b','c1bstab','rpad','cfe','cff','cfg'] }
    ],
    'zigzag': [
      { idx: 0, ids: ['c1a','c1c','c3a','c5a','c6a','c7a','c8a','c9a','c1astab','lpad','backp','c2','c4','cfa','cfb','cfc','cfd'] },
      { idx: 1, ids: ['c1b','c1d','c3b','c5b','c6b','c7b','c8b','c9b','c1bstab','rpad','c4b','c2b','c7c','cfe','cff','cfg'] }
    ],
    'full-custom': [
      { idx: 0, ids: ['c1a','c1b','c1c','c2','c3a','c3b','c4','c5a','c5b','c6a','c6b','c7a','c7b','c7c','c8a','c8b','cfa','cfb','cfc','cfd','cfe','cff','cfg','backp','c1astab','c1bstab','lpad','rpad'] }
    ]
  };

  /* ---- HANDLE DEFAULTS: maps each handle to a zone group index for default color matching ---- */
  /* hres = reserve handle (left side), hcut = cutaway handle (right side) */
  var HANDLE_DEFAULTS = {
    'standard':         { hcut: 0, hres: 0 },
    'half-and-half':    { hcut: 1, hres: 0 },
    'diagonal':         { hcut: 1, hres: 0 },
    'v-split':          { hcut: 1, hres: 1 },
    'tri-v-split':      { hcut: 1, hres: 1 },
    'triple-v-split':   { hcut: 2, hres: 0 },
    'lightning':        { hcut: 1, hres: 0 },
    'triple-lightning': { hcut: 2, hres: 0 },
    'zigzag':           { hcut: 1, hres: 0 },
    'full-custom':      { hcut: 0, hres: 0 }
  };

  // Expose zone map + pattern metadata to Color Designer popup
  window.VCP_PATTERN_ZONE_MAP = PATTERN_ZONE_MAP;
  window.VCP_PATTERNS = PATTERNS;
  window.VCP_HANDLE_DEFAULTS = HANDLE_DEFAULTS;

  /* ================================================================
     UPT ORDER FORM — CODE MAPPING
     Maps our internal IDs → UPT's exact zone names, option labels,
     and shortcodes as used in their official order form / VOS system.
     ================================================================ */
  var UPT_MAP = {
    // Container panel zones → UPT panel names (as printed on order form)
    zones: {
      'c1a':'1A','c1b':'1B','c1c':'1C','c2':'2','c3a':'3A','c3b':'3B','c4':'4',
      'c5a':'5A','c5b':'5B','c6a':'6A','c6b':'6B','c7a':'7A','c7b':'7B','c7c':'7C',
      'c8a':'8A','c8b':'8B','c1d':'1D','c2b':'2B','c4b':'4B','c7d':'7D',
      'c9a':'9A','c9b':'9B','c9c':'9C',
      'c1astab':'Stab1A','c1bstab':'Stab1B','backp':'BackP',
      'lpad':'Left','rpad':'Right'
    },
    // Container panel print order (matches UPT PDF column order)
    zoneOrder: [
      'c1a','c1b','c1c','c2','c3a','c3b','c4','c5a','c5b',
      'c6a','c6b','c7a','c7b','c7c','c8a','c8b','c1astab','c1bstab','backp'
    ],
    // Trim tape zones → UPT trim names
    trim: {
      't1a':'T1A','t1b':'T1B','t2a':'T2A','t2b':'T2B','t3a':'T3A','t3b':'T3B',
      't4a':'T4A','t4b':'T4B','t6a':'T6A','t6b':'T6B','t7':'T7',
      't8atop':'T8A top','t8abot':'T8A bot','t8aside1':'T8A side',
      't8btop':'T8B top','t8bbot':'T8B bot','t8bside1':'T8B side',
      'tstab':'T Stab'
    },
    trimOrder: [
      't1a','t1b','t2a','t2b','t3a','t3b','t4a','t4b',
      't6a','t6b','t7','t8atop','t8abot','t8aside1',
      't8btop','t8bbot','t8bside1','tstab'
    ],
    // Leg pad trim
    legPadTrim: { 'tlegr':'T Right','tlegl':'T Left' },
    // Center flap zones → UPT flap names
    flaps: { 'cfa':'CFA','cfb':'CFB','cfc':'CFC','cfd':'CFD','cfdb':'CFDb','cfe':'CFE','cff':'CFF','cfg':'CFG' },
    flapOrder: ['cfa','cfb','cfc','cfd','cfdb','cfe','cff','cfg'],
    // Piping zones → UPT piping names
    piping: { 'pb':'PB','pc':'PC','pd':'PD','pe':'PE','pf':'PF','pg':'PG' },
    // Embroidery positions → UPT labels (panel# + name)
    embPositions: {
      'yk':  '(7C) YOKE',
      'sw':  '(1A) L SIDE WALL',
      'swr': '(1B) R SIDE WALL',
      'rc':  '(8A) L RING COVER',
      'rcr': '(8B) R RING COVER',
      'hcut':'CUTAWAY HANDLE',
      'hres':'RESERVE HANDLE',
      'bp':  'BACKPAD',
      'rf':  'RESERVE FLAP'
    },
    embSideOrder: ['yk','sw','swr','rc','rcr','hcut','hres','bp','rf'],
    // Pattern names → UPT pattern codes
    patterns: {
      'standard':'STANDARD','half-and-half':'HALF&HALF','diagonal':'DIAGONAL',
      'v-split':'VSPLIT','tri-v-split':'TRICOLORVSPLIT','triple-v-split':'TRIPLEVSPLIT',
      'lightning':'LIGHTNING','triple-lightning':'TRIPLELIGHTNING','zigzag':'ZIGZAG',
      'full-custom':'STANDARD'
    },
    // Reserve handle types → UPT labels
    reserveHandles: {
      'metal-d':'Mini-D handle (Spectra)','metal-d-stainless':'Mini-D handle (Stainless)',
      'pillow':'Pillow handle','freefly':'Freefly handle','lopro':'Lo-Pro handle'
    },
    // Main handle types → UPT labels
    mainHandles: {
      'plastic-handle':'PLASTIC','hackey':'HACKEY','monkey-fist':'MONKEY FIST',
      'freefly-tab':'FREEFLY','dual-tuck-tab':'DUAL TUCK TAB',
      'plastic':'PLASTIC','metal':'METAL PULLOUT','freefly':'FREEFLY',
      'boc':'BOC','ripcord':'RIPCORD'
    },
    // Toggle types → UPT labels
    toggles: { 'tru-lok':'TRU-LOK','velcro':'VELCRO','trident':'TRIDENT' },
    // Ring/webbing types → UPT labels
    rings: {
      'type-17':'Mini ring w/ type 17 webbing',
      'type-8':'Mini ring w/ type 8 webbing',
      'large-ring':'Large ring w/ type 17 webbing'
    },
    // Riser types → UPT labels
    risers: {
      'standard':'Standard','louie-loops':'Louie Loops','low-drag-louie':'Low-drag Louie Loops'
    },
    // Riser cover types → UPT labels
    riserCovers: { 'magnetic':'Magnetic riser covers','tuck-tab':'Tuck-tab riser covers','none':'None' },
    // Riser lengths → UPT labels
    riserLengths: {
      'standard':'21 inch','short':'17 inch','long':'23 inch','custom':'Custom'
    },
    // Emergency systems → UPT labels
    emergency: { 'rsl':'Skyhook RSL','none':'None','collins-lanyard':'Collins lanyard' },
    // Pilot chute fabric → UPT labels
    pcFabric: { 'f111':'F-111','zp':'ZP' },
    // Pilot chute sizes → UPT labels
    pcSize: { 'standard':'27 inch','30-wingsuit':'30 inch (Wingsuit)','lightweight':'25 inch (Lightweight)' },
    // D-bag types → UPT labels
    dBag: { 'standard':'Standard','semi-stowless':'V-Stow bag','stowless':'Stowless' },
    // Harness types → UPT labels
    harnessTypes: { 'standard':'Standard','articulated':'Articulated','swoop':'Swoop' },
    // Backpad types → UPT labels
    backpads: {
      'standard-deluxe':'Standard Deluxe','3d-spacer':'3D spacer foam','mini':'Mini backpad'
    },
    // Hardware finish → UPT labels
    hardwareFinish: { 'standard':'Standard (Cadmium)','black':'Black oxide','stainless':'Stainless steel' },
    // Embroidery thread color shortcodes (em-xxx → UPT shortcode)
    threadSC: {
      'em-black':'BLK','em-white':'WHT','em-smoke':'SMK','em-silver':'SIL',
      'em-neon-yellow':'NeYEL','em-yellow':'YEL','em-gold':'GLD',
      'em-neon-orange':'NeORG','em-orange':'ORG','em-red':'RED',
      'em-neon-pink':'NePNK','em-fuchsia':'FUS','em-pink':'PNK',
      'em-burgundy':'BUR','em-purple':'PUR','em-lavender':'LAV',
      'em-sky-blue':'SKYBL','em-light-blue':'LTBL','em-neon-blue':'NeBL',
      'em-royal-blue':'RBL','em-navy-blue':'NBL','em-teal':'TEL',
      'em-neon-green':'NeGRN','em-kelly-green':'KGR','em-forest-green':'FGR',
      'em-olive-drab':'OD','em-brown':'BRN','em-tan':'TAN','em-coyote':'COY'
    }
  };

  // Returns ordered list of container zone IDs for a given pattern (for PDF/order data)
  function getContainerZoneOrder(pattern) {
    var fullOrder = [
      'c1a','c1b','c1c','c1d','c2','c2b','c3a','c3b','c4','c4b',
      'c5a','c5b','c6a','c6b','c7a','c7b','c7c','c7d','c8a','c8b',
      'c9a','c9b','c9c','c1astab','c1bstab','backp'
    ];
    var patZones = {};
    var groups = PATTERN_ZONE_MAP[pattern] || PATTERN_ZONE_MAP['standard'];
    groups.forEach(function(g) {
      g.ids.forEach(function(id) { patZones[id] = true; });
    });
    return fullOrder.filter(function(zid) {
      return patZones[zid] && UPT_MAP.zones[zid];
    });
  }

  /* ---- PATTERN IMAGES (real UPT container photos) ---- */
  var UPT_IMG = 'https://cdn.shopify.com/s/files/1/0758/1191/4071/files/vcp-config-tool-';
  var PATTERN_IMAGES = {
    'standard':         UPT_IMG + 'CBook-Standard-529x705.jpg',
    'half-and-half':    UPT_IMG + 'CBook-HalfHalf-529x705.jpg',
    'diagonal':         UPT_IMG + 'CBook-Diagonal-529x705.jpg',
    'v-split':          UPT_IMG + 'CBook-VSplit-529x705.jpg',
    'tri-v-split':      UPT_IMG + 'CBook-TriColorVSplit-529x705.jpg',
    'triple-v-split':   UPT_IMG + 'CBook-TipleVSplit-529x705.jpg',
    'lightning':        UPT_IMG + 'CBook-Lightning-529x705.jpg',
    'triple-lightning': UPT_IMG + 'CBook-TripleLightning-529x705.jpg',
    'zigzag':           UPT_IMG + 'CBook-ZigZag-529x705.jpg',
    'full-custom':      UPT_IMG + 'CBook-Standard-529x705.jpg'
  };

  /* ---- CORDURA COLORS ---- */
  var UPT_CORD = 'https://cdn.shopify.com/s/files/1/0758/1191/4071/files/vcp-config-tool-';
  var COLORS = [
    { id: 'black',        name: 'Black',        hex: '#1a1a1a', img: UPT_CORD + 'Black2-705x705.jpg' },
    { id: 'smoke',        name: 'Smoke',        hex: '#6b6b6b', img: UPT_CORD + 'Smoke2-705x705.jpg' },
    { id: 'silver',       name: 'Silver',       hex: '#b0b0b0', img: UPT_CORD + 'Silver2-705x705.jpg' },
    { id: 'white',        name: 'White',        hex: '#f0f0f0', light: true, img: UPT_CORD + 'White2-705x705.jpg' },
    { id: 'neon-yellow',  name: 'Neon Yellow',  hex: '#e8f520', img: UPT_CORD + 'Neon-Yellow2-705x705.jpg' },
    { id: 'yellow',       name: 'Yellow',       hex: '#f0c808', img: UPT_CORD + 'Yellow2-705x705.jpg' },
    { id: 'gold',         name: 'Gold',         hex: '#c8a415', img: UPT_CORD + 'Gold2-705x705.jpg' },
    { id: 'neon-orange',  name: 'Neon Orange',  hex: '#ff6b1a', img: UPT_CORD + 'Neon-Orange2-705x705.jpg' },
    { id: 'orange',       name: 'Orange',       hex: '#e0601a', img: UPT_CORD + 'Orange2-705x705.jpg' },
    { id: 'red',          name: 'Red',          hex: '#cc0000', img: UPT_CORD + 'red2-705x705.jpg' },
    { id: 'neon-pink',    name: 'Neon Pink',    hex: '#ff3399', img: UPT_CORD + 'Neon-Pink2-705x705.jpg' },
    { id: 'burgundy',     name: 'Burgundy',     hex: '#6d1a2d', img: UPT_CORD + 'Burgundy2-705x705.jpg' },
    { id: 'purple',       name: 'Purple',       hex: '#6a1b9a', img: UPT_CORD + 'Purple2-705x705.jpg' },
    { id: 'light-blue',   name: 'Light Blue',   hex: '#63b3ed', img: UPT_CORD + 'Light-Blue2-705x705.jpg' },
    { id: 'neon-blue',    name: 'Neon Blue',    hex: '#1a8cff', img: UPT_CORD + 'Neon-Blue2-705x705.jpg' },
    { id: 'royal-blue',   name: 'Royal Blue',   hex: '#0044cc', img: UPT_CORD + 'Royal-Blue2-705x705.jpg' },
    { id: 'navy-blue',    name: 'Navy Blue',    hex: '#0a1744', img: UPT_CORD + 'Navy-Blue2-705x705.jpg' },
    { id: 'teal',         name: 'Teal',         hex: '#178582', img: UPT_CORD + 'Teal2-705x705.jpg' },
    { id: 'neon-green',   name: 'Neon Green',   hex: '#39e639', img: UPT_CORD + 'Neon-Green2-705x705.jpg' },
    { id: 'kelly-green',  name: 'Kelly Green',  hex: '#2a9d2a', img: UPT_CORD + 'Kelly-Green2-705x705.jpg' },
    { id: 'forest-green', name: 'Forest Green', hex: '#1a5c1a', img: UPT_CORD + 'Forest-Green2-705x705.jpg' },
    { id: 'olive-drab',   name: 'Olive Drab',   hex: '#556b2f', img: UPT_CORD + 'Olive-Drab2-705x705.jpg' },
    { id: 'brown',        name: 'Brown',        hex: '#6b3a1f', img: UPT_CORD + 'Brown2-705x705.jpg' },
    { id: 'beige',        name: 'Beige',        hex: '#d4c5a9', light: true, img: UPT_CORD + 'Beige.jpg' },
    { id: 'tan',          name: 'Tan',          hex: '#c2a770', img: UPT_CORD + 'Tan2-705x705.jpg' },
    { id: 'coyote',       name: 'Coyote',       hex: '#8b7355', img: UPT_CORD + 'Coyote2-705x705.jpg' }
  ];

  var SPECIALTY_COLORS = [
    { id: 'woodland-camo',     name: 'Woodland Camo',        hex: '#4a5d23', img: UPT_CORD + 'Woodland-Camo2-705x705.jpg' },
    { id: 'desert-camo',       name: 'Desert Camo',          hex: '#c2a97e', img: UPT_CORD + 'Desert-Camo2-705x705.jpg' },
    { id: 'desert-digi-camo',  name: 'Desert Digi Camo',     hex: '#b8a88a', img: UPT_CORD + 'Desert-Digi-Camo2-705x705.jpg' },
    { id: 'marpat-desert',     name: 'Marpat Desert Digi',   hex: '#a89570', img: UPT_CORD + 'Marpat-Deser-Digi-Camo2-705x705.jpg' },
    { id: 'marpat-woodland',   name: 'Marpat Woodland Digi', hex: '#4b5320', img: UPT_CORD + 'Marpat-Woodland-Digi2-705x705.jpg' },
    { id: 'multi-cam',         name: 'MultiCam',             hex: '#7c7a4e' },
    { id: 'black-multicam',    name: 'Black MultiCam',       hex: '#2a2a28', img: UPT_CORD + 'Black-Multicam-705x705.jpg' },
    { id: 'camo-multi',        name: 'Camo Multi',           hex: '#5e6b4e', img: UPT_CORD + 'camo-multi-swatch-scaled.jpg' },
    { id: 'galaxy-print',      name: 'Galaxy Print',         hex: '#1a0a3e', img: UPT_CORD + 'galaxy-swatch.png' },
    { id: 'kryptek-mandrake',  name: 'Kryptek Mandrake',     hex: '#3d5c3a', img: UPT_CORD + 'Mandrake2-705x705.jpg' },
    { id: 'kryptek-highlander',name: 'Kryptek Highlander',   hex: '#8a7d5a', img: UPT_CORD + 'Highlander2-705x705.jpg' },
    { id: 'kryptek-typhon',    name: 'Kryptek Typhon',       hex: '#2a2a2a', img: UPT_CORD + 'Typhon2-705x705.jpg' },
    { id: 'kryptek-raid',      name: 'Kryptek Raid',         hex: '#5a5a5a', img: UPT_CORD + 'Raid-705x705.jpg' }
  ];

  var ALL_COLORS = COLORS.concat(SPECIALTY_COLORS);

  /* ---- TRIM TAPE COLORS (real UPT fabric photos) ---- */
  var UPT_TRIM = 'https://cdn.shopify.com/s/files/1/0758/1191/4071/files/vcp-config-tool-';
  var TRIM_TAPE_COLORS = [
    { id: 'white',       name: 'White',       img: UPT_TRIM + 'White-705x235.jpg' },
    { id: 'black',       name: 'Black',       img: UPT_TRIM + 'black-705x235.jpg' },
    { id: 'smoke',       name: 'Smoke',       img: UPT_TRIM + 'Smoke-705x235.jpg' },
    { id: 'silver',      name: 'Silver',      img: UPT_TRIM + 'Silver-705x235.jpg' },
    { id: 'neon-yellow', name: 'Neon Yellow', img: UPT_TRIM + 'NeonYellow-705x235.jpg' },
    { id: 'yellow',      name: 'Yellow',      img: UPT_TRIM + 'yellow-705x235.jpg' },
    { id: 'gold',        name: 'Gold',        img: UPT_TRIM + 'Gold-705x235.jpg' },
    { id: 'neon-orange', name: 'Neon Orange', img: UPT_TRIM + 'neonorange-705x235.jpg' },
    { id: 'orange',      name: 'Orange',      img: UPT_TRIM + 'Orange-705x235.jpg' },
    { id: 'neon-pink',   name: 'Neon Pink',   img: UPT_TRIM + 'Neon-Pink-705x235.jpg' },
    { id: 'pink',        name: 'Pink',        img: UPT_TRIM + 'Pink-705x235.jpg' },
    { id: 'red',         name: 'Red',         img: UPT_TRIM + 'red-705x235.jpg' },
    { id: 'burgundy',    name: 'Burgundy',    img: UPT_TRIM + 'Burg-705x235.jpg' },
    { id: 'purple',      name: 'Purple',      img: UPT_TRIM + 'purple-705x235.jpg' },
    { id: 'fuchsia',     name: 'Fuchsia',     img: UPT_TRIM + 'fuschsia-705x235.jpg' },
    { id: 'sky-blue',    name: 'Sky Blue',    img: UPT_TRIM + 'Sky-Blue-trim-705x235-1.jpg' },
    { id: 'royal-blue',  name: 'Royal Blue',  img: UPT_TRIM + 'royal-705x235.jpg' },
    { id: 'navy-blue',   name: 'Navy Blue',   img: UPT_TRIM + 'Navy-705x235.jpg' },
    { id: 'teal',        name: 'Teal',        img: UPT_TRIM + 'teal-705x235.jpg' },
    { id: 'neon-green',  name: 'Neon Green',  img: UPT_TRIM + 'neongreen-705x235.jpg' },
    { id: 'kelly-green', name: 'Kelly Green', img: UPT_TRIM + 'Kelly-705x235.jpg' },
    { id: 'forest-green',name: 'Forest Green',img: UPT_TRIM + 'forest-705x235.jpg' },
    { id: 'olive-drab',  name: 'Olive Drab',  img: UPT_TRIM + 'Olive-705x235.jpg' },
    { id: 'brown',       name: 'Brown',       img: UPT_TRIM + 'Brown-705x235.jpg' },
    { id: 'coyote',      name: 'Coyote',      img: UPT_TRIM + 'Coyote-705x235.jpg' }
  ];

  /* ---- WEBBING COLORS (real UPT fabric photos) ---- */
  var WEBBING_COLORS = [
    { id: 'white',      name: 'White',      img: UPT_TRIM + 'webwhite-705x705.jpg' },
    { id: 'black',      name: 'Black',      img: UPT_TRIM + 'webblack-705x705.jpg' },
    { id: 'smoke',      name: 'Charcoal',   img: UPT_TRIM + 'webcharc-705x705.jpg' },
    { id: 'silver',     name: 'Silver',     img: UPT_TRIM + 'websilver-705x705.jpg' },
    { id: 'yellow',     name: 'Yellow',     img: UPT_TRIM + 'webyellow-705x705.jpg' },
    { id: 'gold',       name: 'Gold',       img: UPT_TRIM + 'webgold-705x705.jpg' },
    { id: 'orange',     name: 'Orange',     img: UPT_TRIM + 'weborange-705x705.jpg' },
    { id: 'red',        name: 'Red',        img: UPT_TRIM + 'webred-705x705.jpg' },
    { id: 'purple',     name: 'Purple',     img: UPT_TRIM + 'webpurple-705x705.jpg' },
    { id: 'royal-blue', name: 'Royal Blue', img: UPT_TRIM + 'webroyal-705x705.jpg' },
    { id: 'navy-blue',  name: 'Navy Blue',  img: UPT_TRIM + 'webnavy-705x705.jpg' },
    { id: 'olive-drab', name: 'Olive Drab', img: UPT_TRIM + 'webolive-705x705.jpg' },
    { id: 'coyote',     name: 'Coyote',     img: UPT_TRIM + 'webcayote-705x705.jpg' }
  ];

  /* ---- CANOPY DATA ---- */
  var MAIN_CANOPIES = {
    'Performance Designs': ['Sabre 3', 'Sabre 2', 'Pulse', 'Storm', 'CF Storm', 'Spectre', 'Horizon', 'Navigator', 'Lightning', 'Zero', 'Silhouette', 'Stiletto', 'Katana', 'Velocity', 'Comp Velocity', 'Valkyrie', 'Peregrine'],
    'Fluid Wings': ['Prime', 'Nexus', 'Echo', 'Gangster', 'Airwolf 2', 'HK Terminal', 'SAW'],
    'NZ Aerosports / JYRO': ['Safire 4', 'Safire 3', 'Crossfire 3', 'JFX 2', 'Leia', 'Petra', 'Kraken', 'Kraken ZP', 'Helium', 'Air Student', 'JVX'],
    'Icarus World': ['S-Fire', 'X-Fire', 'GT-R', 'Om', 'Omni', 'Equinox', 'Sky', 'Sophia'],
    'Aerodyne': ['Pilot', 'Pilot 7', 'Karma', 'Zulu', 'Triathlon', 'Mamba', 'Diablo'],
    'Squirrel': ['Epicene Pro 2', 'Omicron']
  };

  var RESERVE_CANOPIES = {
    'Performance Designs': ['PD Reserve', 'PD Optimum'],
    'Aerodyne': ['Smart', 'Smart LPV'],
    'Icarus': ['Nano', 'Reserve'],
    'Paratec': ['Speed 2000'],
    'Mars': ['Mars WP']
  };

  /* ---- UPT CONTAINER SIZING DATA (parsed from UPT sizing chart) ---- */
  var CONTAINER_DATA = [
    {n:'V300',t:'Micron',d:{wA:9,wB:9,l:14.5,th:5.5},
     m:{'Valkyrie':[71],'Valkyrie Hybrid':[67],'Velocity':[71],'Xfire':[75]},
     mf:{'Horizon':[120],'JFX2':[74],'Sabre2':[97],'Stiletto':[97],'Valkyrie':[75],'Valkyrie Hybrid':[71],'Velocity':[75]},
     r:{'Optimum':[99]},
     rf:{'Optimum':[106],'PD':[99]}},
    {n:'V303',t:'Micron',d:{wA:10,wB:10,l:15,th:4.5},
     m:{'Crossfire3':[99],'Epicene Pro':[113],'JFX2':[79,82],'Extreme-VX':[74],'Fusion':[98],'Katana':[97],'Leia':[84],'Neos':[79],'Nitron':[98],'Omega':[99],'Omicron':[113],'Omni':[99],'Sabre2':[97],'Safire3':[99],'Spectre':[97],'Stiletto':[97],'Storm':[97],'Synergy':[98],'Valkyrie':[79],'Valkyrie Hybrid':[75],'Velocity':[79],'Xaos-21':[78],'Xaos-27':[68],'Xfire':[92]},
     mf:{'Epicene Pro':[130],'JFX2':[84],'Extreme-VX':[79],'Horizon':[120],'Neos':[84],'Omicron':[130],'Pulse':[97],'Valkyrie':[84],'Valkyrie Hybrid':[79],'Velocity':[84]},
     r:{'Icarus Reserve':[99],'Optimum':[106],'PD':[99],'Smart':[99],'Techno':[98]},
     rf:{'PD':[106],'Icarus Reserve':[109],'Micro Raven':[109],'Nano':[106],'R-Max':[108]}},
    {n:'V304',t:'Micron',d:{wA:10,wB:10,l:15.5,th:4.5},
     m:{'Crossfire3':[109],'Epicene Pro':[130],'JFX2':[84,89],'Extreme-VX':[79],'Fusion':[108],'Horizon':[120],'Katana':[107],'Leia':[79],'Neos':[84,89],'Omega':[109],'Omicron':[130],'Omni':[109],'Pulse':[107],'Sabre2':[107],'Safire3':[109],'Spectre':[107],'Stiletto':[107],'Storm':[107],'Synergy':[108],'Valkyrie':[84],'Valkyrie Hybrid':[79],'Velocity':[84],'Xaos-21':[88],'Xaos-27':[78]},
     mf:{'JFX2':[94],'Horizon':[135],'Neos':[94],'Valkyrie':[90],'Valkyrie Hybrid':[84],'Velocity':[90],'Xaos-21':[88]},
     r:{'Icarus Reserve':[99],'Optimum':[106],'PD':[99],'Smart':[99],'Techno':[98]},
     rf:{'PD':[106],'Icarus Reserve':[109],'Micro Raven':[109],'Nano':[106],'R-Max':[108]}},
    {n:'V305',t:'Micron',d:{wA:10,wB:10,l:14.5,th:4.75},
     m:{'Valkyrie':[67,71],'Valkyrie Hybrid':[67],'Velocity':[71],'Xfire':[92]},
     mf:{'Horizon':[120],'JFX2':[74],'Sabre2':[97],'Safire3':[99],'Stiletto':[97],'Valkyrie':[75],'Valkyrie Hybrid':[71],'Velocity':[75],'Xfire':[102]},
     r:{'Icarus Reserve':[109],'Micro Raven':[109],'Optimum':[113],'PD':[106],'R-Max':[108],'Smart':[99],'Techno':[115]},
     rf:{'Icarus Reserve':[119],'Micro Raven':[120],'Nano':[113],'PD':[113],'R-Max':[118],'Smart':[110],'Speed':[120],'Tempo':[120]}},
    {n:'V305-1',t:'Micron',d:{wA:10,wB:10,l:15,th:5},
     m:{'Crossfire3':[109],'Epicene Pro':[113],'Horizon':[120],'JFX2':[84,89],'Leia':[79],'Omicron':[113],'Pulse':[107],'Sabre2':[107],'Safire3':[109],'Spectre':[107],'Stiletto':[107],'Storm':[107],'Valkyrie':[84],'Valkyrie Hybrid':[79],'Velocity':[84]},
     mf:{'JFX2':[94],'Epicene Pro':[130],'Horizon':[135],'Omicron':[130],'Valkyrie':[90],'Valkyrie Hybrid':[84],'Velocity':[90]},
     r:{'Icarus Reserve':[109],'Micro Raven':[109],'Optimum':[113],'PD':[106],'R-Max':[108],'Smart':[99],'Techno':[115]},
     rf:{'Icarus Reserve':[119],'Micro Raven':[120],'Nano':[113],'PD':[113],'R-Max':[118],'Smart':[110],'Speed':[120],'Tempo':[120]}},
    {n:'V306',t:'Micron',d:{wA:10,wB:10,l:15.5,th:5},
     m:{'Crossfire3':[119],'Epicene Pro':[130],'Fusion':[120],'Horizon':[135],'JFX2':[90],'Mamba':[104],'Neos':[94],'Nitron':[108],'Omega':[119],'Omicron':[130],'Omni':[119],'Pilot':[104],'Sabre2':[107],'Safire3':[119],'Synergy':[108],'Velocity':[96],'Spectre':[107],'Stiletto':[107],'Storm':[107],'Katana':[107]},
     mf:{'Crossfire3':[129],'Epicene Pro':[150],'Horizon':[150],'Katana':[120],'Neos':[104],'Omicron':[150],'Pulse':[120],'Sabre2':[120],'Safire3':[129],'Spectre':[120],'Stiletto':[120],'Valkyrie':[96],'Valkyrie Hybrid':[96]},
     r:{'Icarus Reserve':[109],'Micro Raven':[109],'Optimum':[113],'PD':[106],'R-Max':[108],'Smart':[99],'Techno':[115]},
     rf:{'Icarus Reserve':[119],'Micro Raven':[120],'Nano':[113],'PD':[113],'R-Max':[118],'Smart':[110],'Smart LPV':[120],'Speed':[120],'Tempo':[120]}},
    {n:'V307',t:'Micron',d:{wA:10,wB:11,l:15.5,th:5},
     m:{'Crossfire3':[119],'Epicene Pro':[130],'Horizon':[135],'JFX2':[94],'Omicron':[130],'Pilot':[104],'Pulse':[120],'Sabre2':[107],'Safire3':[119],'Spectre':[107],'Stiletto':[107],'Storm':[107],'Velocity':[96]},
     mf:{'Crossfire3':[129],'Epicene Pro':[150],'Horizon':[150],'Katana':[120],'Omicron':[150],'Sabre2':[120],'Safire3':[129],'Spectre':[120],'Stiletto':[120],'Storm':[120],'Valkyrie':[96],'Valkyrie Hybrid':[96]},
     r:{'Icarus Reserve':[119],'Micro Raven':[120],'Nano':[113],'Optimum':[126],'PD':[113],'R-Max':[118],'Smart':[110],'Speed':[120],'Tempo':[120]},
     rf:{}},
    {n:'V308',t:'Micron',d:{wA:10,wB:11,l:15.5,th:5.5},
     m:{'Crossfire3':[119,129],'Epicene Pro':[150],'Extreme-FX':[109,114],'Fusion':[120],'Horizon':[150],'Katana':[120],'Mamba':[124],'Neos':[109,114],'Nitron':[120],'Omega':[119,129],'Omicron':[150],'Omni':[119,129],'Pilot':[124],'Pulse':[135],'Sabre2':[120],'Safire3':[129],'Solo':[124],'Spectre':[120],'Stiletto':[120],'Storm':[120],'Synergy':[120],'Triathlon':[120],'Velocity':[96],'Xaos-21':[108],'Xaos-27':[108]},
     mf:{'Crossfire3':[139],'Epicene Pro':[170],'Extreme-FX':[119],'Fusion':[135],'Horizon':[170],'Katana':[135],'Omicron':[170],'Neos':[119],'Nitron':[135],'Omega':[139],'Omni':[139],'Pulse':[150],'Sabre2':[135],'Safire3':[139],'Silhouette':[135],'Storm':[135],'Synergy':[135],'Velocity':[103],'Xaos-21':[120],'Xaos-27':[118]},
     r:{'PD':[126],'Optimum':[126],'Icarus Reserve':[129],'Nano':[126],'R-Max':[128],'Smart':[120],'Techno':[128]},
     rf:{'Optimum':[143],'Micro Raven':[135],'Nano':[143],'Speed':[135]}},
    {n:'V309',t:'Micron',d:{wA:10,wB:11,l:17,th:5.5},
     m:{'Crossfire3':[139],'Epicene Pro':[170],'Extreme-FX':[119],'Fusion':[135],'Horizon':[170],'Katana':[135],'Mamba':[124,132],'Neos':[119],'Nitron':[135],'Omega':[139],'Omicron':[170],'Omni':[139],'Pilot':[132],'Pulse':[150],'Sabre2':[135],'Safire3':[139],'Silhouette':[135],'Spectre':[135],'Stiletto':[135],'Storm':[135],'Synergy':[135],'Triathlon':[135],'Valkyrie':[103],'Velocity':[103],'Xaos-21':[120],'Xaos-27':[118]},
     mf:{'Crossfire3':[149],'Epicene Pro':[190],'Fusion':[150],'Horizon':[190],'Katana':[150],'Mamba':[140],'Nitron':[150],'Omega':[149],'Omicron':[190],'Omni':[149],'Pilot':[140],'Pulse':[170],'Sabre2':[150],'Safire3':[149],'Silhouette':[150],'Spectre':[150],'Stiletto':[150],'Storm':[150],'Synergy':[150],'Velocity':[111],'Xaos-21':[135]},
     r:{'PD':[126],'Icarus Reserve':[129],'R-Max':[128],'Techno':[128]},
     rf:{'Optimum':[143],'Micro Raven':[135],'Nano':[143],'Speed':[135]}},
    {n:'V310',t:'Micron',d:{wA:10,wB:11,l:17,th:5.5},
     m:{'Crossfire3':[139],'Epicene Pro':[170],'Extreme-FX':[119],'Fusion':[135],'Horizon':[170],'Katana':[135],'Mamba':[124,132],'Neos':[119],'Nitron':[135],'Omega':[139],'Omicron':[170],'Omni':[139],'Pilot':[132],'Pulse':[150],'Sabre2':[135],'Safire3':[139],'Silhouette':[135],'Spectre':[135],'Stiletto':[135],'Storm':[135],'Synergy':[135],'Triathlon':[135],'Valkyrie':[103],'Velocity':[103],'Xaos-21':[120],'Xaos-27':[118]},
     mf:{'Crossfire3':[149],'Epicene Pro':[190],'Fusion':[150],'Katana':[150],'Mamba':[140],'Nitron':[150],'Omega':[149],'Omicron':[190],'Omni':[149],'Pilot':[140],'Pulse':[170],'Sabre2':[150],'Safire3':[149],'Silhouette':[150],'Spectre':[150],'Storm':[150],'Synergy':[150],'Velocity':[111],'Xaos-21':[135]},
     r:{'Icarus Reserve':[139],'Micro Raven':[135],'Nano':[143],'Optimum':[143],'PD':[126],'R-Max':[138],'Smart':[135]},
     rf:{'Icarus Reserve':[149],'Micro Raven':[150],'Nano':[160],'Optimum':[160],'PD':[143],'R-Max':[148],'Speed':[150]}},
    {n:'V314',t:'Micron',d:{wA:10,wB:10,l:17.5,th:4},
     m:{'Crossfire3':[99],'Epicene Pro':[113],'JFX2':[79],'Katana':[97],'Neos':[79],'Nitron':[98],'Omega':[99],'Omicron':[113],'Omni':[99],'Sabre2':[97],'Safire3':[99],'Spectre':[97],'Stiletto':[97],'Storm':[97],'Synergy':[98],'Valkyrie':[75,79],'Valkyrie Hybrid':[75],'Velocity':[71,79],'Xaos-21':[78],'Xaos-27':[68],'Xfire':[92]},
     mf:{'Epicene Pro':[130],'Horizon':[120],'Omicron':[130],'Neos':[84],'Pulse':[97],'Valkyrie':[84],'Valkyrie Hybrid':[79],'Velocity':[84]},
     r:{'Icarus Reserve':[109],'Micro Raven':[109],'Optimum':[113],'PD':[113],'R-Max':[108],'Smart':[99],'Nano':[113]},
     rf:{'Optimum':[126],'Smart':[110],'Techno':[115]}},
    {n:'V314-1',t:'Micron',d:{wA:10,wB:10,l:18.5,th:4},
     m:{'Crossfire3':[109],'Epicene Pro':[130],'Horizon':[135],'JFX2':[84,89],'Katana':[107],'Omicron':[130],'Sabre2':[107],'Safire3':[109],'Spectre':[107],'Stiletto':[107],'Storm':[107],'Valkyrie':[84],'Valkyrie Hybrid':[79],'Velocity':[84]},
     mf:{'Epicene Pro':[150],'Horizon':[150],'JFX2':[94],'Omicron':[150],'Valkyrie':[90],'Valkyrie Hybrid':[84],'Velocity':[90],'Xaos-21':[88]},
     r:{'Icarus Reserve':[109],'Micro Raven':[109],'Nano':[113],'Optimum':[113],'PD':[113],'R-Max':[108],'Smart':[99]},
     rf:{'Optimum':[126],'Smart':[110],'Techno':[115]}},
    {n:'V316',t:'Micron',d:{wA:10,wB:10,l:17.5,th:4.5},
     m:{'Crossfire3':[109],'Epicene Pro':[113],'JFX2':[84,89],'Fusion':[108],'Horizon':[120],'Katana':[107],'Neos':[84,89],'Nitron':[98],'Omega':[109],'Omicron':[113],'Omni':[109],'Pulse':[107],'Safire3':[109],'Spectre':[107],'Stiletto':[107],'Storm':[107],'Synergy':[108],'Valkyrie':[84],'Valkyrie Hybrid':[79],'Velocity':[84],'Xaos-21':[88],'Xaos-27':[78],'Xfire':[102]},
     mf:{'Crossfire3':[119],'Epicene Pro':[130],'Horizon':[135],'Neos':[94],'Omicron':[130],'Valkyrie':[90],'Valkyrie Hybrid':[84],'Velocity':[90],'Xaos-21':[88],'Xfire':[113]},
     r:{'Icarus Reserve':[119],'Micro Raven':[120],'Nano':[126],'Optimum':[126],'PD':[113],'R-Max':[118],'Smart':[110],'Techno':[115]},
     rf:{'Optimum':[143],'Techno':[128]}},
    {n:'V316-1',t:'Micron',d:{wA:10,wB:10,l:18.5,th:4.5},
     m:{'Epicene Pro':[150],'Horizon':[150],'Omicron':[150],'Pulse':[135],'Sabre2':[120],'Safire3':[129],'Spectre':[120],'Stiletto':[120],'Storm':[120],'Valkyrie':[96],'Valkyrie Hybrid':[90]},
     mf:{'Epicene Pro':[170],'Horizon':[170],'Omicron':[170],'Velocity':[96]},
     r:{'Icarus Reserve':[119],'Micro Raven':[120],'Nano':[126],'Optimum':[126],'PD':[113],'R-Max':[118],'Smart':[110],'Techno':[115]},
     rf:{'Optimum':[143],'Techno':[128]}},
    {n:'V317',t:'Micron',d:{wA:10,wB:10,l:16.5,th:5},
     m:{'Epicene Pro':[113],'Omicron':[113],'Valkyrie':[67,71],'Velocity':[71]},
     mf:{'Horizon':[120],'Sabre2':[97],'Stiletto':[97],'Valkyrie':[75],'Valkyrie Hybrid':[71],'Velocity':[75]},
     r:{'Icarus Reserve':[129],'Nano':[143],'Optimum':[143],'PD':[126],'R-Max':[128],'Techno':[128]},
     rf:{'Micro Raven':[135],'Smart':[120]}},
    {n:'V319',t:'Micron',d:{wA:10,wB:10,l:17.5,th:5},
     m:{'Crossfire3':[119],'Epicene Pro':[130],'JFX2':[94],'Fusion':[120],'Horizon':[135],'Mamba':[104],'Neos':[94],'Nitron':[108],'Omega':[119],'Omicron':[130],'Omni':[119],'Pilot':[104],'Safire3':[119],'Synergy':[108],'Valkyrie':[90],'Valkyrie Hybrid':[84],'Velocity':[90],'Xfire':[113]},
     mf:{'Crossfire3':[129],'Epicene Pro':[150],'Horizon':[150],'Katana':[120],'Neos':[104],'Omicron':[150],'Pulse':[135],'Sabre2':[120],'Safire3':[129],'Spectre':[120],'Stiletto':[120],'Storm':[120],'Valkyrie':[96],'Valkyrie Hybrid':[90],'Velocity':[96],'Xfire':[124]},
     r:{'Icarus Reserve':[129],'Nano':[143],'Optimum':[143],'PD':[126],'R-Max':[128],'Speed':[135],'Techno':[128]},
     rf:{'Micro Raven':[135],'Smart':[120]}},
    {n:'V319-1',t:'Micron',d:{wA:10,wB:10,l:18.5,th:5},
     m:{'Crossfire3':[129],'Epicene Pro':[170],'Horizon':[170],'Omicron':[170],'Pulse':[150],'Sabre2':[135],'Safire3':[129],'Spectre':[135],'Stiletto':[135],'Storm':[135],'Xfire':[139]},
     mf:{'Crossfire3':[139],'Epicene Pro':[190],'Horizon':[190],'Omicron':[190]},
     r:{'Icarus Reserve':[129],'Nano':[143],'Optimum':[143],'PD':[126],'R-Max':[128],'Speed':[135],'Techno':[128]},
     rf:{'Micro Raven':[135],'Smart':[120]}},
    {n:'V320',t:'Micron',d:{wA:10,wB:10,l:17,th:5.5},
     m:{'Crossfire3':[119],'Epicene Pro':[150],'Extreme-FX':[109,114],'Fusion':[120],'Horizon':[150],'Katana':[120],'Mamba':[124],'Neos':[109,114],'Nitron':[120],'Omega':[119,129],'Omicron':[150],'Omni':[119,129],'Pilot':[124],'Pulse':[120],'Sabre2':[120],'Safire3':[119,129],'Solo':[124],'Spectre':[120],'Stiletto':[120],'Storm':[120],'Synergy':[120],'Triathlon':[120],'Valkyrie':[103],'Velocity':[103],'Xaos-21':[108],'Xaos-27':[108]},
     mf:{'Crossfire3':[129,139],'Epicene Pro':[170],'Extreme-FX':[119],'Fusion':[135],'Horizon':[170],'Katana':[135],'Neos':[119],'Nitron':[135],'Omega':[139],'Omicron':[170],'Omni':[139],'Pulse':[150],'Sabre2':[135],'Silhouette':[135],'Spectre':[135],'Stiletto':[135],'Storm':[135],'Synergy':[135],'Velocity':[111],'Xaos-21':[120],'Xaos-27':[118]},
     r:{'PD':[126],'Icarus Reserve':[129],'Nano':[126],'R-Max':[128],'Smart':[120],'Techno':[128]},
     rf:{'Optimum':[143],'Micro Raven':[135],'Nano':[143],'Speed':[135]}},
    {n:'V328',d:{wA:10,wB:12,l:16,th:5},
     m:{'Crossfire3':[129],'Extreme-FX':[119],'Fusion':[135],'Horizon':[150],'Katana':[135],'Mamba':[124],'Neos':[119],'Nitron':[135],'Omega':[139],'Omni':[139],'Pilot':[124],'Pulse':[135],'Sabre2':[135],'Safire3':[139],'Silhouette':[135],'Solo':[124],'Spectre':[135],'Stiletto':[135],'Storm':[135],'Synergy':[135],'Triathlon':[120],'Valkyrie':[103],'Velocity':[103],'Xaos-21':[120],'Xaos-27':[118]},
     mf:{'Crossfire3':[139],'Horizon':[170],'Mamba':[132],'Pilot':[132],'Pulse':[150],'Silhouette':[150],'Triathlon':[135],'Velocity':[111]},
     r:{'Icarus Reserve':[129],'Nano':[143],'Optimum':[143],'PD':[126],'R-Max':[128],'Smart':[120],'Techno':[128]},
     rf:{'Micro Raven':[135],'Speed':[135]}},
    {n:'V339',d:{wA:10,wB:12,l:18,th:4},
     m:{'Crossfire3':[119],'Extreme-FX':[104],'Fusion':[120],'Horizon':[135],'Katana':[120],'Mamba':[104],'Neos':[104],'Nitron':[120],'Omega':[119],'Omni':[119],'Pilot':[104],'Pulse':[135],'Sabre2':[120],'Safire3':[119],'Spectre':[120],'Storm':[120],'Synergy':[120],'Valkyrie':[96],'Xaos-21':[108],'Xaos-27':[98]},
     mf:{'Extreme-FX':[109],'Horizon':[150],'Mamba':[111],'Pilot':[111],'Pulse':[150],'Valkyrie':[103],'Velocity':[103]},
     r:{'Icarus Reserve':[129],'Optimum':[143],'PD':[126],'R-Max':[128],'Techno':[128]},
     rf:{'Micro Raven':[135],'Smart':[120],'Speed':[135]}},
    {n:'V340',d:{wA:10,wB:12,l:18.5,th:4},
     m:{'Crossfire3':[119],'Extreme-FX':[114],'Fusion':[120],'Horizon':[150],'Katana':[120],'Mamba':[111],'Neos':[114],'Nitron':[120],'Omega':[119,129],'Omni':[119,129],'Pilot':[111],'Pulse':[135],'Sabre2':[120],'Safire3':[119,129],'Spectre':[120],'Stiletto':[120],'Storm':[120],'Valkyrie':[96],'Velocity':[96],'Xaos-21':[108],'Xaos-27':[98]},
     mf:{'Crossfire3':[129,139],'Extreme-FX':[119],'Fusion':[135],'Horizon':[170],'Katana':[135],'Mamba':[124],'Neos':[119],'Nitron':[135],'Omega':[139],'Omni':[139],'Pilot':[124],'Pulse':[150],'Sabre2':[135],'Safire3':[139],'Silhouette':[135],'Spectre':[135],'Storm':[135],'Triathlon':[120],'Valkyrie':[103],'Velocity':[103]},
     r:{'Icarus Reserve':[129],'Optimum':[143],'PD':[126],'R-Max':[128],'Techno':[128]},
     rf:{'Micro Raven':[135],'Smart':[120],'Speed':[135]}},
    {n:'V343',d:{wA:10,wB:12,l:18,th:4.5},
     m:{'Crossfire3':[119],'Extreme-FX':[114],'Fusion':[120],'Horizon':[150],'Katana':[120],'Mamba':[111],'Neos':[114],'Nitron':[120],'Omega':[119,129],'Omni':[119,129],'Pilot':[111],'Pulse':[135],'Sabre2':[120],'Safire3':[119,129],'Spectre':[120],'Stiletto':[120],'Synergy':[120],'Valkyrie':[103],'Xaos-21':[108],'Xaos-27':[98]},
     mf:{'Crossfire3':[129,139],'Extreme-FX':[119],'Fusion':[135],'Horizon':[170],'Katana':[135],'Mamba':[124],'Neos':[119],'Nitron':[135],'Omega':[139],'Omni':[139],'Pilot':[124],'Pulse':[150],'Sabre2':[135],'Safire3':[139],'Silhouette':[135],'Spectre':[135],'Stiletto':[135],'Storm':[135],'Synergy':[135],'Triathlon':[120],'Velocity':[111]},
     r:{'Icarus Reserve':[139],'Micro Raven':[135],'Optimum':[160],'PD':[143],'R-Max':[138],'Smart':[135],'Techno':[140]},
     rf:{'Icarus Reserve':[149],'Micro Raven':[150],'R-Max':[148],'Speed':[150]}},
    {n:'V344',d:{wA:10,wB:12,l:18.5,th:4.5},
     m:{'Crossfire3':[129,139],'Extreme-FX':[119],'Fusion':[135],'Horizon':[150],'Katana':[135],'Mamba':[124],'Neos':[119],'Nitron':[135],'Omega':[139],'Omni':[139],'Pilot':[124],'Pulse':[150],'Sabre2':[135],'Safire3':[139],'Silhouette':[135],'Spectre':[135],'Stiletto':[135],'Storm':[135],'Synergy':[135],'Triathlon':[120],'Valkyrie':[103],'Velocity':[103],'Xaos-21':[118],'Xaos-27':[108]},
     mf:{'Crossfire3':[149],'Fusion':[150],'Horizon':[170],'Katana':[150],'Mamba':[140],'Nitron':[150],'Omega':[149],'Omni':[149],'Pilot':[140],'Pulse':[170],'Sabre2':[150],'Safire3':[149],'Silhouette':[150],'Spectre':[150],'Stiletto':[150],'Storm':[150],'Synergy':[150],'Velocity':[111]},
     r:{'Icarus Reserve':[139],'Optimum':[160],'PD':[143],'R-Max':[138],'Smart':[135],'Techno':[140]},
     rf:{'Icarus Reserve':[149],'Micro Raven':[150],'R-Max':[148]}},
    {n:'V346',d:{wA:10,wB:12,l:19,th:5},
     m:{'Crossfire3':[189],'Equinox':[189],'Fusion':[190],'Pilot':[168],'Pulse':[210],'Sabre2':[190],'Safire3':[189],'Silhouette':[190],'Spectre':[190],'Stiletto':[190],'Storm':[190],'Synergy':[190],'Triathlon':[175]},
     mf:{'Equinox':[290],'Fusion':[210],'Pilot':[188],'Pulse':[230],'Sabre2':[210],'Safire3':[209],'Silhouette':[210],'Spectre':[210],'Storm':[210],'Synergy':[210],'Triathlon':[190]},
     r:{'Icarus Reserve':[139],'Optimum':[160],'R-Max':[138],'Smart':[135],'Techno':[140]},
     rf:{'Icarus Reserve':[149],'Micro Raven':[150],'R-Max':[148],'Speed':[150]}},
    {n:'V347',d:{wA:10,wB:12,l:18,th:5},
     m:{'Crossfire3':[129,139],'Extreme-FX':[119],'Fusion':[135],'Horizon':[150],'Katana':[135],'Mamba':[124],'Neos':[119],'Nitron':[135],'Omega':[139],'Omni':[139],'Pilot':[124],'Pulse':[150],'Sabre2':[135],'Safire3':[139],'Silhouette':[135],'Spectre':[135],'Storm':[135],'Synergy':[135],'Triathlon':[120],'Velocity':[111],'Xaos-21':[118],'Xaos-27':[108]},
     mf:{'Crossfire3':[149],'Fusion':[150],'Horizon':[170],'Katana':[150],'Mamba':[140],'Nitron':[150],'Omega':[149],'Omni':[149],'Pilot':[140],'Pulse':[170],'Sabre2':[150],'Safire3':[149],'Silhouette':[150],'Spectre':[150],'Stiletto':[150],'Storm':[150],'Synergy':[150],'Velocity':[120]},
     r:{'Icarus Reserve':[169],'Optimum':[176],'PD':[160],'R-Max':[168],'Smart':[150],'Techno':[155]},
     rf:{'Speed':[170]}},
    {n:'V348',d:{wA:10,wB:12,l:18.5,th:5},
     m:{'Crossfire3':[149],'Fusion':[150],'Horizon':[170],'Katana':[150],'Mamba':[150],'Nitron':[150],'Omega':[149],'Omni':[149],'Pilot':[150],'Pulse':[170],'Sabre2':[150],'Safire3':[149],'Silhouette':[150],'Spectre':[150],'Stiletto':[150],'Storm':[150],'Synergy':[150],'Velocity':[120]},
     mf:{'Crossfire3':[169],'Fusion':[175],'Horizon':[190],'Katana':[170],'Nitron':[170],'Omega':[169],'Omni':[169],'Pilot':[168],'Pulse':[190],'Sabre2':[170],'Safire3':[169],'Silhouette':[170],'Spectre':[170],'Stiletto':[170],'Storm':[170],'Synergy':[170],'Triathlon':[160]},
     r:{'Icarus Reserve':[169],'Optimum':[176],'PD':[160],'R-Max':[168],'Smart':[150],'Techno':[155]},
     rf:{'Speed':[170]}},
    {n:'V349',d:{wA:10,wB:12,l:17.5,th:5.5},
     m:{'Crossfire3':[149],'Fusion':[150],'Katana':[150],'Mamba':[150],'Nitron':[150],'Omega':[149],'Omni':[149],'Pilot':[150],'Pulse':[170],'Sabre2':[150],'Safire3':[149],'Silhouette':[150],'Spectre':[150],'Stiletto':[150],'Storm':[150],'Synergy':[150],'Velocity':[111]},
     mf:{'Crossfire3':[169],'Fusion':[175],'Katana':[170],'Nitron':[170],'Omega':[169],'Omni':[169],'Pilot':[168],'Pulse':[190],'Sabre2':[170],'Safire3':[169],'Silhouette':[170],'Spectre':[170],'Stiletto':[170],'Storm':[170],'Synergy':[170]},
     r:{'Icarus Reserve':[169],'Optimum':[193],'PD':[176],'R-Max':[168],'Smart':[160]},
     rf:{'Icarus Reserve':[189],'R-Max':[188],'Speed':[190]}},
    {n:'V350',d:{wA:10,wB:12,l:18.5,th:5.5},
     m:{'Crossfire3':[169],'Fusion':[175],'Nitron':[170],'Omega':[169],'Omni':[169],'Pilot':[168],'Pulse':[190],'Sabre2':[170],'Safire3':[169],'Silhouette':[170],'Spectre':[170],'Stiletto':[170],'Storm':[170],'Synergy':[170]},
     mf:{'Crossfire3':[189],'Equinox':[189],'Fusion':[190],'Omega':[189],'Omni':[189],'Pilot':[188],'Pulse':[210],'Sabre2':[190],'Safire3':[189],'Silhouette':[190],'Spectre':[190],'Stiletto':[190],'Storm':[190],'Synergy':[190],'Triathlon':[175]},
     r:{'Icarus Reserve':[169],'Optimum':[193],'PD':[176],'R-Max':[168],'Smart':[160]},
     rf:{'Icarus Reserve':[189],'R-Max':[188],'Speed':[190]}},
    {n:'V353',d:{wA:12,wB:14,l:18.5,th:5},
     m:{'Crossfire3':[189],'Equinox':[189],'Fusion':[190],'Pilot':[168],'Pulse':[210],'Sabre2':[190],'Safire3':[189],'Silhouette':[190],'Spectre':[190],'Stiletto':[190],'Storm':[190],'Synergy':[190],'Triathlon':[175]},
     mf:{'Equinox':[209],'Fusion':[210],'Pilot':[188,210],'Pulse':[230],'Sabre2':[210],'Safire3':[209],'Silhouette':[210],'Spectre':[210],'Storm':[210],'Synergy':[210],'Triathlon':[190]},
     r:{'Icarus Reserve':[189],'Optimum':[218],'PD':[193],'R-Max':[188],'Speed':[190],'Techno':[190]},
     rf:{'Icarus Reserve':[219],'Optimum':[235],'PD':[218],'R-Max':[208],'Smart':[190]}},
    {n:'V354',d:{wA:12,wB:14,l:19.5,th:4.25},
     m:{'Crossfire3':[189],'Equinox':[189],'Fusion':[190],'Pilot':[188],'Pulse':[210],'Sabre2':[190],'Safire3':[189],'Silhouette':[190],'Spectre':[190],'Stiletto':[190],'Storm':[190],'Synergy':[190],'Triathlon':[190]},
     mf:{'Fusion':[120],'Pilot':[210],'Pulse':[230],'Sabre2':[210],'Safire3':[209],'Silhouette':[210],'Spectre':[210],'Storm':[210],'Synergy':[210],'Triathlon':[210]},
     r:{'Icarus Reserve':[169],'Optimum':[193],'PD':[176],'R-Max':[168],'Smart':[160],'Speed':[190]},
     rf:{'Icarus Reserve':[189],'Optimum':[218],'PD':[193],'R-Max':[188],'Techno':[190]}},
    {n:'V355',d:{wA:12,wB:14,l:19.5,th:5},
     m:{'Equinox':[209],'Fusion':[210],'Pilot':[188],'Pulse':[230],'Sabre2':[210],'Safire3':[209],'Silhouette':[210],'Spectre':[210],'Storm':[210],'Synergy':[210],'Triathlon':[210]},
     mf:{'Fusion':[230],'Pilot':[210],'Sabre2':[230],'Safire3':[229],'Silhouette':[230],'Spectre':[230],'Storm':[230],'Synergy':[230],'Triathlon':[220]},
     r:{'Icarus Reserve':[189],'Optimum':[218],'PD':[193],'R-Max':[188],'Smart':[190],'Techno':[190]},
     rf:{'Icarus Reserve':[219],'Optimum':[235],'PD':[218],'R-Max':[208]}},
    {n:'V357',d:{wA:12,wB:14,l:18,th:5.5},
     m:{'Crossfire3':[189],'Equinox':[189],'Fusion':[190],'Pulse':[210],'Sabre2':[190],'Safire3':[189],'Silhouette':[190],'Spectre':[190],'Stiletto':[190],'Storm':[190],'Synergy':[190],'Triathlon':[190]},
     mf:{'Fusion':[210],'Pilot':[188],'Pulse':[230],'Sabre2':[210],'Safire3':[209],'Silhouette':[210],'Spectre':[210],'Storm':[210],'Synergy':[210]},
     r:{'R-Max':[208]},
     rf:{'Icarus Reserve':[219],'Optimum':[235],'PD':[218],'R-Max':[228],'Smart':[220]}},
    {n:'V358',d:{wA:12,wB:14,l:19,th:5.5},
     m:{'Equinox':[209],'Fusion':[210],'Pulse':[230],'Sabre2':[210],'Safire3':[209],'Silhouette':[210],'Spectre':[210],'Storm':[210],'Synergy':[210]},
     mf:{'Equinox':[239],'Fusion':[230],'Pilot':[210],'Sabre2':[230],'Safire3':[229],'Silhouette':[230],'Spectre':[230],'Storm':[230],'Synergy':[230],'Triathlon':[220]},
     r:{'Icarus Reserve':[219],'Optimum':[235],'PD':[218],'R-Max':[228]},
     rf:{'Smart':[220]}},
    {n:'V360-1',d:{wA:12,wB:14,l:18.5,th:6},
     m:{'Crossfire3':[229],'Fusion':[230],'Pulse':[230],'Sabre2':[230],'Safire3':[229],'Silhouette':[230],'Solo':[210],'Spectre':[230],'Storm':[230],'Synergy':[230],'Triathlon':[220]},
     mf:{'Solo':[230]},
     r:{'Icarus Reserve':[219],'Optimum':[235],'PD':[218],'R-Max':[228],'Techno':[240]},
     rf:{'PD':[235],'Smart':[220]}},
    {n:'V360-2',d:{wA:12,wB:14,l:19.5,th:6},
     m:{'Equinox':[239]},
     mf:{},
     r:{'Icarus Reserve':[219],'Optimum':[235],'PD':[218],'R-Max':[228]},
     rf:{'PD':[235],'Smart':[220]}},
    {n:'V362',d:{wA:13,wB:15,l:18.5,th:4.75},
     m:{'Equinox':[279]},
     mf:{'Equinox':[299]},
     r:{'Icarus Reserve':[169],'Optimum':[176],'PD':[160],'R-Max':[168],'Smart':[150],'Techno':[155]},
     rf:{}},
    {n:'V375',d:{wA:14,wB:16,l:20,th:5},
     m:{'Equinox':[259],'Sabre2':[260],'Silhouette':[260]},
     mf:{'Equinox':[279]},
     r:{'PD':[253],'Optimum':[253],'Icarus Reserve':[259],'R-Max':[248],'Techno':[240],'Smart':[250]},
     rf:{}},
    {n:'V378',d:{wA:14,wB:16,l:21,th:5},
     m:{'Equinox':[279]},
     mf:{'Equinox':[299]},
     r:{'PD':[253],'Icarus Reserve':[259],'R-Max':[268],'Smart':[250],'Techno':[240]},
     rf:{'PD':[281],'Icarus Reserve':[279],'R-Max':[288]}},
    {n:'V380',d:{wA:12,wB:14,l:19,th:6.5},
     m:{'Equinox':[239]},
     mf:{'Equinox':[259],'Sabre2':[260],'Silhouette':[260]},
     r:{'PD':[281],'Icarus Reserve':[279],'Smart':[270]},
     rf:{'R-Max':[288]}},
    {n:'V382',d:{wA:12,wB:14,l:20,th:6.5},
     m:{'Equinox':[259],'Sabre2':[260],'Silhouette':[260]},
     mf:{'Equinox':[279]},
     r:{'PD':[281],'Icarus Reserve':[279],'R-Max':[288],'Smart':[270]},
     rf:{'R-Max':[288]}}
  ];

  /* Map configurator canopy names → CSV names used in CONTAINER_DATA.
     Canopies not directly in UPT chart use pack-volume equivalents (marked ~). */
  var CSV_NAME = {
    // Performance Designs — direct
    'Sabre 3':'Sabre2','Sabre 2':'Sabre2','Pulse':'Pulse','Storm':'Storm',
    'Spectre':'Spectre','Horizon':'Horizon','Silhouette':'Silhouette',
    'Stiletto':'Stiletto','Katana':'Katana','Velocity':'Velocity',
    'Valkyrie':'Valkyrie','Valkyrie Hybrid':'Valkyrie Hybrid',
    // Performance Designs — pack-volume equivalents / collection aliases
    'Comp Velocity':'Velocity', // ~ PD Comp Velocity product, Velocity pack-volume family
    'CF Storm':'Storm',         // ~ PD CF Storm product, Storm pack-volume family
    'Lightning':'Storm',        // ~ large 7-cell/CRW canopy; nearest UPT chart family
    'Zero':'Equinox',           // ~ large accuracy canopy; nearest large-student chart family
    'Peregrine':'Velocity',     // ~ cross-braced, similar pack volume
    'Navigator':'Equinox',      // ~ large student canopy
    // NZ Aerosports / JYRO — direct
    'Safire 3':'Safire3','Crossfire 3':'Crossfire3','JFX 2':'JFX2','Leia':'Leia',
    // NZ Aerosports / JYRO — pack-volume equivalents / collection aliases
    'Safire 4':'Safire3',       // ~ Safire 4 product, Safire-family pack-volume fallback
    'Kraken':'Safire3',         // ~ wingsuit/main canopy, nearest Safire-family chart fallback
    'Kraken ZP':'Safire3',      // ~ ZP Kraken product, nearest Safire-family chart fallback
    'Air Student':'Equinox',    // ~ large student canopy
    'Petra':'JFX2',             // ~ cross-braced, similar pack to JFX2
    'JVX':'JFX2',               // ~ cross-braced, same mfg as JFX2
    'Helium':'Safire3',         // ~ 7-cell, same mfg, similar pack to Safire3
    // Fluid Wings — pack-volume equivalents
    'Prime':'Storm',            // ~ docile 9-cell, similar to Storm
    'Nexus':'Safire3',          // ~ 9-cell, similar pack to Safire3
    'Echo':'Crossfire3',        // ~ elliptical 9-cell
    'Gangster':'JFX2',          // ~ HP compact pack
    'Airwolf 2':'Velocity',     // ~ cross-braced, compact
    'HK Terminal':'Velocity',   // ~ cross-braced, ultra compact
    'SAW':'Valkyrie',           // ~ cross-braced, compact
    // Icarus World — direct + equivalents
    'S-Fire':'Xfire','X-Fire':'Xfire','Equinox':'Equinox','Omni':'Omni',
    'GT-R':'Velocity',          // ~ cross-braced
    'Om':'Safire3',             // ~ wingsuit/9-cell, similar pack
    'Sky':'Storm',              // ~ large, docile
    'Sophia':'Velocity',        // ~ very small cross-braced
    // Aerodyne — direct + equivalents
    'Pilot':'Pilot','Pilot 7':'Pilot','Triathlon':'Triathlon','Mamba':'Mamba',
    'Karma':'Crossfire3',       // ~ 9-cell elliptical
    'Zulu':'Crossfire3',        // ~ 9-cell elliptical
    'Diablo':'Crossfire3',      // ~ 9-cell elliptical
    // Squirrel — direct
    'Epicene Pro 2':'Epicene Pro','Omicron':'Omicron',
    // Reserves — direct
    'PD Reserve':'PD','PD Optimum':'Optimum',
    'Smart':'Smart','Smart LPV':'Smart LPV',
    'Nano':'Nano','Reserve':'Icarus Reserve',
    'Mars WP':'Smart',          // ~ similar reserve pack volume
    'Speed 2000':'Speed'        // Paratec Speed 2000 → "Speed" in UPT chart
  };

  /* Canopies using approximate pack-volume mapping (not directly in UPT chart) */
  var CSV_APPROX = {
    'Peregrine':1,'Navigator':1,'Comp Velocity':1,'CF Storm':1,'Lightning':1,'Zero':1,
    'Safire 4':1,'Kraken':1,'Kraken ZP':1,'Air Student':1,'Petra':1,'JVX':1,'Helium':1,
    'Prime':1,'Nexus':1,'Echo':1,'Gangster':1,'Airwolf 2':1,
    'HK Terminal':1,'SAW':1,'GT-R':1,'Om':1,'Sky':1,'Sophia':1,
    'Karma':1,'Zulu':1,'Diablo':1,'Mars WP':1,'Speed 2000':1
  };

  /* ---- CANOPY SIZE DATABASE (mirrors wingload-calculator-2) ---- */
  var CANOPY_SIZES = {
    // Performance Designs
    'Sabre 3':      [89, 97, 107, 120, 135, 150, 170, 190, 210, 230],
    'Sabre 2':      [97, 107, 120, 135, 150, 170, 190, 210, 230, 260],
    'Pulse':        [107, 120, 135, 150, 170, 190, 210, 230, 260],
    'Storm':        [97, 107, 120, 135, 150, 170, 190, 210, 230],
    'CF Storm':     [97, 107, 120, 135, 150, 170, 190, 210, 230],
    'Spectre':      [97, 107, 120, 135, 150, 170, 190, 210, 230],
    'Horizon':      [120, 135, 150, 170, 190],
    'Navigator':    [200, 220, 240, 260, 280, 300],
    'Lightning':    [113, 126, 143, 160, 176, 193, 218],
    'Zero':         [205, 215, 225, 235, 245, 255, 265, 275, 285, 295, 305, 315, 325],
    'Silhouette':   [135, 150, 170, 190, 210, 230, 260],
    'Stiletto':     [89, 97, 107, 120, 135, 150, 170, 190],
    'Katana':       [83, 89, 97, 107, 120, 135, 150, 170],
    'Velocity':     [75, 79, 84, 90, 96, 103, 111, 120],
    'Comp Velocity':[71, 75, 79, 84, 90, 96, 103, 111],
    'Valkyrie':     [67, 71, 75, 79, 84, 90, 96, 103],
    'Peregrine':    [61, 64, 67, 69, 71, 75, 79, 84, 90],
    // Fluid Wings
    'Prime':        [110, 120, 130, 140, 150, 160, 170, 190],
    'Nexus':        [120, 135, 150, 170, 190],
    'Echo':         [97, 107, 120, 135, 150, 170],
    'Gangster':     [79, 84, 90, 96, 107, 120, 135],
    'Airwolf 2':    [67, 71, 75, 79, 84, 90, 96, 103],
    'HK Terminal':  [60, 64, 67, 69, 71, 75, 79, 84],
    'SAW':          [67, 71, 75, 79, 84, 89],
    // NZ Aerosports / JYRO
    'Safire 4':     [119, 129, 139, 149, 159, 169, 189],
    'Safire 3':     [99, 109, 119, 129, 139, 149, 169, 189, 209, 229],
    'Crossfire 3':  [89, 99, 109, 119, 129, 139, 149, 159, 169],
    'JFX 2':        [69, 74, 79, 84, 89, 94, 99, 104, 109, 119],
    'Leia':         [59, 64, 69, 72, 75, 79, 84, 89, 94, 99],
    'Petra':        [55, 59, 64, 69, 72, 75, 79, 84, 89],
    'Kraken':       [119, 129, 139, 149, 159, 169, 179, 189],
    'Kraken ZP':    [119, 129, 139, 149, 159, 169, 179, 189],
    'Helium':       [129, 139, 149, 169, 189, 209, 229],
    'Air Student':  [169, 189, 209, 219, 229, 239, 249, 259, 269, 289, 299],
    'JVX':          [66, 69, 72, 75, 79, 84, 89, 94, 99, 104, 109, 119],
    // Icarus World
    'X-Fire':       [75, 83, 92, 102, 113, 124, 138, 153, 168],
    'GT-R':         [67, 71, 75, 79, 84, 90, 96, 103],
    'S-Fire':       [99, 109, 119, 129, 139, 149, 169, 189, 209, 229],
    'Om':           [99, 109, 119, 129, 139, 149, 169, 189, 209, 229],
    'Omni':         [99, 109, 119, 129, 139, 149, 169, 189, 209, 229, 239, 249, 259],
    'Equinox':      [189, 199, 209, 219, 229, 239, 249, 259, 279, 289, 299],
    'Sky':          [149, 169, 189, 209],
    'Sophia':       [60, 65, 70, 75, 80],
    // Aerodyne
    'Pilot':        [90, 96, 104, 111, 117, 124, 132, 140, 150, 168, 188, 210, 230, 250],
    'Pilot 7':      [117, 127, 137, 147, 167, 187, 207, 227, 247, 277],
    'Karma':        [93, 99, 109, 119, 129, 149],
    'Zulu':         [92, 102, 112, 122, 132, 152, 172],
    'Triathlon':    [99, 120, 135, 150, 160, 175, 190, 210, 220, 240, 260],
    'Mamba':        [90, 96, 104, 111, 117, 124, 132, 140, 150],
    'Diablo':       [88, 99, 110, 120, 135, 150, 170, 190],
    // Squirrel
    'Epicene Pro 2': [116, 130, 150, 170, 190, 210],
    'Omicron':      [125, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230],
    // Reserves
    'PD Reserve':   [99, 106, 113, 126, 143, 160, 176, 193, 218, 235, 253, 281],
    'PD Optimum':   [99, 106, 113, 126, 143, 160, 176, 193, 218, 235, 253],
    'Smart':        [99, 110, 120, 135, 150, 160, 175, 190, 220, 250],
    'Smart LPV':    [99, 110, 120, 135, 150, 160, 175, 190, 220, 250],
    'Nano':         [99, 106, 113, 126, 143, 160, 176, 193, 218, 235, 253],
    'Reserve':      [99, 109, 119, 129, 139, 149, 169, 189, 219, 239, 259, 279],
    'Mars WP':      [100, 120, 143, 160, 180, 200],
    'Speed 2000':   [120, 135, 150, 160, 175, 190, 210]
  };

  /* ---- PERFORMANCE TIERS (matching wingload-calculator-2) ---- */
  var TIERS = {
    F: { name: 'F-Tier', limit: 1.0, desc: 'Student & Accuracy. Large 7/9-cells. Focus on safety and forgiveness.' },
    E: { name: 'E-Tier', limit: 1.3, desc: '7-Cell / Wingsuit / Tracking. Docile openings, soft on-heading reliability.' },
    D: { name: 'D-Tier', limit: 1.5, desc: 'Intermediate/Sport 9-Cell. Great glide, flare, and daily fun.' },
    C: { name: 'C-Tier', limit: 1.8, desc: 'Advanced Elliptical. Faster turns, longer recovery arc.' },
    B: { name: 'B-Tier', limit: 2.2, desc: 'Cross-Braced Entry. High-performance swooping introduction.' },
    A: { name: 'A-Tier', limit: 2.6, desc: 'Hyper Performance. Highly elliptical, advanced sail materials.' },
    S: { name: 'S-Tier', limit: 3.5, desc: 'Competition Class. Pure speed, expert use only.' }
  };
  var CANOPY_TIER = {
    'Navigator':'F','Equinox':'F','Air Student':'F','Zero':'F','Prime':'F','Karma':'F',
    'Spectre':'E','Storm':'E','CF Storm':'E','Horizon':'E','Om':'E','Kraken':'E','Kraken ZP':'E','Lightning':'E','Pilot 7':'E',
    'Triathlon':'E','Echo':'E','Helium':'E','Epicene Pro 2':'E','Omicron':'E',
    'Sabre 2':'D','Sabre 3':'D','Pulse':'D','Safire 4':'D','Safire 3':'D','S-Fire':'D','Omni':'D',
    'Pilot':'D','Silhouette':'D','Nexus':'D','Sky':'D',
    'Katana':'C','Crossfire 3':'C','Gangster':'C','Zulu':'C','Mamba':'C',
    'Diablo':'C','X-Fire':'C','Stiletto':'C',
    'Velocity':'B','Comp Velocity':'B','JFX 2':'B','GT-R':'B','Airwolf 2':'B',
    'Valkyrie':'A','Leia':'A','JVX':'A','SAW':'A',
    'Petra':'S','Peregrine':'S','HK Terminal':'S','Sophia':'S'
  };

  /* ---- SHORT MANUFACTURER NAMES ---- */
  var SHORT_MFG = {
    'Performance Designs': 'PD',
    'Fluid Wings': 'Fluid',
    'NZ Aerosports / JYRO': 'JYRO',
    'Icarus World': 'Icarus',
    'Aerodyne': 'Aerodyne',
    'Squirrel': 'Squirrel',
    'Icarus': 'Icarus',
    'Paratec': 'Paratec',
    'Mars': 'Mars'
  };

  var AAD_OPTIONS = [
    { id: 'cypres-2',       name: 'CYPRES 2' },
    { id: 'vigil-cuatro',   name: 'Vigil Cuatro' },
    { id: 'mars-m2-multi',  name: 'Mars m2 multi' }
  ];

  /* ---- EMBROIDERY LOCATIONS ---- */
  var EMBROIDERY_LOCATIONS = [
    { id: 'riser-covers',   label: 'Riser Covers' },
    { id: 'ring-cover-left',  label: 'Ring Cover (Left)' },
    { id: 'ring-cover-right', label: 'Ring Cover (Right)' },
    { id: 'side-wall-left',   label: 'Side Wall (Left)' },
    { id: 'side-wall-right',  label: 'Side Wall (Right)' },
    { id: 'center-flap',    label: 'Center Flap' },
    { id: 'leg-pads',       label: 'Leg Pads' },
    { id: 'backpad',        label: 'Backpad' }
  ];

  /* ---- BASE RIG PRICE (EUR, VAT-inclusive reference) ---- */
  var BASE_PRICE = 4090;

  /* ---- SURCHARGES (EUR, VAT-inclusive reference prices) ---- */
  var SURCHARGES = {
    'vgh': 280,
    'rolled-edge': 34,
    '3d-spacer': 210,
    'babylon': 210,
    'skyhook': 330,
    'rsl': 150,
    'black-hardware': 90,
    'padded-stabilizers': 70,
    'soft-stabilizers': 70,
    'reserve-soft-handle': 75,
    'louie-loops': 50,
    'low-drag-louie': 90,
    'hook-knife': 60,
    'jc-stitching': 186,
    'contrast-stitching': 85,
    'center-flap-piping': 116,
    'leg-pad-covers': 128,
    'ws-dynamic-corners': 180,
    'ws-bridle': 0,
    'ws-semi-stowless': 100,
    'pattern': 280,
    'freefly-handle': 59,
    'dual-tuck-tab': 69,
    'hackey': 59,
    'monkey-fist': 84,
    'u-stow': 100,
    'v-stow': 100
  };

  /* ---- SHOPIFY MARKETS PRICING ---- */
  var VAT_RATE = 0.21;
  var EU_COUNTRY_CODES = {
    AT: true, BE: true, BG: true, HR: true, CY: true, CZ: true, DE: true,
    DK: true, EE: true, ES: true, FI: true, FR: true, GR: true, HU: true,
    IE: true, IT: true, LT: true, LU: true, LV: true, MT: true, NL: true,
    PL: true, PT: true, RO: true, SE: true, SI: true, SK: true
  };

  function getPricingContext() {
    var injected = window.vcPricing || {};
    var shopifyCurrency = window.Shopify && window.Shopify.currency ? window.Shopify.currency : {};
    var countryCode = String(injected.countryCode || (window.Shopify && window.Shopify.country) || 'ES').toUpperCase();
    var currencyCode = String(injected.currencyCode || shopifyCurrency.active || 'EUR').toUpperCase();
    var rate = Number(shopifyCurrency.rate);
    if (!isFinite(rate) || rate <= 0) rate = currencyCode === 'EUR' ? 1 : 0;
    return {
      countryCode: countryCode,
      currencyCode: currencyCode,
      locale: injected.locale || document.documentElement.lang || (typeof navigator !== 'undefined' ? navigator.language : '') || 'en',
      rate: rate,
      includesVat: !!EU_COUNTRY_CODES[countryCode],
      basePrice: Number(injected.basePrice),
      basePriceFormatted: injected.basePriceFormatted || ''
    };
  }

  function localizeContainerPrice(eurVatInclusiveAmount) {
    var amount = Number(eurVatInclusiveAmount) || 0;
    var pricing = getPricingContext();
    // The Vector base and container options share one canonical rule: EUR gross
    // price, less 21% VAT outside the EU, converted with Shopify's active FX.
    // Product-specific fixed market prices are intentionally not used here.
    var taxableAmount = pricing.includesVat ? amount : amount / (1 + VAT_RATE);
    if (pricing.rate > 0) return taxableAmount * pricing.rate;
    return NaN;
  }

  function getLocalizedBasePrice() {
    return localizeContainerPrice(BASE_PRICE);
  }

  function formatMoney(amount) {
    var pricing = getPricingContext();
    var value = Number(amount);
    if (!isFinite(value)) return 'Price unavailable';
    try {
      return new Intl.NumberFormat(pricing.locale, {
        style: 'currency',
        currency: pricing.currencyCode
      }).format(value);
    } catch (e) {
      return pricing.currencyCode + ' ' + value.toFixed(2);
    }
  }

  function formatContainerPrice(eurVatInclusiveAmount) {
    return formatMoney(localizeContainerPrice(eurVatInclusiveAmount));
  }

  function localizeStaticOptionPrices() {
    var nodes = document.querySelectorAll('#vc-container .vc-option-card-price:not(.included)');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var original = node.dataset.eurPriceText || node.textContent.trim();
      if (!node.dataset.eurPriceText) node.dataset.eurPriceText = original;
      var match = original.match(/^\+\s*€\s*([0-9]+(?:[.,][0-9]+)?)(.*)$/);
      if (!match) continue;
      var eurAmount = Number(match[1].replace(',', '.'));
      node.textContent = '+' + formatContainerPrice(eurAmount) + match[2];
    }
  }

  /* ---- CONTACT PERSISTENCE ---- */
  var CONTACT_KEY = 'vc-user-contact';

  function generateUUID() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  /* ---- BACKEND API HELPER ---- */
  function getBackendUrl() {
    var el = document.getElementById('vc-container');
    return el ? (el.dataset.backendUrl || '') : '';
  }

  function apiPost(endpoint, data) {
    var base = getBackendUrl();
    if (!base) return; // No backend configured — silently skip
    try {
      var payload = JSON.stringify(Object.assign({
        sessionId: state.sessionId || '',
        email: state.userEmail || '',
        phone: state.userPhone || '',
        timestamp: new Date().toISOString()
      }, data));
      if (navigator.sendBeacon) {
        navigator.sendBeacon(base + endpoint, new Blob([payload], { type: 'application/json' }));
      } else {
        fetch(base + endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true }).catch(function() {});
      }
    } catch (e) { /* silent */ }
  }

  /* ---- ANALYTICS ---- */
  /* Expose trackEvent globally so vc-color-popup.js can fire analytics */
  window.vcTrackEvent = trackEvent;
  function trackEvent(eventName, params) {
    params = params || {};
    params.session_id = state.sessionId || '';
    params.stage_number = state.currentStage;
    params.timestamp = new Date().toISOString();

    // GA4
    if (window.gtag) {
      try { gtag('event', eventName, params); } catch (e) { /* silent */ }
    }

    // Meta Pixel
    if (window.fbq) {
      try { fbq('trackCustom', eventName, params); } catch (e) { /* silent */ }
    }

    // Backend analytics
    apiPost('/api/analytics/event', { event: eventName, params: params });
  }

  /* ---- STATE ---- */
  var state = {
    currentStage: 2,
    maxVisited: 2,

    // Contact capture (summary stage)
    userEmail: '',
    userPhone: '',           // E.164 format, e.g. "+34644271547"
    userCountryCode: '+34',
    whatsappOptIn: false,
    sessionId: '',
    contactCaptured: false,
    cartItemKey: '',         // Shopify cart line item key (set on initial add)

    // Stage 1
    height: '',
    weight: '',
    jumpCount: '',
    canopyCourses: 0,
    dzAltitude: 0,
    dzAltUnit: 'm',
    chest: '',
    waist: '',
    torso: '',
    legPad: '',
    inseam: '',
    sex: 'Male',
    previousSerialNumber: '',
    specialInstructions: '',

    // Stage 2
    pattern: 'standard',
    zoneColors: ['black'],
    containerColorMap: {},
    bindingColor: 'black',
    webbingColor: 'black',
    contrastStitch: false,
    stitchColor: 'em-black',

    // Saved Designs (max 3)
    savedDesigns: [],      // Array of { pattern, colorMap, bindingColor, name, timestamp }
    selectedDesignIndex: -1, // -1 = none selected, 0-2 = selected slot
    colorDesignerSaved: false, // True once user has saved at least one design via the Color Designer popup

    // Stage 3
    harnessType: 'standard',
    legPadConfig: 'one-piece',
    rolledEdge: false,
    minus2: false,
    legPadCovers: false,
    backpad: 'standard-deluxe',
    stabilizers: 'standard',

    // Stage 4
    mainHandle: 'plastic-handle',
    pcHandleColor1: '',
    pcHandleColor2: '',
    mainDBag: 'standard',
    pilotChuteFabric: 'f111',
    pilotChuteSize: 'standard',
    reserveHandle: 'metal-d',
    emergencySystem: 'rsl',
    riserType: 'standard',
    ringType: 'type-17',
    riserCovers: 'magnetic',
    riserLength: '21',
    toggleType: 'tru-lok',
    hookKnife: 'yes',

    // Stage 5
    mainCanopyBrand: '',
    mainCanopyModel: '',
    mainCanopySize: '',
    reserveCanopyBrand: '',
    reserveCanopyModel: '',
    reserveCanopySize: '',
    includeMainCanopy: false,
    includeReserveCanopy: false,
    aad: '',
    exitWeight: '',
    containerSize: '',
    containerFit: '',
    containerManual: false,

    // Stage 6
    isWingsuit: false,
    wsDynamicCorners: false,
    wsBridle: false,
    wsSemiStowless: false,
    wsDash1Shape: false,

    // Stage 7
    hardwareFinish: 'standard',
    jcStitching: false,
    jcColor: 'em-black',
    centerFlapPiping: false,
    embroidery: EMBROIDERY_LOCATIONS.map(function (loc) {
      return { id: loc.id, label: loc.label, enabled: false, text: '' };
    })
  };

  /* ---- DOM CACHE ---- */
  var dom = {};

  /* ---- HELPERS ---- */
  function $(id) { return document.getElementById(id); }

  function colorName(id) {
    var c = ALL_COLORS.find(function (x) { return x.id === id; });
    if (c) return c.name;
    var t = TRIM_TAPE_COLORS.find(function (x) { return x.id === id; });
    if (t) return t.name;
    var w = WEBBING_COLORS.find(function (x) { return x.id === id; });
    return w ? w.name : id;
  }

  function colorHex(id) {
    var c = ALL_COLORS.find(function (x) { return x.id === id; });
    return c ? c.hex : '#1a1a1a';
  }

  function capitalize(s) {
    if (!s) return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  function escHtml(s) {
    if (!s) return '';
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function getPreviousVectorSerial() {
    return String(state.previousSerialNumber || '').trim();
  }

  function hasPreviousVectorSerial() {
    return getPreviousVectorSerial().length > 0;
  }

  function syncMeasurementMode() {
    var usePreviousVector = hasPreviousVectorSerial();
    var manualMeasurements = $('vc-manual-measurements');
    var serialStatus = $('vc-previousSerial-status');
    if (manualMeasurements) manualMeasurements.style.display = usePreviousVector ? 'none' : '';
    if (serialStatus) serialStatus.style.display = usePreviousVector ? '' : 'none';
  }

  function labelFromId(id) {
    return id.split('-').map(capitalize).join(' ');
  }

  /* ================================================================
     NAVIGATION
     ================================================================ */
  function goToStage(n) {
    var prevStageNum = state.currentStage;
    var stages = document.querySelectorAll('.vc-stage');
    for (var i = 0; i < stages.length; i++) stages[i].style.display = 'none';

    var targetId = n === 8 ? 'vc-stage-summary' : 'vc-stage-' + n;
    var target = $(targetId);
    if (target) target.style.display = '';

    state.currentStage = n;
    var nIdx = STAGE_ORDER.indexOf(n);
    var mvIdx = STAGE_ORDER.indexOf(state.maxVisited);
    if (nIdx > mvIdx) state.maxVisited = n;

    // Analytics: track stage transitions
    if (n !== prevStageNum) {
      trackEvent('vc_stage_start', { stage_name: targetId, from_stage: prevStageNum });
      if (n === 8) {
        trackEvent('vc_summary_view', { num_saved_designs: (state.savedDesigns || []).length });
        apiPost('/api/funnel/summary-reached', { designSummary: buildSummaryText() });
      }
    }

    // Hide expert banner on summary (8)
    var expertBanner = dom.container.querySelector('.vc-expert-banner');
    if (expertBanner) expertBanner.style.display = (n === 8) ? 'none' : '';

    // Show landing intro only on the first stage (Stage 2)
    var landingIntro = dom.container.querySelector('.vc-landing-intro');
    if (landingIntro) landingIntro.style.display = (n === STAGE_ORDER[0]) ? '' : 'none';

    updateProgressBar();
    updateNavButtons();
    clearErrors();
    saveState();

    if (n === 8) renderSummary();

    dom.container.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (target) {
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }
  }

  function nextStage() {
    var result = validateStage(state.currentStage);
    if (!result.valid) { showErrors(result.errors); return; }
    trackEvent('vc_stage_complete', { stage_name: 'vc-stage-' + state.currentStage });
    apiPost('/api/funnel/stage-progress', { stage: state.currentStage, stageData: {} });
    updateCartProperties(); // Sync current selections to cart item
    clearErrors();
    var idx = STAGE_ORDER.indexOf(state.currentStage);
    var next = (idx >= 0 && idx < STAGE_ORDER.length - 1) ? STAGE_ORDER[idx + 1] : 8;
    goToStage(next);
  }

  function prevStage() {
    clearErrors();
    var idx = STAGE_ORDER.indexOf(state.currentStage);
    var prev = (idx > 0) ? STAGE_ORDER[idx - 1] : STAGE_ORDER[0];
    goToStage(prev);
  }

  function updateProgressBar() {
    var steps = dom.progressList.querySelectorAll('.vc-progress-step');
    var curIdx = STAGE_ORDER.indexOf(state.currentStage);
    for (var i = 0; i < steps.length; i++) {
      var stepNum = parseInt(steps[i].dataset.step, 10);
      // Hide Stage 7 (cosmetic options moved to Color Designer)
      if (stepNum === 7) { steps[i].style.display = 'none'; continue; }
      // Hide Stage 8 (summary) from progress dots — shown separately
      if (stepNum === 8) continue;
      var stepIdx = STAGE_ORDER.indexOf(stepNum);
      steps[i].classList.remove('active', 'completed', 'clickable');
      if (stepNum === state.currentStage) {
        steps[i].classList.add('active');
      } else if (stepIdx >= 0 && stepIdx < curIdx) {
        steps[i].classList.add('completed');
      }
      // Allow clicking visited stages
      var maxIdx = STAGE_ORDER.indexOf(state.maxVisited);
      if (stepIdx >= 0 && stepIdx <= maxIdx) {
        steps[i].classList.add('clickable');
        steps[i].setAttribute('tabindex', '0');
      } else {
        steps[i].removeAttribute('tabindex');
      }
    }
    // Update progress arrows
    if (dom.progressPrev) {
      dom.progressPrev.disabled = (curIdx <= 0);
    }
    if (dom.progressNext) {
      dom.progressNext.disabled = (curIdx < 0 || curIdx >= STAGE_ORDER.length - 1);
    }
  }

  function updateNavButtons() {
    dom.prevBtn.style.display = '';
    var isFirst = (state.currentStage === STAGE_ORDER[0]);
    dom.prevBtn.disabled = isFirst;
    dom.prevBtn.style.visibility = isFirst ? 'hidden' : 'visible';

    var isLast = (STAGE_ORDER.indexOf(state.currentStage) === STAGE_ORDER.length - 1);
    if (state.currentStage === 8) {
      dom.nextBtn.style.display = 'none';
    } else if (state.currentStage === 6) {
      dom.nextBtn.textContent = 'View Summary';
      dom.nextBtn.style.display = '';
    } else {
      dom.nextBtn.textContent = 'Next';
      dom.nextBtn.style.display = '';
    }
  }

  /* ================================================================
     VALIDATION
     ================================================================ */
  function validateStage(n) {
    var errors = [];
    switch (n) {
      case 1:
        if (hasPreviousVectorSerial()) break;
        if (!state.jumpCount && state.jumpCount !== 0) errors.push('Enter your total number of jumps');
        if (!state.height || state.height < 140 || state.height > 220) errors.push('Enter a valid height (140\u2013220 cm)');
        if (!state.weight || state.weight < 40 || state.weight > 180) errors.push('Enter a valid weight (40\u2013180 kg)');
        if (!state.chest) errors.push('Enter your chest measurement');
        if (!state.waist) errors.push('Enter your waist measurement');
        if (!state.torso) errors.push('Enter your torso (ASIS-to-Throat) measurement');
        if (!state.legPad) errors.push('Enter your leg pad measurement');
        if (!state.inseam) errors.push('Enter your inseam measurement');
        break;
      case 2:
        if (!state.pattern) errors.push('Select a container pattern');
        if (!state.colorDesignerSaved) errors.push('Open the Color Designer and save at least one design before continuing');
        break;
      case 4:
        if (!state.harnessType) errors.push('Select a harness type');
        break;
      case 5:
        if (!state.mainHandle) errors.push('Select a main deployment handle');
        break;
      case 6:
        if (state.includeMainCanopy && !state.mainCanopyModel) errors.push('Select a main canopy model');
        if (state.includeReserveCanopy && !state.reserveCanopyModel) errors.push('Select a reserve canopy model');
        if (!state.containerSize) errors.push('A container size is required \u2014 select canopies for auto-recommendation, or choose manually below.');
        break;
    }
    return { valid: errors.length === 0, errors: errors };
  }

  function showErrors(errors) {
    var el = dom.errors;
    var ul = el.querySelector('ul');
    if (!ul) { ul = document.createElement('ul'); el.appendChild(ul); }
    ul.innerHTML = '';
    errors.forEach(function (msg) {
      var li = document.createElement('li');
      li.textContent = msg;
      ul.appendChild(li);
    });
    el.style.display = '';
    el.classList.add('visible');
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearErrors() {
    dom.errors.classList.remove('visible');
  }

  /* ================================================================
     STAGE 2: PATTERN CARDS + SVG RENDERING
     ================================================================ */
  function renderPatternCards() {
    var grid = dom.patternGrid;
    grid.innerHTML = '';
    var keys = Object.keys(PATTERNS);
    keys.forEach(function (key) {
      var p = PATTERNS[key];
      var card = document.createElement('div');
      card.className = 'vc-pattern-card' + (state.pattern === key ? ' selected' : '');
      card.dataset.pattern = key;
      card.setAttribute('role', 'radio');
      card.setAttribute('aria-checked', state.pattern === key ? 'true' : 'false');
      card.setAttribute('aria-label', p.name);
      card.setAttribute('tabindex', '0');
      if (key === 'full-custom') card.classList.add('vc-pattern-card--custom');
      var imgSrc = PATTERN_IMAGES[key];
      var freePatterns = ['standard', 'v-split', 'tri-v-split', 'full-custom'];
      var priceBadge = key === 'full-custom' ? '<span class="vc-pattern-price vc-pattern-price--included">Included</span>' : (freePatterns.indexOf(key) === -1 ? '<span class="vc-pattern-price">+' + formatContainerPrice(SURCHARGES.pattern) + '</span>' : '');
      card.innerHTML = (imgSrc
        ? '<img class="vc-pattern-card-img" src="' + imgSrc + '" alt="' + p.name + ' pattern" loading="lazy">'
        : generatePatternSVG(key, defaultZoneColors(key), 100, 65, false)) +
        '<span class="vc-pattern-card-name">' + p.name + priceBadge + '</span>' +
        '<span class="vc-pattern-card-desc">' + p.desc + '</span>';
      grid.appendChild(card);
    });
  }

  function defaultZoneColors(patternKey) {
    var count = PATTERNS[patternKey].zones.length;
    var defaults = ['black', 'red', 'royal-blue'];
    var arr = [];
    for (var i = 0; i < count; i++) arr.push(defaults[i] || 'black');
    return arr;
  }

  function selectPattern(key) {
    if (!PATTERNS[key]) return;
    state.pattern = key;

    // Sync pattern to selected design and clear stale previews
    var selDesign = state.savedDesigns && state.savedDesigns[state.selectedDesignIndex];
    if (selDesign && selDesign.pattern !== key) {
      selDesign.pattern = key;
      delete selDesign.previewPng;
      delete selDesign.previewPngs;
    }

    // Prune containerColorMap of zone keys that don't belong to the new pattern.
    // Otherwise split-only zones (c1d, c2b, c4b, c7d, c9a-c) keep their old colors
    // after switching to a simpler pattern and leak into the PDF / order form.
    if (state.containerColorMap) {
      var patternIds = {};
      PATTERN_ZONE_MAP[key].forEach(function (g) {
        g.ids.forEach(function (id) { patternIds[id] = true; });
      });
      Object.keys(state.containerColorMap).forEach(function (mapKey) {
        // Only prune bare zone ids (e.g. "c1a"); keep namespaced keys ("trim:…", "piping:…", "harness:…").
        if (mapKey.indexOf(':') !== -1) return;
        if (!patternIds[mapKey]) delete state.containerColorMap[mapKey];
      });
    }

    var newCount = PATTERNS[key].zones.length;

    // Adjust zoneColors array length — use distinct defaults for multi-zone patterns
    var GROUP_DEFAULTS = ['black', 'red', 'royal-blue', 'gold'];
    while (state.zoneColors.length < newCount) {
      var gi = state.zoneColors.length;
      state.zoneColors.push((key !== 'full-custom' && newCount > 1) ? (GROUP_DEFAULTS[gi] || 'black') : 'black');
    }
    if (state.zoneColors.length > newCount) state.zoneColors = state.zoneColors.slice(0, newCount);

    // Update pattern cards immediately
    var cards = dom.patternGrid.querySelectorAll('.vc-pattern-card');
    for (var i = 0; i < cards.length; i++) {
      var isSelected = cards[i].dataset.pattern === key;
      cards[i].classList.toggle('selected', isSelected);
      cards[i].setAttribute('aria-checked', isSelected ? 'true' : 'false');
    }

    // Show loading spinner, then do heavy rendering after repaint
    var spinner = $('vc-pattern-loading');
    if (spinner) spinner.style.display = 'flex';
    setTimeout(function () {
      renderColorPreview();
      saveState();
      if (spinner) spinner.style.display = 'none';
    }, 30);
  }

  function renderZonePickers() {
    var container = dom.zonePickers || $('vc-zone-pickers');
    if (!container) return;
    container.innerHTML = '';
    var pat = PATTERNS[state.pattern];
    pat.zones.forEach(function (zoneName, idx) {
      var section = document.createElement('div');
      section.className = 'vc-swatch-section';

      var labelRow = document.createElement('div');
      labelRow.className = 'vc-swatch-section-label';
      labelRow.textContent = zoneName + ' Color ';
      var badge = document.createElement('span');
      badge.className = 'vc-selected-color-badge';
      badge.id = 'vc-zone-badge-' + idx;
      badge.textContent = colorName(state.zoneColors[idx]);
      labelRow.appendChild(badge);
      section.appendChild(labelRow);

      var picker = document.createElement('div');
      picker.className = 'vc-swatch-picker';
      picker.dataset.target = 'zoneColors';
      picker.dataset.zoneIndex = idx;
      picker.setAttribute('role', 'radiogroup');
      picker.setAttribute('aria-label', zoneName + ' color');
      renderSwatches(picker, state.zoneColors[idx], true);
      section.appendChild(picker);

      container.appendChild(section);
    });
  }

  function renderSwatches(containerEl, selectedId, useImages) {
    containerEl.innerHTML = '';
    var fn = useImages ? createZoneSwatch : createSwatch;

    COLORS.forEach(function (c) {
      containerEl.appendChild(fn(c, selectedId));
    });

    // specialty divider
    var divider = document.createElement('div');
    divider.className = 'vc-swatch-divider';
    divider.textContent = 'Specialty / Camo';
    containerEl.appendChild(divider);

    SPECIALTY_COLORS.forEach(function (c) {
      containerEl.appendChild(createSwatch(c, selectedId));
    });
  }

  function createSwatch(color, selectedId) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vc-swatch';
    if (color.light) btn.classList.add('vc-swatch-light');
    if (color.id === selectedId) btn.classList.add('vc-swatch-selected');
    btn.style.backgroundColor = color.hex;
    btn.title = color.name;
    btn.dataset.colorId = color.id;
    btn.setAttribute('role', 'radio');
    btn.setAttribute('aria-label', color.name);
    btn.setAttribute('aria-checked', color.id === selectedId ? 'true' : 'false');
    return btn;
  }

  function createZoneSwatch(color, selectedId) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vc-swatch vc-swatch-photo';
    if (color.id === selectedId) btn.classList.add('vc-swatch-selected');
    btn.title = color.name;
    btn.dataset.colorId = color.id;
    btn.setAttribute('role', 'radio');
    btn.setAttribute('aria-label', color.name);
    btn.setAttribute('aria-checked', color.id === selectedId ? 'true' : 'false');
    if (color.img) {
      btn.innerHTML = '<img src="' + color.img + '" alt="' + color.name + '" loading="lazy">' +
        '<span class="vc-swatch-photo-label">' + color.name + '</span>';
    } else {
      // No image available — show hex color block + label in same card layout
      btn.innerHTML = '<span class="vc-swatch-photo-hex" style="background:' + color.hex + ';"></span>' +
        '<span class="vc-swatch-photo-label">' + color.name + '</span>';
    }
    return btn;
  }

  function createImageSwatch(color, selectedId) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vc-swatch vc-swatch-photo';
    if (color.id === selectedId) btn.classList.add('vc-swatch-selected');
    btn.title = color.name;
    btn.dataset.colorId = color.id;
    btn.setAttribute('role', 'radio');
    btn.setAttribute('aria-label', color.name);
    btn.setAttribute('aria-checked', color.id === selectedId ? 'true' : 'false');
    btn.innerHTML = '<img src="' + color.img + '" alt="' + color.name + '" loading="lazy">' +
      '<span class="vc-swatch-photo-label">' + color.name + '</span>';
    return btn;
  }

  function renderImageSwatches(containerEl, colors, selectedId) {
    containerEl.innerHTML = '';
    colors.forEach(function (c) {
      containerEl.appendChild(createImageSwatch(c, selectedId));
    });
  }

  function handleSwatchClick(e) {
    var swatch = e.target.closest('.vc-swatch');
    if (!swatch) return;
    var picker = swatch.closest('.vc-swatch-picker');
    if (!picker) return;

    var colorId = swatch.dataset.colorId;
    var target = picker.dataset.target;
    var zoneIdx = picker.dataset.zoneIndex;

    if (target === 'zoneColors' && zoneIdx !== undefined) {
      state.zoneColors[parseInt(zoneIdx, 10)] = colorId;
      var badge = $('vc-zone-badge-' + zoneIdx);
      if (badge) badge.textContent = colorName(colorId);
    } else if (target === 'bindingColor') {
      state.bindingColor = colorId;
      var bl = $('vc-binding-badge');
      if (bl) bl.textContent = colorName(colorId);
    } else if (target === 'webbingColor') {
      state.webbingColor = colorId;
      var wl = $('vc-webbing-badge');
      if (wl) wl.textContent = colorName(colorId);
    } else if (target === 'stitchColor') {
      state.stitchColor = colorId;
      var sl = $('vc-stitch-badge');
      if (sl) sl.textContent = colorName(colorId);
    }

    // Update swatch selection within this picker
    var allSwatches = picker.querySelectorAll('.vc-swatch');
    for (var i = 0; i < allSwatches.length; i++) {
      var isSel = allSwatches[i].dataset.colorId === colorId;
      allSwatches[i].classList.toggle('vc-swatch-selected', isSel);
      allSwatches[i].setAttribute('aria-checked', isSel ? 'true' : 'false');
    }

    renderColorPreview();
    saveState();
  }

  /* ---- SVG GENERATION: Realistic Vector 3 container silhouette ---- */

  /**
   * Build a realistic Vector 3 container back-panel silhouette.
   * The shape tapers from wider shoulders to a slightly narrower bottom,
   * with structural detail lines (reserve flap, pin covers, grommets).
   *
   * @param {string}   patternKey  — PATTERNS key
   * @param {string[]} colors      — array of color IDs matching the pattern zone count
   * @param {number}   w           — SVG viewport width
   * @param {number}   h           — SVG viewport height
   * @param {boolean}  [detail]    — true = render structural details (main preview only)
   */
  function generatePatternSVG(patternKey, colors, w, h, detail) {
    var hexes = colors.map(colorHex);
    var uid = 'p-' + patternKey + '-' + Math.random().toString(36).substr(2, 4);

    /* ---- Container silhouette geometry ---- */
    var mx = w * 0.1;              // horizontal margin
    var tl = mx;                    // top-left x
    var tr = w - mx;                // top-right x
    var bl = mx + w * 0.02;         // bottom-left x (slightly narrower)
    var br = w - mx - w * 0.02;     // bottom-right x
    var r  = w * 0.04;              // corner radius
    var yokeD = h * 0.04;           // yoke notch depth
    var yokeW = w * 0.18;           // yoke notch width (each side)

    // Container outline path: top with yoke notches, tapered sides, flat bottom
    var outline =
      // Top-left corner
      'M' + (tl + r) + ',0' +
      // Top edge to left yoke notch
      ' L' + (tl + yokeW) + ',0' +
      ' L' + (tl + yokeW + w * 0.02) + ',' + yokeD +
      // Across yoke (harness pass-through)
      ' L' + (tr - yokeW - w * 0.02) + ',' + yokeD +
      ' L' + (tr - yokeW) + ',0' +
      // Top-right corner
      ' L' + (tr - r) + ',0' +
      ' Q' + tr + ',0 ' + tr + ',' + r +
      // Right side — slight inward taper
      ' L' + (tr - (tr - br) * 0.15) + ',' + (h * 0.35) +
      ' L' + br + ',' + (h - r) +
      // Bottom-right corner
      ' Q' + br + ',' + h + ' ' + (br - r) + ',' + h +
      // Bottom edge
      ' L' + (bl + r) + ',' + h +
      // Bottom-left corner
      ' Q' + bl + ',' + h + ' ' + bl + ',' + (h - r) +
      // Left side — slight inward taper
      ' L' + (tl + (bl - tl) * 0.15) + ',' + (h * 0.35) +
      ' L' + tl + ',' + r +
      // Top-left corner
      ' Q' + tl + ',0 ' + (tl + r) + ',0 Z';

    var svg = '<svg viewBox="0 0 ' + w + ' ' + h + '" xmlns="http://www.w3.org/2000/svg">';

    /* ---- Pattern clip masks & filled layers ---- */
    var cx = w / 2;  // center x
    svg += '<defs>';

    switch (patternKey) {
      case 'standard':
        svg += '</defs>';
        svg += '<path d="' + outline + '" fill="' + hexes[0] + '"/>';
        break;

      case 'half-and-half':
        svg += '<clipPath id="' + uid + 'L"><rect x="0" y="0" width="' + cx + '" height="' + h + '"/></clipPath>';
        svg += '<clipPath id="' + uid + 'R"><rect x="' + cx + '" y="0" width="' + cx + '" height="' + h + '"/></clipPath>';
        svg += '</defs>';
        svg += '<path d="' + outline + '" fill="' + hexes[0] + '" clip-path="url(#' + uid + 'L)"/>';
        svg += '<path d="' + outline + '" fill="' + hexes[1] + '" clip-path="url(#' + uid + 'R)"/>';
        break;

      case 'diagonal':
        svg += '<clipPath id="' + uid + 'U"><polygon points="0,0 ' + w + ',0 ' + w + ',' + (h * 0.4) + ' 0,' + (h * 0.6) + '"/></clipPath>';
        svg += '<clipPath id="' + uid + 'D"><polygon points="0,' + (h * 0.6) + ' ' + w + ',' + (h * 0.4) + ' ' + w + ',' + h + ' 0,' + h + '"/></clipPath>';
        svg += '</defs>';
        svg += '<path d="' + outline + '" fill="' + hexes[0] + '" clip-path="url(#' + uid + 'U)"/>';
        svg += '<path d="' + outline + '" fill="' + hexes[1] + '" clip-path="url(#' + uid + 'D)"/>';
        break;

      case 'v-split':
        var vy = h * 0.7;
        svg += '<clipPath id="' + uid + 'V"><polygon points="' + cx + ',0 ' + (cx + w * 0.32) + ',0 ' + cx + ',' + vy + ' ' + (cx - w * 0.32) + ',0"/></clipPath>';
        svg += '</defs>';
        svg += '<path d="' + outline + '" fill="' + hexes[1] + '"/>';
        svg += '<path d="' + outline + '" fill="' + hexes[0] + '" clip-path="url(#' + uid + 'V)"/>';
        break;

      case 'tri-v-split':
        svg += '<clipPath id="' + uid + 'L"><rect x="0" y="0" width="' + (w * 0.33) + '" height="' + h + '"/></clipPath>';
        svg += '<clipPath id="' + uid + 'C"><polygon points="' + cx + ',0 ' + (cx + w * 0.24) + ',0 ' + cx + ',' + (h * 0.72) + ' ' + (cx - w * 0.24) + ',0"/></clipPath>';
        svg += '<clipPath id="' + uid + 'R"><rect x="' + (w * 0.67) + '" y="0" width="' + (w * 0.33) + '" height="' + h + '"/></clipPath>';
        svg += '</defs>';
        svg += '<path d="' + outline + '" fill="' + hexes[0] + '"/>';
        svg += '<path d="' + outline + '" fill="' + hexes[2] + '" clip-path="url(#' + uid + 'R)"/>';
        svg += '<path d="' + outline + '" fill="' + hexes[1] + '" clip-path="url(#' + uid + 'C)"/>';
        svg += '<path d="' + outline + '" fill="' + hexes[0] + '" clip-path="url(#' + uid + 'L)"/>';
        break;

      case 'triple-v-split':
        var s1 = w * 0.36;
        svg += '<clipPath id="' + uid + 'M"><polygon points="' + cx + ',0 ' + (cx + s1) + ',0 ' + cx + ',' + (h * 0.78) + ' ' + (cx - s1) + ',0"/></clipPath>';
        svg += '<clipPath id="' + uid + 'I"><polygon points="' + cx + ',0 ' + (cx + s1 * 0.5) + ',0 ' + cx + ',' + (h * 0.52) + ' ' + (cx - s1 * 0.5) + ',0"/></clipPath>';
        svg += '</defs>';
        svg += '<path d="' + outline + '" fill="' + hexes[2] + '"/>';
        svg += '<path d="' + outline + '" fill="' + hexes[1] + '" clip-path="url(#' + uid + 'M)"/>';
        svg += '<path d="' + outline + '" fill="' + hexes[0] + '" clip-path="url(#' + uid + 'I)"/>';
        break;

      case 'lightning':
        var lp = 'M0,0 L' + (w * 0.55) + ',0 L' + (w * 0.35) + ',' + (h * 0.5) + ' L' + (w * 0.6) + ',' + (h * 0.5) + ' L' + (w * 0.3) + ',' + h + ' L0,' + h + ' Z';
        svg += '<clipPath id="' + uid + 'L"><path d="' + lp + '"/></clipPath>';
        svg += '</defs>';
        svg += '<path d="' + outline + '" fill="' + hexes[1] + '"/>';
        svg += '<path d="' + outline + '" fill="' + hexes[0] + '" clip-path="url(#' + uid + 'L)"/>';
        break;

      case 'triple-lightning':
        var lp1 = 'M0,0 L' + (w * 0.65) + ',0 L' + (w * 0.45) + ',' + (h * 0.5) + ' L' + (w * 0.7) + ',' + (h * 0.5) + ' L' + (w * 0.4) + ',' + h + ' L0,' + h + ' Z';
        var lp2 = 'M0,0 L' + (w * 0.4) + ',0 L' + (w * 0.2) + ',' + (h * 0.5) + ' L' + (w * 0.45) + ',' + (h * 0.5) + ' L' + (w * 0.15) + ',' + h + ' L0,' + h + ' Z';
        svg += '<clipPath id="' + uid + 'A"><path d="' + lp1 + '"/></clipPath>';
        svg += '<clipPath id="' + uid + 'B"><path d="' + lp2 + '"/></clipPath>';
        svg += '</defs>';
        svg += '<path d="' + outline + '" fill="' + hexes[2] + '"/>';
        svg += '<path d="' + outline + '" fill="' + hexes[1] + '" clip-path="url(#' + uid + 'A)"/>';
        svg += '<path d="' + outline + '" fill="' + hexes[0] + '" clip-path="url(#' + uid + 'B)"/>';
        break;

      case 'zigzag':
        var zpts = '0,0 ';
        var segs = 6;
        for (var zi = 0; zi < segs; zi++) {
          var zy = (h / segs) * zi + (h / segs / 2);
          zpts += (zi % 2 === 0 ? (w * 0.62) : (w * 0.38)) + ',' + zy + ' ';
        }
        zpts += '0,' + h;
        svg += '<clipPath id="' + uid + 'Z"><polygon points="' + zpts + '"/></clipPath>';
        svg += '</defs>';
        svg += '<path d="' + outline + '" fill="' + hexes[1] + '"/>';
        svg += '<path d="' + outline + '" fill="' + hexes[0] + '" clip-path="url(#' + uid + 'Z)"/>';
        break;

      default:
        svg += '</defs>';
        svg += '<path d="' + outline + '" fill="' + hexes[0] + '"/>';
    }

    /* ---- Container outline stroke ---- */
    svg += '<path d="' + outline + '" fill="none" stroke="#94a3b8" stroke-width="' + (w > 120 ? 1.5 : 1) + '"/>';

    /* ---- Structural detail lines (only for large preview) ---- */
    if (detail) {
      var dl = 'rgba(0,0,0,0.12)';
      var dlW = 0.8;
      var il = tl + (tr - tl) * 0.12;
      var ir = tr - (tr - tl) * 0.12;

      // Reserve flap horizontal line (approx 35% from top)
      var rfy = h * 0.34;
      svg += '<line x1="' + (tl + 2) + '" y1="' + rfy + '" x2="' + (tr - 2) + '" y2="' + rfy + '" stroke="' + dl + '" stroke-width="' + dlW + '" stroke-dasharray="4,3"/>';

      // Pin cover lines — two vertical lines in center area
      var pcx1 = cx - w * 0.06;
      var pcx2 = cx + w * 0.06;
      svg += '<line x1="' + pcx1 + '" y1="' + (rfy + 4) + '" x2="' + pcx1 + '" y2="' + (h * 0.72) + '" stroke="' + dl + '" stroke-width="' + dlW + '"/>';
      svg += '<line x1="' + pcx2 + '" y1="' + (rfy + 4) + '" x2="' + pcx2 + '" y2="' + (h * 0.72) + '" stroke="' + dl + '" stroke-width="' + dlW + '"/>';

      // Main closing flap lines (bottom section)
      var mfy = h * 0.72;
      svg += '<line x1="' + (bl + 4) + '" y1="' + mfy + '" x2="' + (br - 4) + '" y2="' + mfy + '" stroke="' + dl + '" stroke-width="' + dlW + '" stroke-dasharray="4,3"/>';

      // Grommets: 3 pairs along pin cover lines
      var gr = w * 0.012;
      var gy = [rfy + h * 0.06, rfy + h * 0.15, rfy + h * 0.24];
      for (var gi = 0; gi < gy.length; gi++) {
        svg += '<circle cx="' + pcx1 + '" cy="' + gy[gi] + '" r="' + gr + '" fill="none" stroke="' + dl + '" stroke-width="0.6"/>';
        svg += '<circle cx="' + pcx2 + '" cy="' + gy[gi] + '" r="' + gr + '" fill="none" stroke="' + dl + '" stroke-width="0.6"/>';
      }

      // Reserve ripcord cable path (left side)
      svg += '<path d="M' + (tl + 4) + ',' + (h * 0.12) + ' Q' + (tl - 2) + ',' + (h * 0.2) + ' ' + (tl + 4) + ',' + (h * 0.28) + '" fill="none" stroke="' + dl + '" stroke-width="0.6"/>';

      // "VECTOR" label in reserve area (only if large enough)
      if (w > 160) {
        svg += '<text x="' + cx + '" y="' + (rfy * 0.55) + '" text-anchor="middle" font-family="sans-serif" font-size="' + (w * 0.045) + '" font-weight="800" letter-spacing="2" fill="rgba(0,0,0,0.06)">VECTOR</text>';
      }
    }

    svg += '</svg>';
    return svg;
  }

  /* ================================================================
     STAGE 2: RICH COLOR PREVIEW PANEL
     Shows all zone→color assignments with swatches, names, and codes.
     ================================================================ */
  // View boxes for the 4 rig views (960x400 SVG divided into quadrants)
  var RIG_VIEWS = {
    back:  { label: 'Back',  viewBox: '0 0 240 400' },
    front: { label: 'Front', viewBox: '240 0 240 400' },
    right: { label: 'Right', viewBox: '480 0 240 400' },
    left:  { label: 'Left',  viewBox: '720 0 240 400' }
  };
  var previewActiveView = 'back';
  var rigPreviewCache = {}; // { pattern: svgMarkup }

  /** Open the Container Color Designer popup — reusable, called from comparison box button */
  function openColorDesignerFresh() {
    if (!window.VectorColorPopup) return;
    // Build a default color map — use distinct colors per group for multi-zone patterns
    var freshMap = {};
    var GROUP_DEFAULTS = ['black', 'red', 'royal-blue', 'gold'];
    var allPatZones = PATTERN_ZONE_MAP[state.pattern] || PATTERN_ZONE_MAP['standard'];
    allPatZones.forEach(function (m) {
      var defColor = (allPatZones.length > 1 && state.pattern !== 'full-custom') ? (GROUP_DEFAULTS[m.idx] || 'black') : 'black';
      m.ids.forEach(function (id) { freshMap[id] = defColor; });
    });
    // Assign handle default colors based on which side they physically match
    var handleDef = HANDLE_DEFAULTS[state.pattern] || { hcut: 0, hres: 0 };
    var useGroupColors = (allPatZones.length > 1 && state.pattern !== 'full-custom');
    freshMap['hcut'] = useGroupColors ? (GROUP_DEFAULTS[handleDef.hcut] || 'black') : 'black';
    freshMap['hres'] = useGroupColors ? (GROUP_DEFAULTS[handleDef.hres] || 'black') : 'black';
    var freshDesignName = 'Design ' + (state.savedDesigns.length + 1);
    state.selectedDesignIndex = -1; // Signal: create new design slot
    window.VectorColorPopup.open(
      freshMap,
      function (colorMap, embData, quickOptions, designName, previewPng, previewPngs) {
        state.containerColorMap = colorMap;
        if (embData) state.containerEmbroidery = embData;
        if (previewPng) state.containerDesignPreview = previewPng;
        if (quickOptions) {
          if (typeof quickOptions.contrastStitch === 'boolean') state.contrastStitch = quickOptions.contrastStitch;
          if (quickOptions.stitchColor) state.stitchColor = quickOptions.stitchColor;
          if (typeof quickOptions.jcStitching === 'boolean') state.jcStitching = quickOptions.jcStitching;
          if (quickOptions.jcColor) state.jcColor = quickOptions.jcColor;
          if (typeof quickOptions.pipingEnabled === 'boolean') state.centerFlapPiping = quickOptions.pipingEnabled;
        }
        var hasPiping = false;
        Object.keys(colorMap).forEach(function (k) { if (k.indexOf('piping:') === 0) hasPiping = true; });
        if (hasPiping) state.centerFlapPiping = true;
        state.colorDesignerSaved = true;
        saveState();
        renderColorPreview();
        saveDesignToSlot(designName, previewPng, previewPngs);
      },
      state.pattern || 'standard',
      null, // no embroidery — fresh start
      {
        contrastStitch: false,
        stitchColor: 'em-black',
        jcStitching: false,
        jcColor: 'em-black',
        pipingEnabled: false
      },
      freshDesignName
    );
  }

  function openColorDesignerPopup() {
    if (!window.VectorColorPopup) return;
    var currentDesign = state.savedDesigns[state.selectedDesignIndex];
    var currentDesignName = currentDesign ? currentDesign.name : 'Design 1';
    window.VectorColorPopup.open(
      state.containerColorMap,
      function (colorMap, embData, quickOptions, designName, previewPng, previewPngs) {
        state.containerColorMap = colorMap;
        if (embData) state.containerEmbroidery = embData;
        if (previewPng) state.containerDesignPreview = previewPng;
        if (quickOptions) {
          if (typeof quickOptions.contrastStitch === 'boolean') state.contrastStitch = quickOptions.contrastStitch;
          if (quickOptions.stitchColor) state.stitchColor = quickOptions.stitchColor;
          if (typeof quickOptions.jcStitching === 'boolean') state.jcStitching = quickOptions.jcStitching;
          if (quickOptions.jcColor) state.jcColor = quickOptions.jcColor;
          if (typeof quickOptions.pipingEnabled === 'boolean') state.centerFlapPiping = quickOptions.pipingEnabled;
        }
        var hasPiping = false;
        Object.keys(colorMap).forEach(function(k) { if (k.indexOf('piping:') === 0) hasPiping = true; });
        if (hasPiping) state.centerFlapPiping = true;
        // Update design name on current design
        if (designName && currentDesign) {
          currentDesign.name = designName;
        }
        state.colorDesignerSaved = true;
        saveState();
        renderColorPreview();
        saveDesignToSlot(designName, previewPng, previewPngs);
      },
      state.pattern || 'standard',
      state.containerEmbroidery || null,
      {
        contrastStitch: state.contrastStitch || false,
        stitchColor: state.stitchColor || 'em-black',
        jcStitching: state.jcStitching || false,
        jcColor: state.jcColor || 'em-black',
        pipingEnabled: state.centerFlapPiping || false
      },
      currentDesignName
    );
  }

  /* ---- Step 1 action buttons: Create New Design + AI Designer ---- */
  function renderDesignActions() {
    var container = $('vc-design-actions');
    if (!container) return;
    var used = state.savedDesigns ? state.savedDesigns.length : 0;
    var full = used >= MAX_SAVED_DESIGNS;
    var html = '';
    html += '<button type="button" id="vc-create-new-design" class="vc-action-btn vc-action-new"' + (full ? ' disabled' : '') + '>';
    html += '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
    html += ' Create New Design';
    html += '</button>';
    html += '<button type="button" id="vc-open-ai-popup" class="vc-action-btn vc-action-ai"' + (full ? ' disabled' : '') + '>';
    html += '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/><path d="M20 3v4"/><path d="M22 5h-4"/></svg>';
    html += ' Create with: Custom AI Design Engine';
    html += '</button>';
    if (full) html += '<span class="vc-action-hint">All ' + MAX_SAVED_DESIGNS + ' design slots full \u2014 delete one first</span>';
    html += '<p class="vc-ai-info-text">Describe your dream rig in words and our AI will generate a complete color scheme for you \u2014 pattern, zones, trim, and webbing. Tweak it further by hand or regenerate until it\u2019s perfect.</p>';
    container.innerHTML = html;

    // Wire Create New Design
    var newBtn = document.getElementById('vc-create-new-design');
    if (newBtn && !full) {
      newBtn.addEventListener('click', function () { openColorDesignerFresh(); });
    }
    // Wire AI Designer
    var aiBtn = document.getElementById('vc-open-ai-popup');
    if (aiBtn && !full) {
      aiBtn.addEventListener('click', function () { openAIDesignerPopup(); });
    }
  }

  function renderColorPreview() {
    var panel = $('vc-color-preview-panel');
    if (!panel) return;

    // Hide the separate saved-designs section — we merge it into the comparison box
    var oldSaved = $('vc-saved-designs-section');
    if (oldSaved) oldSaved.style.display = 'none';

    // Refresh the design action buttons (slot count may have changed)
    renderDesignActions();

    var html = '<div class="vc-compare-box">';
    html += '<div class="vc-compare-header">';
    html += '<div class="vc-compare-header-left">';
    html += '<span class="vc-compare-title">Design Comparison</span>';
    html += '<span class="vc-compare-hint">' + (state.savedDesigns.length || 0) + ' / ' + MAX_SAVED_DESIGNS + ' slots</span>';
    html += '</div>';
    html += '<div class="vc-compare-header-btns">';
    html += '</div>';
    html += '</div>';
    html += '<div class="vc-compare-slots" id="vc-compare-slots">';

    // Render saved design slots
    if (state.savedDesigns) {
      state.savedDesigns.forEach(function (design, idx) {
        var isActive = state.selectedDesignIndex === idx;
        var patternName = PATTERN_NAMES[design.pattern] || design.pattern;
        html += '<div class="vc-compare-slot' + (isActive ? ' vc-compare-active' : '') + '" data-slot="' + idx + '">';
        html += '<div class="vc-compare-slot-head">';
        html += '<span class="vc-compare-slot-name">' + escHtml(design.name || '') + '</span>';
        html += '<span class="vc-compare-slot-pattern">' + escHtml(patternName || '') + '</span>';
        html += '<button type="button" class="vc-compare-slot-del" data-del="' + idx + '" title="Delete">&times;</button>';
        html += '</div>';
        html += '<div class="vc-compare-views" id="vc-compare-views-' + idx + '"></div>';
        // Color chips
        var keyColors = getKeyColors(design.colorMap);
        html += '<div class="vc-compare-chips">';
        keyColors.forEach(function (c) {
          html += '<span class="vc-compare-chip"><span class="vc-compare-dot" style="background:' + c.hex + '"></span>' + (c.sc || c.name) + '</span>';
        });
        html += '</div>';
        html += '<button type="button" class="vc-compare-slot-edit" data-edit="' + idx + '">&#9998; Edit Design</button>';
        html += '</div>';
      });
    }

    // Empty slots — clickable to start a fresh design
    var used = state.savedDesigns ? state.savedDesigns.length : 0;
    for (var e = used; e < MAX_SAVED_DESIGNS; e++) {
      html += '<div class="vc-compare-slot vc-compare-empty" data-empty-slot="' + e + '">';
      html += '<div class="vc-compare-empty-inner">';
      html += '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
      html += '<span>Start new design</span>';
      html += '</div>';
      html += '</div>';
    }

    html += '</div>'; // slots
    html += '</div>'; // box
    panel.innerHTML = html;

    // Load SVG views for each slot
    if (state.savedDesigns) {
      state.savedDesigns.forEach(function (design, idx) {
        loadSlotViews(idx, design.pattern, design.colorMap, design.embroidery);
      });
      // Restore VCP to the currently selected slot's embroidery after rendering all slots
      var VCP = window.VectorColorPopup;
      if (VCP && VCP.syncEmbroideryFromV2 && state.containerEmbroidery && state.containerEmbroidery._v2) {
        VCP.syncEmbroideryFromV2(state.containerEmbroidery._v2);
      }
    }

    // Wire up slot clicks
    var slotsEl = $('vc-compare-slots');
    if (slotsEl) {
      slotsEl.addEventListener('click', function (ev) {
        var editBtn = ev.target.closest('.vc-compare-slot-edit');
        if (editBtn) {
          ev.stopPropagation();
          var ei = parseInt(editBtn.dataset.edit, 10);
          selectDesign(ei);
          openColorDesignerPopup();
          return;
        }
        var delBtn = ev.target.closest('.vc-compare-slot-del');
        if (delBtn) {
          ev.stopPropagation();
          var di = parseInt(delBtn.dataset.del, 10);
          if (confirm('Delete this design?')) deleteDesign(di);
          return;
        }
        var slot = ev.target.closest('.vc-compare-slot:not(.vc-compare-empty)');
        if (slot) { selectDesign(parseInt(slot.dataset.slot, 10)); return; }

        // Empty slot — open Color Designer with fresh/default colors
        var emptySlot = ev.target.closest('.vc-compare-empty');
        if (emptySlot) openColorDesignerFresh();
      });
    }
  }

  /**
   * Load 4 view SVGs into a comparison slot
   */
  function loadSlotViews(slotIdx, pattern, colorMap, embroideryData) {
    var viewsEl = document.getElementById('vc-compare-views-' + slotIdx);
    if (!viewsEl) return;

    var urls = window.VCP_RIG_SVG_URLS || {};
    var url = urls[pattern || 'standard'] || window.VCP_RIG_SVG_URL;
    if (!url) return;

    var VCP = window.VectorColorPopup;
    var lookupColor = VCP ? VCP.colorById : function (id) { return findColorObjById(id); };

    function renderViews(svgMarkup) {
      viewsEl.innerHTML = '';
      // Sync VCP to this slot's embroidery before rendering (don't refresh main rig)
      if (VCP && VCP.syncEmbroideryFromV2 && embroideryData && embroideryData._v2) {
        VCP.syncEmbroideryFromV2(embroideryData._v2, false);
      }
      var viewKeys = ['back', 'front', 'right', 'left'];
      viewKeys.forEach(function (key) {
        var card = document.createElement('div');
        card.className = 'vc-compare-view';

        var svgWrap = document.createElement('div');
        svgWrap.className = 'vc-compare-view-svg';
        svgWrap.innerHTML = svgMarkup;

        var svg = svgWrap.querySelector('svg');
        if (svg) {
          svg.removeAttribute('width');
          svg.removeAttribute('height');
          svg.style.width = '100%';
          svg.style.height = 'auto';
          svg.setAttribute('viewBox', RIG_VIEWS[key].viewBox);
          applyColorsToSlotSvg(svg, colorMap, lookupColor, VCP);
        }

        card.appendChild(svgWrap);
        var label = document.createElement('div');
        label.className = 'vc-compare-view-label';
        label.textContent = RIG_VIEWS[key].label;
        card.appendChild(label);
        viewsEl.appendChild(card);
      });
    }

    // Use cache
    if (rigPreviewCache[pattern || 'standard']) {
      renderViews(rigPreviewCache[pattern || 'standard']);
      return;
    }

    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4 || xhr.status !== 200) return;
      rigPreviewCache[pattern || 'standard'] = xhr.responseText;
      renderViews(xhr.responseText);
    };
    xhr.send();
  }

  /**
   * Apply colors, piping, embroidery, and textures to a slot SVG
   */
  function applyColorsToSlotSvg(svg, colorMap, lookupColor, VCP) {
    if (!colorMap) { console.warn('[VC] applyColors: no colorMap'); return; }

    // Build a robust lookup: VCP first, then local ALL_COLORS fallback
    var resolveColor = function (id) {
      // Try VCP (has MASTER_COLORS: cordura + harness + trim + embroidery)
      if (VCP && VCP.colorById) {
        var c = VCP.colorById(id);
        if (c && c.hex) return c;
      }
      // Fallback: search local cordura colors
      for (var i = 0; i < ALL_COLORS.length; i++) {
        if (ALL_COLORS[i].id === id) return ALL_COLORS[i];
      }
      // Last resort: return grey placeholder
      return { name: id, hex: '#888' };
    };

    var applied = 0;
    Object.keys(colorMap).forEach(function (key) {
      var c = resolveColor(colorMap[key]);
      if (!c || !c.hex) return;
      var svgId = key;
      if (key.indexOf('trim:') === 0) svgId = key.substring(5);
      else if (key.indexOf('harness:') === 0) svgId = key.substring(8);
      else if (key.indexOf('piping:') === 0) return;
      var paths = svg.querySelectorAll('[data-zone="' + svgId + '"]');
      for (var i = 0; i < paths.length; i++) { paths[i].setAttribute('fill', c.hex); applied++; }
    });
    console.log('[VC] applyColors: ' + applied + ' zone fills applied (' + Object.keys(colorMap).length + ' colorMap keys, VCP=' + !!VCP + ')');

    // Piping
    var pipingGroup = svg.getElementById('piping');
    if (pipingGroup) {
      var hasPiping = false;
      ['pb','pc','pd','pe','pf','pg'].forEach(function (zoneId) {
        var colorId = colorMap['piping:' + zoneId];
        if (!colorId) return;
        hasPiping = true;
        var color = resolveColor(colorId);
        if (!color || !color.hex) return;
        var l1 = svg.getElementById(zoneId + '1');
        var l2 = svg.getElementById(zoneId + '2');
        var bot = svg.getElementById(zoneId + 'bot');
        if (l1) { l1.setAttribute('stroke', color.hex); l1.setAttribute('stroke-width', '2'); }
        if (l2) { l2.setAttribute('stroke', color.hex); l2.setAttribute('stroke-width', '2'); }
        if (bot) { bot.setAttribute('fill-opacity', '0'); }
      });
      pipingGroup.setAttribute('display', hasPiping ? 'inline' : 'none');
    }

    // Embroidery
    if (VCP && VCP.renderEmbroideryOnSvg) VCP.renderEmbroideryOnSvg(svg);

    // Fabric textures
    if (VCP && VCP.applyFabricTextures) VCP.applyFabricTextures(svg, colorMap);
  }

  function loadPreviewRig() {
    var container = $('vc-preview-rig');
    if (!container) return;

    var VCP = window.VectorColorPopup;
    var lookupColor = VCP ? VCP.colorById : function (id) { return findColorObjById(id); };

    // Fetch the rig SVG
    var urls = window.VCP_RIG_SVG_URLS || {};
    var url = urls[state.pattern || 'standard'] || window.VCP_RIG_SVG_URL;
    if (!url) return;

    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4 || xhr.status !== 200) return;

      container.innerHTML = xhr.responseText;
      var svg = container.querySelector('svg');
      if (!svg) return;

      // Size SVG to fit container
      svg.removeAttribute('width');
      svg.removeAttribute('height');
      svg.style.width = '100%';
      svg.style.height = 'auto';

      // Set initial view
      svg.setAttribute('viewBox', RIG_VIEWS[previewActiveView].viewBox);

      // Apply colors from state.containerColorMap
      var cMap = state.containerColorMap;
      if (!cMap) return;

      Object.keys(cMap).forEach(function(key) {
        var c = lookupColor(cMap[key]);
        if (!c) return;

        // Determine SVG element ID from colorMap key
        var svgId = key;
        if (key.indexOf('trim:') === 0) svgId = key.substring(5);
        else if (key.indexOf('harness:') === 0) svgId = key.substring(8);
        else if (key.indexOf('piping:') === 0) return; // Piping handled separately

        var paths = svg.querySelectorAll('[data-zone="' + svgId + '"]');
        for (var i = 0; i < paths.length; i++) {
          paths[i].setAttribute('fill', c.hex);
        }
      });

      // Apply piping colors
      var pipingGroup = svg.getElementById('piping');
      if (pipingGroup) {
        var hasPiping = false;
        ['pb','pc','pd','pe','pf','pg'].forEach(function(zoneId) {
          var colorId = cMap['piping:' + zoneId];
          if (!colorId) return;
          hasPiping = true;
          var color = lookupColor(colorId);
          if (!color) return;
          var l1 = svg.getElementById(zoneId + '1');
          var l2 = svg.getElementById(zoneId + '2');
          var bot = svg.getElementById(zoneId + 'bot');
          if (l1) { l1.setAttribute('stroke', color.hex); l1.setAttribute('stroke-width', '2'); }
          if (l2) { l2.setAttribute('stroke', color.hex); l2.setAttribute('stroke-width', '2'); }
          if (bot) { bot.setAttribute('fill-opacity', '0'); }
        });
        pipingGroup.setAttribute('display', hasPiping ? 'inline' : 'none');
      }

      // Apply embroidery logos to the preview rig
      if (VCP && VCP.renderEmbroideryOnSvg) {
        VCP.renderEmbroideryOnSvg(svg);
      }

      // Apply fabric textures if toggle is ON
      if (VCP && VCP.applyFabricTextures) {
        VCP.applyFabricTextures(svg, cMap);
      }
    };
    xhr.send();
  }

  function findColorObjById(id) {
    for (var i = 0; i < ALL_COLORS.length; i++) {
      if (ALL_COLORS[i].id === id) return ALL_COLORS[i];
    }
    return { name: id, hex: '#888', sc: '' };
  }

  function renderTrimPickers() {
    var binPicker = $('vc-binding-picker');
    var webPicker = $('vc-webbing-picker');
    var stPicker = $('vc-stitch-picker');
    if (binPicker) { binPicker.dataset.target = 'bindingColor'; renderImageSwatches(binPicker, TRIM_TAPE_COLORS, state.bindingColor); }
    if (webPicker) { webPicker.dataset.target = 'webbingColor'; renderImageSwatches(webPicker, WEBBING_COLORS, state.webbingColor); }
    if (stPicker) { stPicker.dataset.target = 'stitchColor'; renderSwatches(stPicker, state.stitchColor); }
  }

  /* ================================================================
     SAVED DESIGNS — Up to 3 selectable design cards
     ================================================================ */
  var MAX_SAVED_DESIGNS = 3;

  var PATTERN_NAMES = {
    'standard': 'Standard',
    'half-and-half': 'Half & Half',
    'diagonal': 'Diagonal',
    'v-split': 'V-Split',
    'tri-v-split': 'Tri-color V-Split',
    'triple-v-split': 'Triple V-Split',
    'lightning': 'Lightning',
    'triple-lightning': 'Triple Lightning',
    'zigzag': 'Zig-zag',
    'full-custom': 'Full Custom'
  };

  /**
   * Save the current design to a slot (auto-assign to next available or replace oldest)
   */
  function saveDesignToSlot(designName, previewPng, previewPngs) {
    var design = {
      pattern: state.pattern || 'standard',
      colorMap: JSON.parse(JSON.stringify(state.containerColorMap)),
      bindingColor: state.bindingColor,
      name: designName || ('Design ' + ((state.selectedDesignIndex >= 0 ? state.selectedDesignIndex : state.savedDesigns.length) + 1)),
      timestamp: Date.now()
    };
    if (state.containerEmbroidery) design.embroidery = JSON.parse(JSON.stringify(state.containerEmbroidery));
    if (previewPng) design.previewPng = previewPng;
    if (previewPngs) design.previewPngs = previewPngs;

    var idx = state.selectedDesignIndex;
    if (idx >= 0 && idx < state.savedDesigns.length) {
      // Update existing slot in-place (editing current design)
      state.savedDesigns[idx] = design;
    } else if (state.savedDesigns.length < MAX_SAVED_DESIGNS) {
      // New design — add to next available slot
      state.savedDesigns.push(design);
      state.selectedDesignIndex = state.savedDesigns.length - 1;
    } else {
      // All slots full — replace the oldest design
      var oldestIdx = 0;
      var oldestTime = state.savedDesigns[0].timestamp;
      for (var i = 1; i < state.savedDesigns.length; i++) {
        if (state.savedDesigns[i].timestamp < oldestTime) {
          oldestTime = state.savedDesigns[i].timestamp;
          oldestIdx = i;
        }
      }
      if (!designName) design.name = 'Design ' + (oldestIdx + 1);
      state.savedDesigns[oldestIdx] = design;
      state.selectedDesignIndex = oldestIdx;
    }

    saveState();
    renderSavedDesigns();
  }

  /**
   * Select a saved design and load it into the current state
   */
  function selectDesign(index) {
    if (index < 0 || index >= state.savedDesigns.length) return;

    var design = state.savedDesigns[index];
    state.pattern = design.pattern;
    state.containerColorMap = JSON.parse(JSON.stringify(design.colorMap));
    state.bindingColor = design.bindingColor;
    if (design.embroidery) {
      state.containerEmbroidery = JSON.parse(JSON.stringify(design.embroidery));
      // Sync VCP internal state so rig preview shows this slot's embroidery
      var VCP = window.VectorColorPopup;
      if (VCP && VCP.syncEmbroideryFromV2 && state.containerEmbroidery._v2) {
        VCP.syncEmbroideryFromV2(state.containerEmbroidery._v2);
      }
    }
    state.selectedDesignIndex = index;

    // Update pattern cards
    var patternCards = document.querySelectorAll('.vc-pattern-card');
    patternCards.forEach(function (card) {
      var isSelected = card.dataset.pattern === design.pattern;
      card.classList.toggle('selected', isSelected);
      card.setAttribute('aria-checked', isSelected ? 'true' : 'false');
    });

    saveState();
    renderColorPreview();
    renderSavedDesigns();
  }

  /**
   * Delete a saved design
   */
  function deleteDesign(index) {
    if (index < 0 || index >= state.savedDesigns.length) return;

    state.savedDesigns.splice(index, 1);

    // Adjust selected index
    if (state.selectedDesignIndex === index) {
      state.selectedDesignIndex = state.savedDesigns.length > 0 ? 0 : -1;
    } else if (state.selectedDesignIndex > index) {
      state.selectedDesignIndex--;
    }

    // Rename remaining designs only if they have default names
    state.savedDesigns.forEach(function (d, i) {
      if (!d.name || /^Design \d+$/.test(d.name)) {
        d.name = 'Design ' + (i + 1);
      }
    });

    saveState();
    renderSavedDesigns();
  }

  /**
   * Get key colors for compact display (main zones only)
   */
  function getKeyColors(colorMap) {
    var keyZones = ['c1a', 'c2', 'c3a', 'c7c', 'hcut', 'hres'];
    var colors = [];
    var seen = {};

    keyZones.forEach(function (zoneId) {
      var colorId = colorMap[zoneId];
      if (colorId && !seen[colorId]) {
        seen[colorId] = true;
        var c = findColorObjById(colorId);
        colors.push({ id: colorId, hex: c.hex, sc: c.sc || '', name: c.name });
      }
    });

    // Limit to 6 colors max
    return colors.slice(0, 6);
  }

  /**
   * Generate a small thumbnail SVG for a saved design
   */
  function generateDesignThumbnail(pattern, colorMap) {
    // Get representative colors for the pattern
    var colors = [];
    switch (pattern) {
      case 'standard':
        colors = [colorMap['c1a'] || 'black'];
        break;
      case 'half-and-half':
        colors = [colorMap['c1a'] || 'black', colorMap['c1d'] || colorMap['c1b'] || 'black'];
        break;
      case 'diagonal':
        colors = [colorMap['c1a'] || 'black', colorMap['c1d'] || colorMap['c4'] || 'black'];
        break;
      case 'v-split':
      case 'tri-v-split':
        colors = [colorMap['c9a'] || 'black', colorMap['c1a'] || 'black'];
        break;
      case 'triple-v-split':
        colors = [colorMap['c9a'] || 'black', colorMap['c9b'] || 'black', colorMap['c1a'] || 'black'];
        break;
      case 'lightning':
        colors = [colorMap['c1a'] || 'black', colorMap['c1b'] || 'black'];
        break;
      case 'triple-lightning':
        colors = [colorMap['c1a'] || 'black', colorMap['c9b'] || 'black', colorMap['c1b'] || 'black'];
        break;
      case 'zigzag':
        colors = [colorMap['c1a'] || 'black', colorMap['c1b'] || 'black'];
        break;
      default:
        colors = [colorMap['c1a'] || 'black'];
    }

    return generatePatternSVG(pattern, colors, 80, 110, false);
  }

  /**
   * Render all saved design cards (thin wrapper — comparison box handles it)
   */
  function renderSavedDesigns() {
    renderColorPreview();
  }

  /* ================================================================
     STAGE 5: CASCADING DROPDOWNS
     ================================================================ */
  function populateBrands(selectEl, data) {
    selectEl.innerHTML = '<option value="">Select brand\u2026</option>';
    Object.keys(data).forEach(function (brand) {
      var opt = document.createElement('option');
      opt.value = brand;
      opt.textContent = brand;
      selectEl.appendChild(opt);
    });
  }

  function populateModels(selectEl, brand, data) {
    selectEl.innerHTML = '<option value="">Select model\u2026</option>';
    if (!brand || !data[brand]) { selectEl.disabled = true; return; }
    selectEl.disabled = false;
    data[brand].forEach(function (model) {
      var opt = document.createElement('option');
      opt.value = model;
      opt.textContent = model;
      selectEl.appendChild(opt);
    });
  }

  /* ================================================================
     COMBINED CANOPY DROPDOWN + SIZE BUTTONS
     ================================================================ */
  function populateCombinedDropdown(selectEl, canopyData, placeholder) {
    selectEl.innerHTML = '<option value="">' + (placeholder || 'Select canopy\u2026') + '</option>';
    selectEl.disabled = false;
    Object.keys(canopyData).forEach(function (brand) {
      var short = SHORT_MFG[brand] || brand;
      var grp = document.createElement('optgroup');
      grp.label = short;
      canopyData[brand].forEach(function (model) {
        var el = document.createElement('option');
        el.value = brand + '||' + model;
        el.textContent = short + ' \u2013 ' + model;
        grp.appendChild(el);
      });
      selectEl.appendChild(grp);
    });
  }

  function renderSizeButtons(containerId, modelName, slot) {
    var container = $(containerId);
    if (!container) return;
    container.innerHTML = '';
    if (!modelName || !CANOPY_SIZES[modelName]) {
      container.style.display = 'none';
      return;
    }
    container.style.display = '';
    var sizes = CANOPY_SIZES[modelName];
    var ew = parseFloat(state.exitWeight) || 0;
    var ewLbs = ew * 2.205;
    var hasJumpData = state.jumpCount || state.jumpCount === 0;
    var maxWL = hasJumpData ? getAdjustedMaxWL(slot) : ((slot === 'reserve') ? 1.4 : 1.8);

    sizes.forEach(function (s) {
      var wl = (s > 0 && ewLbs > 0) ? ewLbs / s : 0;
      var btn = document.createElement('div');
      btn.className = 'vc-size-btn';
      btn.setAttribute('role', 'button');
      btn.setAttribute('tabindex', '0');
      btn.setAttribute('aria-label', s + ' sq ft' + (wl > 0 ? ', wing load ' + wl.toFixed(2) : ''));

      var currentSize = (slot === 'main') ? state.mainCanopySize : state.reserveCanopySize;
      if (currentSize && Math.abs(parseFloat(currentSize) - s) < 2) btn.classList.add('vc-size-active');
      btn.classList.add(wl > 0 && wl <= maxWL + 0.05 ? 'vc-size-safe' : (wl > 0 ? 'vc-size-unsafe' : 'vc-size-neutral'));

      var label = '<span class="vc-size-val">' + s + ' sq ft</span>';
      if (ew > 0) label += '<span class="vc-size-wl">WL ' + wl.toFixed(2) + '</span>';
      btn.innerHTML = label;
      btn.dataset.size = s;
      btn.dataset.slot = slot;
      container.appendChild(btn);
    });
  }

  /* ================================================================
     CONTAINER SIZING & WING LOADING
     ================================================================ */
  /* ---- Compute min/max canopy sizes a container can hold ---- */
  function getContainerCanopyRange(c) {
    var mainSizes = [];
    var resSizes = [];
    var k;
    for (k in c.m) c.m[k].forEach(function (s) { mainSizes.push(s); });
    for (k in c.mf) c.mf[k].forEach(function (s) { mainSizes.push(s); });
    for (k in c.r) c.r[k].forEach(function (s) { resSizes.push(s); });
    for (k in c.rf) c.rf[k].forEach(function (s) { resSizes.push(s); });
    return {
      mainMin: mainSizes.length ? Math.min.apply(null, mainSizes) : 0,
      mainMax: mainSizes.length ? Math.max.apply(null, mainSizes) : 0,
      resMin: resSizes.length ? Math.min.apply(null, resSizes) : 0,
      resMax: resSizes.length ? Math.max.apply(null, resSizes) : 0
    };
  }

  /* Collect all chart sizes for a canopy across all containers */
  function getChartSizesFor(csvName, isReserve) {
    var sizes = {};
    CONTAINER_DATA.forEach(function (c) {
      var lists = isReserve
        ? [c.r[csvName], c.rf[csvName]]
        : [c.m[csvName], c.mf[csvName]];
      lists.forEach(function (arr) {
        if (arr) arr.forEach(function (s) { sizes[s] = true; });
      });
    });
    return Object.keys(sizes).map(Number).sort(function (a, b) { return a - b; });
  }

  /* Find the nearest chart size >= selected (smaller canopy fits in container
     rated for a bigger one). Falls back to nearest smaller if none above. */
  function nearestChartSize(selected, chartSizes) {
    if (!chartSizes.length) return null;
    if (chartSizes.indexOf(selected) !== -1) return selected;
    var above = null, below = null;
    for (var i = 0; i < chartSizes.length; i++) {
      if (chartSizes[i] >= selected) { above = chartSizes[i]; break; }
      below = chartSizes[i];
    }
    return above || below;
  }

  function findContainers(mainModel, mainSize, resModel, resSize, isWingsuit) {
    var csvMain = CSV_NAME[mainModel];
    var csvRes = resModel ? CSV_NAME[resModel] : null;
    var sz = parseInt(mainSize, 10);
    var rsz = resSize ? parseInt(resSize, 10) : 0;
    if (!csvMain || !sz) return [];
    var approx = !!(CSV_APPROX[mainModel] || (resModel && CSV_APPROX[resModel]));

    /* Resolve effective sizes — use exact if in chart, else nearest */
    var mainChartSizes = getChartSizesFor(csvMain, false);
    var effectiveMainSz = nearestChartSize(sz, mainChartSizes);
    if (!effectiveMainSz) return [];
    var mainApprox = (effectiveMainSz !== sz);

    var effectiveResSz = rsz;
    var resApprox = false;
    if (csvRes && rsz) {
      var resChartSizes = getChartSizesFor(csvRes, true);
      effectiveResSz = nearestChartSize(rsz, resChartSizes);
      if (!effectiveResSz) effectiveResSz = rsz; // keep original if no chart data at all
      resApprox = (effectiveResSz !== rsz);
    }

    var matches = [];
    CONTAINER_DATA.forEach(function (c) {
      var mainFit = null;
      if (c.m[csvMain] && c.m[csvMain].indexOf(effectiveMainSz) !== -1) mainFit = 'standard';
      else if (c.mf[csvMain] && c.mf[csvMain].indexOf(effectiveMainSz) !== -1) mainFit = 'full';
      if (!mainFit) return;
      var resFit = null;
      if (csvRes && rsz) {
        if (c.r[csvRes] && c.r[csvRes].indexOf(effectiveResSz) !== -1) resFit = 'standard';
        else if (c.rf[csvRes] && c.rf[csvRes].indexOf(effectiveResSz) !== -1) resFit = 'full';
        if (!resFit) return;
      }
      matches.push({ name: c.n, type: c.t || '', dims: c.d, mainFit: mainFit, resFit: resFit, approx: approx || mainApprox || resApprox });
    });
    // Sort: prefer standard fit for both main & reserve, then prefer -1 variants for wingsuit
    matches.sort(function (a, b) {
      var aScore = (a.mainFit === 'standard' ? 0 : 1) + (a.resFit === 'standard' ? 0 : (a.resFit ? 1 : 0));
      var bScore = (b.mainFit === 'standard' ? 0 : 1) + (b.resFit === 'standard' ? 0 : (b.resFit ? 1 : 0));
      if (aScore !== bScore) return aScore - bScore;
      if (isWingsuit) {
        var aWs = a.name.indexOf('-1') !== -1 ? 0 : 1;
        var bWs = b.name.indexOf('-1') !== -1 ? 0 : 1;
        if (aWs !== bWs) return aWs - bWs;
      }
      return 0;
    });
    return matches;
  }

  function calcWingLoading(weightKg, canopySqFt, canopyModel) {
    if (!weightKg || !canopySqFt) return null;
    var lbs = weightKg * 2.205;
    var wl = lbs / canopySqFt;
    // Tier mapping (matching wingload-calculator-2)
    var tierKey;
    if (wl < 1.05) tierKey = 'F';
    else if (wl < 1.3) tierKey = 'E';
    else if (wl < 1.5) tierKey = 'D';
    else if (wl < 1.8) tierKey = 'C';
    else if (wl < 2.2) tierKey = 'B';
    else if (wl < 2.6) tierKey = 'A';
    else tierKey = 'S';
    var tier = TIERS[tierKey];
    var tierColors = { F:'#22c55e', E:'#84cc16', D:'#eab308', C:'#f97316', B:'#ef4444', A:'#dc2626', S:'#991b1b' };
    var canopyTierKey = canopyModel ? CANOPY_TIER[canopyModel] : null;
    var canopyTier = canopyTierKey ? TIERS[canopyTierKey] : null;
    return {
      value: Math.round(wl * 100) / 100,
      tierKey: tierKey, tierName: tier.name, tierDesc: tier.desc,
      color: tierColors[tierKey],
      canopyTierKey: canopyTierKey,
      canopyTierName: canopyTier ? canopyTier.name : null,
      canopyTierLimit: canopyTier ? canopyTier.limit : null
    };
  }

  /* ---- Max wing loading based on jump experience (ported from wingload-calculator-2) ---- */
  function getMaxWLForJumps(jumps) {
    if (jumps <= 50)   return 1.0;
    if (jumps <= 100)  return 1.1;
    if (jumps <= 150)  return 1.2;
    if (jumps <= 200)  return 1.3;
    if (jumps <= 300)  return 1.4;
    if (jumps <= 400)  return 1.5;
    if (jumps <= 500)  return 1.6;
    if (jumps <= 650)  return 1.7;
    if (jumps <= 950)  return 1.8;
    if (jumps <= 1200) return 2.0;
    if (jumps <= 1500) return 2.2;
    if (jumps <= 1800) return 2.4;
    if (jumps <= 2100) return 2.6;
    if (jumps <= 2500) return 2.8;
    return 3.0;
  }

  function getAdjustedMaxWL(slot) {
    var jumps = parseInt(state.jumpCount, 10) || 0;
    var base = getMaxWLForJumps(jumps);
    var courses = parseInt(state.canopyCourses, 10) || 0;
    var courseBonus = Math.max(0, (courses - 1)) * 0.1;
    var altVal = parseFloat(state.dzAltitude) || 0;
    var altFt = state.dzAltUnit === 'ft' ? altVal : altVal * 3.28084;
    var altPenalty = (altFt / 1000) * 0.04;
    var result = Math.round((base + courseBonus - altPenalty) * 100) / 100;
    if (slot === 'reserve') return Math.min(result, 1.4);
    return result;
  }

  function getLargestSafeSize(sizes, ewLbs, maxWL) {
    var largest = null;
    sizes.forEach(function (s) {
      if (s <= 0 || ewLbs <= 0) return;
      var wl = ewLbs / s;
      if (wl <= maxWL && (largest === null || s > largest)) largest = s;
    });
    return largest;
  }

  /* ---- Sync exit weight from Stage 1 body weight ---- */
  function syncExitWeight() {
    var w = parseFloat(state.weight) || 0;
    state.exitWeight = w > 0 ? Math.round(w + 12) : '';
    var display = $('vc-exit-weight-display');
    if (display) {
      display.textContent = state.exitWeight
        ? state.exitWeight + ' kg (' + Math.round(state.exitWeight * 2.205) + ' lbs)'
        : '-- kg';
    }
    updateWingLoading();
  }

  function buildSizeSuggestions(csvName) {
    var sizes = {};
    CONTAINER_DATA.forEach(function (c) {
      var lists = [c.m[csvName], c.mf[csvName], c.r[csvName], c.rf[csvName]];
      lists.forEach(function (arr) {
        if (!arr) return;
        arr.forEach(function (s) { sizes[s] = true; });
      });
    });
    return Object.keys(sizes).map(Number).sort(function (a, b) { return a - b; });
  }

  function populateSizeSuggestions(slot) {
    var model = slot === 'main' ? state.mainCanopyModel : state.reserveCanopyModel;
    var listId = slot === 'main' ? 'vc-main-sizes' : 'vc-reserve-sizes';
    var dl = $(listId);
    if (!dl) return;
    dl.innerHTML = '';
    if (!model) return;
    var csvName = CSV_NAME[model];
    if (!csvName) return;
    var sizes = buildSizeSuggestions(csvName);
    sizes.forEach(function (s) {
      var opt = document.createElement('option');
      opt.value = s;
      dl.appendChild(opt);
    });
  }

  /* ================================================================
     SHOPIFY PRODUCT CARD INTEGRATION
     ================================================================ */
  var PRODUCT_SEARCH_MAP = {
    'Sabre 3':['sabre3','sabre 3'],'Pulse':['pulse'],'Stiletto':['stiletto'],'Katana':['katana'],
    'Valkyrie':['valkyrie'],'Comp Velocity':['compvelocity','comp velocity','pd-comp-velocity'],'Horizon':['horizon'],
    'CF Storm':['cfstorm','cf storm','pd-cf-storm'],'Lightning':['pd-lightning','lightning'],'Zero':['pd-zero','zero'],
    'Safire 4':['safire4','safire 4','jyro-safire-4'],'Safire 3':['safire3','safire 3'],
    'Crossfire 3':['crossfire3','crossfire 3'],'JFX 2':['jfx2','jfx 2'],'Leia':['leia'],
    'Kraken':['jyro kraken skydiving canopy','kraken-low-bulk','jyro-kraken-low-bulk'],
    'Kraken ZP':['kraken-zp','kraken zp'],'Helium':['helium'],'Air Student':['air-student','air student'],'Petra':['petra'],
    'S-Fire':['icarus-sfire','sfire skydiving canopy'],'X-Fire':['icarus-xfire','xfire skydiving canopy'],'GT-R':['gt-r','gtr'],'Om':['om-wingsuit','icarus-om-wingsuit'],
    'Omni':['icarus-omni','omni'],'Equinox':['equinox'],'Sky':['icarus-sky','sky skydiving canopy'],
    'Pilot':['pilot skydiving canopy'],'Pilot 7':['pilot7','pilot 7'],
    'PD Reserve':['pd reserve','pd-reserve'],'PD Optimum':['optimum','pd-optimum'],
    'Smart':['smart reserve','aerodyne-smart-reserve'],'Smart LPV':['smartlpv','smart-lpv','smart lpv'],
    'Nano':['nano'],'Reserve':['icarus reserve'],'Mars WP':['mars wp','mars-wp'],
    'Speed 2000':['speed 2000','speed2000','paratec']
  };

  var AAD_PRODUCT_MAP = {
    'cypres-2':['cypres','airtec'],
    'vigil-cuatro':['vigil','cuatro'],
    'mars-m2-multi':['mars','m2 multi','m2multi']
  };

  function findShopifyProduct(modelName, productArray) {
    if (!productArray || !Array.isArray(productArray) || !modelName) return null;
    var searchTerms = PRODUCT_SEARCH_MAP[modelName] || [modelName.toLowerCase().replace(/\s+/g, '')];
    for (var i = 0; i < productArray.length; i++) {
      var product = productArray[i];
      var title = product.title.toLowerCase().replace(/\s+/g, '');
      var handle = product.handle.toLowerCase();
      for (var j = 0; j < searchTerms.length; j++) {
        var t = searchTerms[j].replace(/\s+/g, '');
        if (title.indexOf(t) !== -1 || handle.indexOf(t) !== -1) return product;
      }
    }
    return null;
  }

  function findAADProduct(aadId) {
    if (!window.vcAADProducts || !Array.isArray(window.vcAADProducts) || !aadId) return null;
    var terms = AAD_PRODUCT_MAP[aadId] || [];
    for (var i = 0; i < window.vcAADProducts.length; i++) {
      var product = window.vcAADProducts[i];
      var title = product.title.toLowerCase();
      var handle = product.handle.toLowerCase();
      for (var j = 0; j < terms.length; j++) {
        if (title.indexOf(terms[j]) !== -1 || handle.indexOf(terms[j]) !== -1) return product;
      }
    }
    return null;
  }

  function renderCanopyProductCard(containerId, modelName, size, productArray) {
    var el = $(containerId);
    if (!el) return;
    if (!modelName) { el.style.display = 'none'; return; }
    var product = findShopifyProduct(modelName, productArray);
    if (!product) { el.style.display = 'none'; return; }
    var matchedVariant = null;
    if (size && product.variants) {
      var sizeStr = String(size);
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if (v.size === sizeStr || (v.title && v.title.indexOf(sizeStr) !== -1)) { matchedVariant = v; break; }
      }
    }
    var badgeClass = product.available ? 'vc-product-badge--available' : 'vc-product-badge--unavailable';
    var badgeText = product.available ? 'Available' : 'Out of Stock';
    var productUrl = matchedVariant ? matchedVariant.url : product.url;
    var priceText = matchedVariant ? matchedVariant.price_formatted : product.price_formatted;
    el.innerHTML =
      '<div class="vc-product-card-inner">' +
        '<div class="vc-product-card-image">' +
          '<img src="' + (product.featured_image || '') + '" alt="' + product.title + '" loading="lazy">' +
        '</div>' +
        '<div class="vc-product-card-content">' +
          '<div class="vc-product-card-header">' +
            '<span class="vc-product-card-title">' + product.title + '</span>' +
            '<span class="vc-product-badge ' + badgeClass + '">' + badgeText + '</span>' +
          '</div>' +
          '<span class="vc-product-card-price">' + priceText + '</span>' +
          '<a href="' + productUrl + '" target="_blank" rel="noopener" class="vc-product-card-btn">' +
            'View on Store <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3"/></svg>' +
          '</a>' +
        '</div>' +
      '</div>';
    el.style.display = '';
  }

  /* Show/hide the "Include canopy in order" toggle based on store product availability.
     slot = 'main' | 'reserve' */
  function updateCanopyToggleVisibility(slot) {
    var cbId = slot === 'main' ? 'vc-include-main' : 'vc-include-reserve';
    var cb = $(cbId);
    if (!cb) return;
    var wrap = cb.closest('.vc-toggle-switch');
    if (!wrap) return;
    var model = slot === 'main' ? state.mainCanopyModel : state.reserveCanopyModel;
    var products = slot === 'main' ? window.vcMainCanopyProducts : window.vcReserveCanopyProducts;
    var product = model ? findShopifyProduct(model, products) : null;
    if (product) {
      wrap.style.display = '';
    } else {
      wrap.style.display = 'none';
      cb.checked = false;
      if (slot === 'main') state.includeMainCanopy = false;
      else state.includeReserveCanopy = false;
    }
  }

  function getAADDescription(aadId) {
    var descs = {
      'cypres-2': 'Industry standard. Trusted worldwide with thousands of saves.',
      'vigil-cuatro': 'Belgian engineering. 20-year lifespan, no maintenance intervals.',
      'mars-m2-multi': 'Multi-mode: student, sport, pro, and tandem in one device.'
    };
    return descs[aadId] || '';
  }

  function renderAADCards() {
    var container = $('vc-aad-cards');
    if (!container) return;
    container.innerHTML = '';
    AAD_OPTIONS.forEach(function (aad) {
      var product = findAADProduct(aad.id);
      var card = document.createElement('label');
      card.className = 'vc-option-card vc-aad-product-option' + (state.aad === aad.id ? ' selected' : '');
      var imgHtml = '';
      var priceHtml = '';
      var badgeHtml = '';
      var storeLink = '';
      if (product) {
        imgHtml = '<div class="vc-img-wrap"><img class="vc-option-card-img" src="' + (product.featured_image || '') + '" alt="' + product.title + '" loading="lazy"></div>';
        priceHtml = '<span class="vc-option-card-price">' + product.price_formatted + '</span>';
        badgeHtml = product.available
          ? '<span class="vc-product-badge vc-product-badge--available" style="margin-top:4px;">Available</span>'
          : '<span class="vc-product-badge vc-product-badge--unavailable" style="margin-top:4px;">Out of Stock</span>';
        storeLink = '<a href="' + product.url + '" target="_blank" rel="noopener" class="vc-product-card-btn vc-product-card-btn--small" onclick="event.stopPropagation();">View on Store <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3"/></svg></a>';
      }
      card.innerHTML =
        '<input type="radio" name="vc-aad" value="' + aad.id + '"' + (state.aad === aad.id ? ' checked' : '') + '>' +
        imgHtml +
        '<div class="vc-option-card-body">' +
          '<span class="vc-option-card-title">' + aad.name + '</span>' +
          badgeHtml +
          priceHtml +
          '<span class="vc-option-card-desc">' + getAADDescription(aad.id) + '</span>' +
          storeLink +
        '</div>';
      container.appendChild(card);
    });
  }

  function populateContainerDropdown() {
    var sel = $('vc-container-manual-select');
    if (!sel) return;
    sel.innerHTML = '<option value="">Select container\u2026</option>';
    var micron = [];
    var standard = [];
    CONTAINER_DATA.forEach(function (c) {
      if (c.t === 'Micron') micron.push(c);
      else standard.push(c);
    });
    if (micron.length) {
      var grp1 = document.createElement('optgroup');
      grp1.label = 'Micron Series';
      micron.forEach(function (c) {
        var opt = document.createElement('option');
        opt.value = c.n;
        opt.textContent = c.n + ' (' + c.d.wA + '" \u00d7 ' + c.d.wB + '" \u00d7 ' + c.d.l + '" \u00d7 ' + c.d.th + '")';
        grp1.appendChild(opt);
      });
      sel.appendChild(grp1);
    }
    if (standard.length) {
      var grp2 = document.createElement('optgroup');
      grp2.label = 'Standard Series';
      standard.forEach(function (c) {
        var opt = document.createElement('option');
        opt.value = c.n;
        opt.textContent = c.n + ' (' + c.d.wA + '" \u00d7 ' + c.d.wB + '" \u00d7 ' + c.d.l + '" \u00d7 ' + c.d.th + '")';
        grp2.appendChild(opt);
      });
      sel.appendChild(grp2);
    }
  }

  function showManualContainerInfo(containerName) {
    var infoEl = $('vc-container-manual-info');
    if (!infoEl) return;
    if (!containerName) {
      infoEl.style.display = 'none';
      state.containerSize = '';
      state.containerFit = 'manual';
      saveState();
      return;
    }
    var c = null;
    for (var i = 0; i < CONTAINER_DATA.length; i++) {
      if (CONTAINER_DATA[i].n === containerName) { c = CONTAINER_DATA[i]; break; }
    }
    if (!c) { infoEl.style.display = 'none'; return; }
    state.containerSize = c.n;
    state.containerFit = 'manual';
    var typeLabel = c.t ? ' ' + c.t : '';
    var dimsStr = c.d.wA + '" \u00d7 ' + c.d.wB + '" \u00d7 ' + c.d.l + '" (L) \u00d7 ' + c.d.th + '" (T)';
    var mainKeys = {};
    var k;
    for (k in c.m) mainKeys[k] = true;
    for (k in c.mf) mainKeys[k] = true;
    var resKeys = {};
    for (k in c.r) resKeys[k] = true;
    for (k in c.rf) resKeys[k] = true;
    var mainList = Object.keys(mainKeys).sort().join(', ') || 'None listed';
    var resList = Object.keys(resKeys).sort().join(', ') || 'None listed';
    var range = getContainerCanopyRange(c);
    var rangeHtml = '<p class="vc-container-card-dims" style="margin-top:6px;">' +
      '<strong>Main capacity:</strong> holds canopies from ' + range.mainMin + ' to ' + range.mainMax + ' sq ft' +
      ' &nbsp;\u00b7&nbsp; <strong>Reserve:</strong> ' + range.resMin + ' to ' + range.resMax + ' sq ft</p>';
    infoEl.style.display = '';
    infoEl.className = 'vc-container-card';
    infoEl.innerHTML =
      '<div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;">' +
        '<span class="vc-container-card-title">UPT Vector ' + c.n + typeLabel + '</span>' +
        '<span class="vc-container-card-fit vc-container-card-fit--manual">Manual Selection</span>' +
      '</div>' +
      '<p class="vc-container-card-dims">Dimensions: ' + dimsStr + '</p>' +
      rangeHtml +
      '<p class="vc-container-card-dims" style="margin-top:6px;"><strong>Compatible mains:</strong> ' + mainList + '</p>' +
      '<p class="vc-container-card-dims"><strong>Compatible reserves:</strong> ' + resList + '</p>' +
      '<p class="vc-container-card-disclaimer">Verify compatibility with your dealer. <a href="https://uptvector.com/sizing-chart/" target="_blank" rel="noopener">Full chart \u2192</a></p>';
    saveState();
  }

  function updateContainerResult() {
    if (state.containerManual) return;
    var card = $('vc-container-result');
    if (!card) return;
    var results = findContainers(
      state.mainCanopyModel, state.mainCanopySize,
      state.reserveCanopyModel, state.reserveCanopySize,
      state.isWingsuit
    );
    if (!state.mainCanopyModel || !state.mainCanopySize) {
      card.className = 'vc-container-card vc-container-card--empty';
      card.innerHTML = '<p class="vc-container-card-title" style="font-size:15px;font-weight:600;color:var(--vc-text-muted);">Select your canopies above to see the recommended container size</p>';
      state.containerSize = '';
      state.containerFit = '';
      saveState();
      return;
    }
    if (!results.length) {
      card.className = 'vc-container-card vc-container-card--empty';
      card.innerHTML = '<p class="vc-container-card-title" style="font-size:15px;font-weight:600;">No exact match found</p>' +
        '<p class="vc-container-card-disclaimer">This combination was not found in the UPT sizing chart. Please <a href="https://uptvector.com/sizing-chart/" target="_blank" rel="noopener">check the full UPT chart</a> or contact your dealer.</p>';
      state.containerSize = '';
      state.containerFit = '';
      saveState();
      return;
    }
    var best = results[0];
    state.containerSize = best.name;
    state.containerFit = best.mainFit;
    var typeLabel = best.type ? ' ' + best.type : '';
    var fitClass = best.mainFit === 'standard' ? 'vc-container-card-fit--standard' : 'vc-container-card-fit--full';
    var fitLabel = best.mainFit === 'standard' ? 'Standard Fit' : 'Full Fit';
    var dimsStr = best.dims.wA + '" \u00d7 ' + best.dims.wB + '" \u00d7 ' + best.dims.l + '" (L) \u00d7 ' + best.dims.th + '" (T)';
    // Compute canopy size range for this container
    var containerObj = null;
    for (var ci = 0; ci < CONTAINER_DATA.length; ci++) {
      if (CONTAINER_DATA[ci].n === best.name) { containerObj = CONTAINER_DATA[ci]; break; }
    }
    var rangeHtml = '';
    if (containerObj) {
      var range = getContainerCanopyRange(containerObj);
      rangeHtml = '<p class="vc-container-card-dims" style="margin-top:6px;">' +
        '<strong>Main capacity:</strong> holds canopies from ' + range.mainMin + ' to ' + range.mainMax + ' sq ft' +
        ' &nbsp;\u00b7&nbsp; <strong>Reserve:</strong> ' + range.resMin + ' to ' + range.resMax + ' sq ft</p>';
    }
    var altHtml = '';
    if (results.length > 1) {
      var alts = results.slice(1, 4).map(function (r) {
        return r.name + (r.type ? ' ' + r.type : '') + ' (' + r.mainFit + ')';
      });
      altHtml = '<p class="vc-container-card-dims" style="margin-top:12px;"><strong>Also compatible:</strong> ' + alts.join(', ') + '</p>';
    }
    card.className = 'vc-container-card';
    card.innerHTML =
      '<div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;">' +
        '<span class="vc-container-card-title">UPT Vector ' + best.name + typeLabel + '</span>' +
        '<span class="vc-container-card-fit ' + fitClass + '">' + fitLabel + '</span>' +
      '</div>' +
      '<p class="vc-container-card-dims">Dimensions: ' + dimsStr + '</p>' +
      rangeHtml +
      altHtml +
      '<p class="vc-container-card-disclaimer">' +
        'Based on the <a href="https://uptvector.com/sizing-chart/" target="_blank" rel="noopener">UPT sizing chart</a>. We always back-check every recommended container with UPT. If you have special remarks, you can list them in the Special Instructions on the next stage.</p>';
    saveState();
  }

  function getWingLoadAdvice(category) {
    var advice = {
      'Conservative': 'Forgiving and safe. Great for newer jumpers and low-stress landings.',
      'Moderate': 'Standard sport loading. Good for regular jumping with solid canopy skills.',
      'Experienced': 'Requires solid canopy control and consistent landing approach.',
      'Advanced': 'High performance territory. Strong canopy piloting skills required.',
      'Aggressive': 'Very high loading. Expert canopy piloting and current jump currency essential.',
      'Expert / Competition': 'Competition-level loading. Only for expert canopy pilots with extensive training.'
    };
    return advice[category] || '';
  }

  function updateWingLoading() {
    var el = $('vc-wingload-result');
    if (!el) return;
    var ew = parseFloat(state.exitWeight) || ((parseFloat(state.weight) || 0) + 12);
    var sz = parseFloat(state.mainCanopySize) || 0;
    if (!ew || !sz) {
      el.style.display = 'none';
      return;
    }
    var wl = calcWingLoading(ew, sz, state.mainCanopyModel);
    if (!wl) { el.style.display = 'none'; return; }
    var pct = Math.min(wl.value / 2.2, 1) * 100;
    // Safety status based on experience (matching wingload-calculator-2)
    var jumps = parseInt(state.jumpCount, 10) || 0;
    var maxWL = getAdjustedMaxWL('main');
    var statusMsg = '';
    if (wl.value > 1.05 && jumps <= 50) {
      statusMsg = '<strong>STOP:</strong> Students must stay below 1.0 wing loading.';
    } else if (jumps > 0 && wl.value > maxWL) {
      statusMsg = '<strong>Warning:</strong> Wing load ' + wl.value.toFixed(2) + ' exceeds recommended limit (' + maxWL.toFixed(1) + ') for your experience level.';
    }
    var canopyNote = wl.canopyTierName
      ? '<span class="vc-wingload-type" style="font-size:11px;font-weight:700;opacity:0.85;">Canopy tier: ' +
        wl.canopyTierName + ' (max WL ' + wl.canopyTierLimit.toFixed(1) + ')</span>'
      : '';
    el.style.display = '';
    el.innerHTML =
      '<div class="vc-wingload">' +
        '<span class="vc-wingload-value" style="color:' + wl.color + ';">' + wl.value.toFixed(2) + '</span>' +
        '<div class="vc-wingload-detail">' +
          '<span class="vc-wingload-category" style="color:' + wl.color + ';">' + wl.tierName + '</span>' +
          '<span class="vc-wingload-tier-desc" style="font-size:11px;color:#666;">' + wl.tierDesc + '</span>' +
          canopyNote +
          '<div class="vc-wingload-bar"><div class="vc-wingload-bar-fill" style="width:' + pct + '%;background:' + wl.color + ';"></div></div>' +
          '<span class="vc-wingload-sub">Wing loading: ' + wl.value.toFixed(2) + ' lbs/sq ft &mdash; Exit weight: ' + Math.round(ew) + ' kg (' + Math.round(ew * 2.205) + ' lbs)</span>' +
          (statusMsg ? '<span class="vc-wingload-advice" style="color:#ef4444;">' + statusMsg + '</span>' : '') +
        '</div>' +
      '</div>';
  }

  /* ================================================================
     AI COLOR DESIGN ENGINE (Gemini 3 Flash)
     ================================================================ */
  function getGeminiProxyUrl() {
    return (dom.container && dom.container.dataset.geminiProxy) || '';
  }

  /* ---------- Build comprehensive AI prompt (5 templates, random) ---------- */

  // Helper: describe physical areas covered by a set of SVG IDs
  function describePhysicalAreas(ids) {
    var parts = [];
    if (ids.indexOf('c2') !== -1 || ids.indexOf('c2b') !== -1) parts.push('Yoke (top of back)');
    if (ids.indexOf('c1a') !== -1 || ids.indexOf('c1b') !== -1) parts.push('Main Body (large back panels)');
    if (ids.indexOf('c1c') !== -1) parts.push('Lower body bridge');
    if (ids.indexOf('c1d') !== -1) parts.push('Divider strip');
    if (ids.indexOf('c3a') !== -1 || ids.indexOf('c3b') !== -1) parts.push('Upper Sidewalls');
    if (ids.indexOf('c5a') !== -1 || ids.indexOf('c5b') !== -1) parts.push('Lower Sidewalls');
    if (ids.indexOf('c6a') !== -1 || ids.indexOf('c6b') !== -1) parts.push('Lateral panels');
    if (ids.indexOf('c4') !== -1 || ids.indexOf('c4b') !== -1) parts.push('Belly Band (front waist)');
    if (ids.indexOf('c7a') !== -1 || ids.indexOf('c7b') !== -1) parts.push('Reserve container');
    if (ids.indexOf('c9a') !== -1) parts.push('V-shape center overlay');
    var cfCount = 0;
    ids.forEach(function (id) { if (id.indexOf('cf') === 0) cfCount++; });
    if (cfCount > 0) parts.push('Center flap (spine)');
    if (ids.indexOf('backp') !== -1) parts.push('Back pad');
    if (ids.indexOf('hcut') !== -1 || ids.indexOf('hres') !== -1) parts.push('Handle covers (chest)');
    if (ids.indexOf('lpad') !== -1 || ids.indexOf('rpad') !== -1) parts.push('Leg pads');
    return parts.join(', ');
  }

  // 5 prompt personality templates — each gives a different design vibe
  // EMBROIDERY RULES (shared): minimal chars, text emoji, sidewalls always 45°, no custom logos
  var EMB_RULES =
    'EMBROIDERY TEXT RULES:\n' +
    '- Keep custom text SHORT: 1-6 characters max. Less is more on a rig.\n' +
    '- Mix in Unicode text symbols that match the theme. Examples:\n' +
    '  \u2605 \u2606 \u2736 \u2737 \u2764 \u2661 \u2660 \u2663 \u2666 \u2665 \u2708 \u269B \u2622 \u2623 \u26A1 \u2604 \u2602 \u263A \u263B\n' +
    '  \u2620 \u2694 \u2693 \u2692 \u265B \u265A \u2654 \u2655 \u262F \u262E \u2721 \u2740 \u273F \u2742 \u2748 \u2756 \u25C6 \u25B2 \u25BC\n' +
    '  Combine them! e.g. "\u2605FLY\u2605" or "\u26A1ACE" or "\u2708\u2764" or "\u2620APEX"\n' +
    '- Sidewalls (swalls) MUST ALWAYS use "angle45": true for 45\u00B0 diagonal placement.\n' +
    '- Do NOT use "custom_logo" type. Only use "logo" or "custom" types.\n';

  var PROMPT_TEMPLATES = [
    // Template 1: Bold & Striking
    {
      intro: 'You are an expert skydiving rig color designer known for BOLD, eye-catching designs. ' +
        'Create a stunning color scheme for a UPT Vector 3 container that will turn heads at every DZ.',
      rules:
        '1. VISUALLY STRIKING! Skydivers want bold, unique rigs. Use HIGH CONTRAST bright colors.\n' +
        '2. At LEAST 5-6 different BRIGHT colors total across fabric, trim, harness, and embroidery.\n' +
        '3. Trim tape MUST contrast the main fabric — pick a vivid color.\n' +
        '4. Embroidery thread MUST contrast its panel (light on dark, dark on light).\n' +
        '5. ALWAYS enable piping with a contrasting color.\n' +
        '6. ALWAYS enable contrast stitching with a vibrant thread.\n' +
        '7. Include 4-5 embroidery positions. Always include yoke + sidewall text.\n' +
        '8. Sidewall text: short & punchy with symbols, e.g. "\u2605FLY\u2605", "\u26A1SEND\u26A1", "\u2708SKY".\n' +
        '9. Use DIFFERENT colors for each panel group — never pick similar or dark shades for all.\n' +
        '10. Use bright colors like neons, reds, blues, yellows — avoid all-black or mostly-dark palettes.',
      temp: 0.95
    },
    // Template 2: Professional & Coordinated
    {
      intro: 'You are a professional color consultant for premium skydiving equipment. ' +
        'Design an elegant, well-coordinated UPT Vector 3 container that looks premium and refined.',
      rules:
        '1. PREMIUM LOOK — think high-end sports equipment. Coordinated, not chaotic.\n' +
        '2. Use a cohesive color palette: 1 primary, 1 secondary, 1-2 accents.\n' +
        '3. Trim tape should COMPLEMENT the fabric — polished, intentional.\n' +
        '4. Harness webbing in a neutral that ties the scheme together.\n' +
        '5. Enable piping as a subtle accent line.\n' +
        '6. Contrast stitching: yes, pick a color that enhances rather than shouts.\n' +
        '7. Include 3-5 embroidery positions with clean logos.\n' +
        '8. Sidewall text: classy & minimal, e.g. "\u25C6PRO\u25C6", "\u2654ACE", "\u2736V3".\n' +
        '9. The design should look intentional, like a luxury product.',
      temp: 0.85
    },
    // Template 3: Competition / Race Livery
    {
      intro: 'You are a motorsport livery designer who also designs skydiving rigs. ' +
        'Create a UPT Vector 3 design inspired by race car liveries — aggressive, dynamic, high-energy!',
      rules:
        '1. Think RACE CAR / MOTORSPORT livery — dynamic, aggressive, high-visibility.\n' +
        '2. Use SHARP COLOR BREAKS between panel groups.\n' +
        '3. High contrast: dark vs bright, neon vs matte.\n' +
        '4. Trim tape in a bright accent (neon yellow, neon orange, neon green, red, white).\n' +
        '5. Harness webbing: black or bold contrast. Black hardware.\n' +
        '6. ALWAYS enable piping in a neon or high-vis color.\n' +
        '7. ALWAYS enable contrast stitching AND JC stitching.\n' +
        '8. Include 5+ embroidery positions. Bold sidewall text.\n' +
        '9. Sidewall text: action words with symbols, e.g. "\u26A1SEND\u26A1", "\u2620MACH1", "\u2605GO\u2605".\n' +
        '10. Use symbols everywhere: \u26A1 \u2605 \u2708 \u2620 add racing character.',
      temp: 1.0
    },
    // Template 4: Nature & Adventure Inspired
    {
      intro: 'You are an outdoor adventure brand designer creating a UPT Vector 3 color scheme. ' +
        'Draw inspiration from nature — mountains, oceans, sunsets, forests, deserts.',
      rules:
        '1. NATURE-INSPIRED palettes: earth tones, sky blues, sunset oranges, forest greens.\n' +
        '2. Evoke a specific natural scene or environment.\n' +
        '3. Trim tape: organic feel — gold, tan, beige, warm tones.\n' +
        '4. Harness webbing: natural tones (coyote, tan, olive-drab) or black.\n' +
        '5. Enable piping in a warm accent.\n' +
        '6. Contrast stitching in an earthy or warm thread.\n' +
        '7. Include 4-5 embroidery positions.\n' +
        '8. Sidewall text: nature-themed with symbols, e.g. "\u2604FLY", "\u2602SKY", "\u263AWILD", "\u2740FREE".\n' +
        '9. Warm, adventurous, connected to the outdoors.\n' +
        '10. Use similar tones across related panel groups for natural gradients.',
      temp: 0.9
    },
    // Template 5: Vibrant & Fun
    {
      intro: 'You are a fun-loving skydiver creating the HAPPIEST, most COLORFUL UPT Vector 3 design ever. ' +
        'Think beach parties, tropical sunsets, candy colors, and pure joy. Make it POP!',
      rules:
        '1. VIBRANT & FUN! Use the brightest, most cheerful colors available.\n' +
        '2. MUST use at least 3-4 of these: neon-yellow, neon-orange, neon-pink, neon-green, neon-blue, yellow, red, sky-blue, fuchsia.\n' +
        '3. Each panel group should be a different bright color — RAINBOW vibes.\n' +
        '4. Trim tape: bright accent (neon-yellow, neon-pink, yellow, or white).\n' +
        '5. Harness webbing: white or a bright color.\n' +
        '6. Enable piping in a contrasting neon.\n' +
        '7. Contrast stitching in a vivid thread (neon-pink, neon-yellow, or gold).\n' +
        '8. Include 5+ embroidery positions with colorful thread.\n' +
        '9. Sidewall text: fun with symbols, e.g. "\u2605FUN\u2605", "\u2764FLY\u2764", "\u2600HAPPY", "\u266BVIBE".\n' +
        '10. No black panels allowed. This rig should GLOW!',
      temp: 1.0
    }
  ];

  function buildGeminiPayload(userPrompt) {
    // Build color lists with name+hex for AI context
    var corduraList = ALL_COLORS.map(function (c) { return c.id + ' ("' + c.name + '" ' + c.hex + ')'; }).join(', ');
    var trimList = TRIM_TAPE_COLORS.map(function (c) { return c.id + ' ("' + c.name + '" ' + c.hex + ')'; }).join(', ');
    var webbingList = WEBBING_COLORS.map(function (c) { return c.id + ' ("' + c.name + '" ' + c.hex + ')'; }).join(', ');

    // Embroidery thread colors
    var VCP = window.VectorColorPopup;
    var threadList = '';
    if (VCP && VCP.EMBROIDERY_COLORS) {
      threadList = VCP.EMBROIDERY_COLORS.map(function (c) { return c.id + ' ("' + c.name + '")'; }).join(', ');
    }

    // Embroidery positions with per-side logo options
    var embDetails = '';
    if (VCP && VCP.EMBROIDERY_POSITIONS && VCP.EMBROIDERY_LOGOS) {
      var posLines = [];
      VCP.EMBROIDERY_POSITIONS.forEach(function (p) {
        var logos = VCP.EMBROIDERY_LOGOS.filter(function (l) {
          return l.positions.indexOf(p.id) !== -1;
        });
        var logoStr = logos.map(function (l) {
          return l.id + ' ("' + l.name + '", ' + l.colors + ' color' + (l.colors !== 1 ? 's' : '') + ')';
        }).join(', ');
        posLines.push('  - ' + p.id + ' (' + p.label + '): ' + p.desc + '\n    Available logos: ' + logoStr + '\n    Also: "custom" (custom text, 1 color)');
      });
      embDetails = posLines.join('\n');
    }

    // Standard pattern: list all panel groups the AI can color individually
    var panelGroups =
      'PANEL GROUPS (each can be a DIFFERENT color):\n' +
      '  "yoke": Yoke — top of back (c2)\n' +
      '  "mainBody": Main Body — largest back panels (c1a, c1b)\n' +
      '  "lowerBody": Lower Body bridge (c1c)\n' +
      '  "upperSidewalls": Upper Sidewalls (c3a, c3b)\n' +
      '  "lowerSidewalls": Lower Sidewalls (c5a, c5b)\n' +
      '  "laterals": Lateral panels (c6a, c6b)\n' +
      '  "bellyBand": Belly Band — front waist (c4)\n' +
      '  "reserve": Reserve container (c7a, c7b)\n' +
      '  "centerFlap": Center flap — spine strip (cfa-cfg)\n' +
      '  "backpad": Back pad (backp)\n' +
      '  "handles": Handle covers — chest (hcut, hres)\n' +
      '  "legPads": Leg pads — thighs (lpad, rpad)\n';

    // Randomly select a prompt template
    var tpl = PROMPT_TEMPLATES[Math.floor(Math.random() * PROMPT_TEMPLATES.length)];

    // Shared data sections
    var sharedData =
      '\n\n=== THE RIG: Physical layout ===\n' +
      'BACK VIEW (most visible): Yoke at top \u2192 Main Body panels (largest) \u2192 Center flap (spine) \u2192 Reserve container (bottom)\n' +
      'SIDE VIEWS: Upper Sidewalls \u2192 Lower Sidewalls \u2192 Lateral panels\n' +
      'FRONT VIEW: Belly Band (waist) \u2192 Handle covers (chest) \u2192 Leg pads (thighs)\n' +
      'Harness webbing = structural straps everywhere. Trim tape = decorative binding along seams.\n\n' +

      '=== PANEL LAYOUT (Standard configuration — each panel can be a different color!) ===\n' +
      panelGroups + '\n' +

      '=== ACCENT ELEMENTS (independent of zones) ===\n' +
      'TRIM TAPE: binding on all seams, 1 color | HARNESS WEBBING: straps, 1 color\n' +
      'PIPING: accent cord on center flap edges | CONTRAST STITCHING: colored thread on harness\n' +
      'JC STITCHING: decorative harness pattern | HARDWARE: "standard" (silver) or "black"\n' +
      'EMBROIDERY: stitched logos/text on panels\n\n' +

      '=== CORDURA FABRIC COLORS ===\n' + corduraList + '\n\n' +
      '=== TRIM TAPE COLORS ===\n' + trimList + '\n\n' +
      '=== HARNESS WEBBING COLORS ===\n' + webbingList + '\n\n' +
      '=== EMBROIDERY THREAD COLORS (em- prefix) ===\n' + threadList + '\n\n' +

      '=== EMBROIDERY POSITIONS ===\n' +
      embDetails + '\n' +
      'Custom text: type "custom", text "YOUR TEXT", color "em-xxx", font "block" or "script"\n' +
      'Symbols you can embed in text: \u2605 \u2660 \u2600 \u26A1 \u2708 \u2764 \u266B \u2620 \u272A \u2693 \u265B \u262E \u2694 \u2666 \u2726\n' +
      'NO "custom_logo" type — only "logo" or "custom".\n\n' +
      EMB_RULES + '\n';

    // Template-specific design rules (now framed as defaults, not hard rules)
    var designRules = '=== DESIGN DEFAULTS (only apply when the user is silent on these) ===\n' + tpl.rules + '\n\n';

    // Shared JSON format
    var jsonFormat =
      '=== JSON FORMAT (return ONLY valid JSON, no markdown) ===\n' +
      '{ "name": "Creative Name",\n' +
      '  "description": "2 sentences describing the theme",\n' +
      '  "panels": {\n' +
      '    "yoke": "cordura-id",\n' +
      '    "mainBody": "cordura-id",\n' +
      '    "lowerBody": "cordura-id",\n' +
      '    "upperSidewalls": "cordura-id",\n' +
      '    "lowerSidewalls": "cordura-id",\n' +
      '    "laterals": "cordura-id",\n' +
      '    "bellyBand": "cordura-id",\n' +
      '    "reserve": "cordura-id",\n' +
      '    "centerFlap": "cordura-id",\n' +
      '    "backpad": "cordura-id",\n' +
      '    "handles": "cordura-id",\n' +
      '    "legPads": "cordura-id"\n' +
      '  },\n' +
      '  "trimTape": "trim-id",\n' +
      '  "harnessWebbing": "webbing-id",\n' +
      '  "contrastStitch": true, "stitchColor": "em-xxx",\n' +
      '  "jcStitching": true/false, "jcColor": "em-xxx",\n' +
      '  "hardwareFinish": "standard" or "black",\n' +
      '  "pipingEnabled": true, "pipingColor": "trim-id",\n' +
      '  "embroidery": [\n' +
      '    {"position":"yoke","type":"logo","logoId":"xxx","colors":["em-xxx","em-xxx"]},\n' +
      '    {"position":"swalls","type":"custom","text":"\u2605FLY\u2605","color":"em-xxx","font":"block","angle45":true},\n' +
      '    ... more positions\n' +
      '  ]\n' +
      '}\n\n' +
      'HARD RULES (always apply — never violate these):\n' +
      '- "panels" MUST include ALL 12 panel group keys listed.\n' +
      '- Use EXACT color IDs from the Cordura / Trim / Webbing / Thread lists. Cordura/trim/webbing = no prefix. Thread = em- prefix.\n' +
      '- Sidewalls ("swalls") embroidery MUST include "angle45": true.\n' +
      '- Do NOT use "custom_logo" type. Only "logo" or "custom".\n\n' +
      'SOFT DEFAULTS (apply only when the user did not request otherwise):\n' +
      '- Prefer 3-5 distinct panel colors for visual interest.\n' +
      '- Include yoke + swalls + 1-2 more embroidery positions.\n' +
      '- When the user does NOT specify a mood, lean colorful/vivid. If the user asks for minimal/mono/all-black/subtle/etc., FULLY respect that even if the template vibe suggests bright.\n';

    // Random seed defeats Gemini prompt-cache on repeat clicks of the same user text
    var seed = Math.random().toString(36).slice(2, 10) + '-' + Date.now().toString(36);

    // User request goes FIRST and takes priority over templates/defaults below
    var userSection;
    if (userPrompt && userPrompt.trim()) {
      userSection = '=== USER REQUEST (highest priority — override any default below that conflicts) ===\n' +
        userPrompt.trim() + '\n\n' +
        'Honor the user request above. The templates and defaults that follow are *suggestions* for filling gaps the user did not specify. If the user asks for something specific (a color, a mood, a pattern, restraint, monochrome, etc.), prioritize that over the template vibe.\n\n';
    } else {
      userSection = '=== USER REQUEST ===\n(none — be creative)\n\n';
    }

    var seedSection = '=== GENERATION SEED ===\nseed=' + seed + ' (vary the output — do not repeat prior designs)\n\n';

    var prompt = userSection + seedSection + tpl.intro + '\n\n' +
      sharedData + designRules + jsonFormat;

    return {
      contents: [{ parts: [{ text: prompt }] }],
      generationConfig: {
        temperature: tpl.temp,
        maxOutputTokens: 4096,
        responseMimeType: 'application/json'
      }
    };
  }

  function callGeminiAPI(userPrompt, callback) {
    var proxyUrl = getGeminiProxyUrl();
    if (!proxyUrl) {
      callback({ error: 'AI not configured. Set a Gemini Proxy URL in the theme editor.' });
      return;
    }
    var body = buildGeminiPayload(userPrompt);

    var xhr = new XMLHttpRequest();
    xhr.open('POST', proxyUrl, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.timeout = 90000;

    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          var resp = JSON.parse(xhr.responseText);
          if (!resp.candidates || !resp.candidates[0] || !resp.candidates[0].content || !resp.candidates[0].content.parts || !resp.candidates[0].content.parts[0]) {
            throw new Error('Unexpected AI response structure');
          }
          var text = resp.candidates[0].content.parts[0].text;
          var design = JSON.parse(text);
          callback({ data: design });
        } catch (e) {
          callback({ error: 'Failed to parse AI response. Please try again.' });
        }
      } else if (xhr.status === 503 || xhr.status === 429) {
        callback({ error: 'AI service is temporarily busy. Please wait a moment and try again.' });
      } else {
        var errMsg = 'API error (' + xhr.status + ').';
        try {
          var errBody = JSON.parse(xhr.responseText);
          if (errBody.error && errBody.error.message) errMsg += ' ' + errBody.error.message;
        } catch (ignored) {}
        callback({ error: errMsg });
      }
    };
    xhr.onerror = function () { callback({ error: 'Network error. Check your connection and try again.' }); };
    xhr.ontimeout = function () { callback({ error: 'Request timed out. Please try again.' }); };
    xhr.send(JSON.stringify(body));
  }

  // Find the closest UPT Cordura color by Euclidean RGB distance
  function findClosestColor(hex, colorList) {
    var c = hex.replace('#', '');
    if (c.length === 3) c = c[0] + c[0] + c[1] + c[1] + c[2] + c[2];
    var r = parseInt(c.substr(0, 2), 16);
    var g = parseInt(c.substr(2, 2), 16);
    var b = parseInt(c.substr(4, 2), 16);
    var best = colorList[0];
    var bestDist = Infinity;
    colorList.forEach(function (col) {
      var ch = (col.hex || '#000').replace('#', '');
      if (ch.length === 3) ch = ch[0] + ch[0] + ch[1] + ch[1] + ch[2] + ch[2];
      var cr = parseInt(ch.substr(0, 2), 16);
      var cg = parseInt(ch.substr(2, 2), 16);
      var cb = parseInt(ch.substr(4, 2), 16);
      var d = (r - cr) * (r - cr) + (g - cg) * (g - cg) + (b - cb) * (b - cb);
      if (d < bestDist) { bestDist = d; best = col; }
    });
    return best;
  }

  // Store the last AI design so Apply can reference it
  var lastAIDesign = null;

  function resolveColorName(colorId, list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === colorId) return list[i].name;
    }
    return colorId;
  }

  function renderAIDesign(design) {
    var resultEl = $('vc-ai-result');
    var previewEl = $('vc-ai-preview');
    var descEl = $('vc-ai-description');
    var swatchesEl = $('vc-ai-swatches');
    var applyBtn = $('vc-ai-apply');
    if (!resultEl || !previewEl || !descEl || !swatchesEl) return;

    lastAIDesign = design;

    // Description
    descEl.innerHTML =
      '<h4 class="vc-ai-design-name">' + escHtml(design.name || 'AI Design') + '</h4>' +
      '<p class="vc-ai-design-desc">' + escHtml(design.description || '') + '</p>';

    // Panel color preview
    var panels = design.panels || {};
    var panelLabels = {
      yoke: 'Yoke', mainBody: 'Main Body', lowerBody: 'Lower Body',
      upperSidewalls: 'Upper SW', lowerSidewalls: 'Lower SW', laterals: 'Laterals',
      bellyBand: 'Belly Band', reserve: 'Reserve', centerFlap: 'Center Flap',
      backpad: 'Back Pad', handles: 'Handles', legPads: 'Leg Pads'
    };
    var previewHtml = '<div class="vc-ai-panel-grid">';
    Object.keys(panelLabels).forEach(function (key) {
      var colorId = panels[key];
      if (!colorId) return;
      var colorObj = findColorObjById(colorId);
      var hex = colorObj ? colorObj.hex : '#888';
      var name = colorObj ? colorObj.name : colorId;
      var textColor = isLightColor(hex) ? '#333' : 'rgba(255,255,255,0.8)';
      previewHtml += '<div class="vc-ai-panel" style="background:' + hex + ';" title="' + panelLabels[key] + ': ' + name + '">' +
        '<span class="vc-ai-panel-label" style="color:' + textColor + ';">' + panelLabels[key] + '</span>' +
        '</div>';
    });
    previewHtml += '</div>';

    // Trim / webbing / options row
    var infoItems = [];
    if (design.trimTape) infoItems.push('Trim: ' + resolveColorName(design.trimTape, TRIM_TAPE_COLORS));
    if (design.harnessWebbing) infoItems.push('Webbing: ' + resolveColorName(design.harnessWebbing, WEBBING_COLORS));
    if (design.contrastStitch) infoItems.push('Contrast Stitch: ' + (design.stitchColor || 'em-black'));
    if (design.jcStitching) infoItems.push('JC Stitch: ' + (design.jcColor || 'em-black'));
    if (design.hardwareFinish === 'black') infoItems.push('Black Hardware');
    if (design.pipingEnabled) infoItems.push('Piping: ON');
    if (infoItems.length) {
      previewHtml += '<div class="vc-ai-trim-row">';
      infoItems.forEach(function (t) {
        previewHtml += '<div class="vc-ai-trim-item">' + t + '</div>';
      });
      previewHtml += '</div>';
    }

    // Embroidery section
    var emb = design.embroidery || [];
    if (emb.length) {
      previewHtml += '<div class="vc-ai-emb-section"><div class="vc-ai-emb-title">Embroidery</div>';
      emb.forEach(function (e) {
        var posLabel = e.position || '?';
        var detail = '';
        if (e.type === 'logo' && e.logoId) {
          detail = 'Logo: ' + e.logoId;
          if (e.colors && e.colors.length) detail += ' (' + e.colors.join(', ') + ')';
        } else if (e.type === 'custom_logo' && e.logoUrl) {
          detail = 'Custom Logo <img src="' + e.logoUrl + '" class="vc-ai-emb-logo-thumb" alt="logo" />';
        } else if (e.type === 'custom' && e.text) {
          detail = 'Custom: "' + e.text + '"';
          if (e.color) detail += ' (' + e.color + ')';
        }
        previewHtml += '<div class="vc-ai-emb-item"><span class="vc-ai-emb-pos">' + posLabel + '</span> ' + detail + '</div>';
      });
      previewHtml += '</div>';
    }

    previewEl.innerHTML = previewHtml;

    // Swatch list — panels + options
    var swatchHtml = '<div class="vc-ai-swatch-list">';
    Object.keys(panelLabels).forEach(function (key) {
      var colorId = panels[key];
      if (!colorId) return;
      var colorObj = findColorObjById(colorId) || { name: colorId, hex: '#888', id: colorId };
      swatchHtml += '<div class="vc-ai-swatch-item">' +
        '<span class="vc-ai-swatch-dot" style="background:' + colorObj.hex + ';"></span>' +
        '<span class="vc-ai-swatch-name">' + panelLabels[key] + '</span>' +
        '<span class="vc-ai-swatch-match">' + colorObj.name + ' (' + colorObj.id + ')</span>' +
        '</div>';
    });
    swatchHtml += '</div>';
    swatchesEl.innerHTML = swatchHtml;

    resultEl.style.display = '';
    if (applyBtn) applyBtn.style.display = '';
  }

  // Panel group key → SVG IDs for per-panel AI coloring
  var AI_PANEL_MAP = {
    yoke:            ['c2', 'c2b'],
    mainBody:        ['c1a', 'c1b'],
    lowerBody:       ['c1c', 'c1d'],
    upperSidewalls:  ['c3a', 'c3b'],
    lowerSidewalls:  ['c5a', 'c5b'],
    laterals:        ['c6a', 'c6b'],
    bellyBand:       ['c4', 'c4b'],
    reserve:         ['c7a', 'c7b', 'c7c'],
    centerFlap:      ['cfa', 'cfb', 'cfc', 'cfd', 'cfe', 'cff', 'cfg'],
    backpad:         ['backp'],
    handles:         ['hcut', 'hres'],
    legPads:         ['lpad', 'rpad']
  };

  function applyAIDesignToRig() {
    if (!lastAIDesign) return;
    var d = lastAIDesign;

    // AI designs are always applied as full-custom — per-panel colors drive the look.
    // Split/lightning/etc patterns would override the AI's panel-by-panel palette.
    selectPattern('full-custom');

    // 1. Cordura panels → containerColorMap
    var colorMap = JSON.parse(JSON.stringify(state.containerColorMap || {}));
    var panels = d.panels || {};
    Object.keys(AI_PANEL_MAP).forEach(function (groupKey) {
      var colorId = panels[groupKey];
      if (!colorId) return;
      var match = findColorObjById(colorId);
      if (!match) match = findClosestColor('#888', ALL_COLORS);
      AI_PANEL_MAP[groupKey].forEach(function (svgId) {
        colorMap[svgId] = match.id;
      });
    });
    // Also fill any remaining standard-zone IDs that aren't in a group (stabilizers, etc.)
    var coveredIds = {};
    Object.keys(AI_PANEL_MAP).forEach(function (k) {
      AI_PANEL_MAP[k].forEach(function (id) { coveredIds[id] = true; });
    });
    var stdIds = PATTERN_ZONE_MAP['standard'][0].ids;
    var fallbackColor = panels.mainBody || 'black';
    stdIds.forEach(function (id) {
      if (!coveredIds[id] && !colorMap[id]) {
        colorMap[id] = fallbackColor;
      }
    });

    // 2. Trim tape — apply to ALL trim zones
    if (d.trimTape) {
      var trimMatch = null;
      for (var ti = 0; ti < TRIM_TAPE_COLORS.length; ti++) {
        if (TRIM_TAPE_COLORS[ti].id === d.trimTape) { trimMatch = TRIM_TAPE_COLORS[ti]; break; }
      }
      if (trimMatch) {
        var allTrimZones = ['t1a','t1b','t2a','t2b','t3a','t3b','t4a','t4b','t6a','t6b','t7',
          't8atop','t8abot','t8aside1','t8aside2','t8btop','t8bbot','t8bside1','t8bside2','tstab','tlegr','tlegl'];
        allTrimZones.forEach(function (z) { colorMap['trim:' + z] = trimMatch.id; });
      }
    }

    // 3. Harness webbing
    if (d.harnessWebbing) {
      colorMap['harness:harness'] = d.harnessWebbing;
    }

    // 4. Piping
    if (d.pipingEnabled) {
      state.centerFlapPiping = true;
      var pipColor = d.pipingColor || d.trimTape || 'black';
      ['pb','pc','pd','pe','pf','pg'].forEach(function (z) { colorMap['piping:' + z] = pipColor; });
    } else {
      state.centerFlapPiping = false;
    }

    state.containerColorMap = colorMap;

    // 5. Contrast stitching
    if (typeof d.contrastStitch === 'boolean') state.contrastStitch = d.contrastStitch;
    if (d.stitchColor) state.stitchColor = d.stitchColor;

    // 6. JC stitching
    if (typeof d.jcStitching === 'boolean') state.jcStitching = d.jcStitching;
    if (d.jcColor) state.jcColor = d.jcColor;

    // 7. Hardware finish
    if (d.hardwareFinish === 'black' || d.hardwareFinish === 'standard') {
      state.hardwareFinish = d.hardwareFinish;
    }

    // 8. Embroidery — use per-side EMB_LOGOS for correct index mapping
    var VCP = window.VectorColorPopup;
    var emb = d.embroidery || [];
    if (emb.length && VCP && VCP.EMB_LOGOS) {
      var v2 = {
        currentLogoIndex: {},
        logoColors: {},
        customNames: {},
        customFontStyle: {},
        angle45: {}
      };
      var perSideLogos = VCP.EMB_LOGOS;

      // Position→sides mapping (some positions have 2 mirror sides)
      var posSidesMap = {
        yoke: ['yk'], swalls: ['sw', 'swr'], rcovers: ['rc', 'rcr'],
        handles: ['hcut', 'hres'], backpad: ['bp'], reserveflap: ['rf']
      };

      emb.forEach(function (e) {
        var pos = e.position;
        if (!pos) return;
        var sides = posSidesMap[pos] || [pos];

        sides.forEach(function (side) {
          var sideLogos = perSideLogos[side];
          if (!sideLogos) return;

          if (e.type === 'logo' && e.logoId) {
            // Find logo in the per-side array by matching name prefix
            for (var li = 0; li < sideLogos.length; li++) {
              var logoName = sideLogos[li].name;
              // Match: logoId 'v3hd' matches 'v3hd_yh', 'v3hd_s', 'v3hd_r' etc.
              if (logoName === e.logoId || logoName.indexOf(e.logoId + '_') === 0 ||
                  logoName.indexOf(e.logoId) === 0) {
                v2.currentLogoIndex[side] = li;
                if (e.colors && e.colors.length) {
                  v2.logoColors[side] = {};
                  e.colors.forEach(function (c, ci) {
                    v2.logoColors[side][ci + 1] = c;
                  });
                }
                break;
              }
            }
          } else if (e.type === 'custom_logo' && e.logoUrl) {
            // Find custom_logo entry in per-side logos
            for (var cli = 0; cli < sideLogos.length; cli++) {
              if (sideLogos[cli].isCustomLogo) {
                v2.currentLogoIndex[side] = cli;
                break;
              }
            }
            // Set the logo URL into embCustomLogos state for rendering
            if (!state.embCustomLogos) state.embCustomLogos = {};
            state.embCustomLogos[side] = { dataUrl: e.logoUrl, rotation: 0 };
          } else if (e.type === 'custom' && e.text) {
            // Find custom_name entry in per-side logos
            for (var ci = 0; ci < sideLogos.length; ci++) {
              if (sideLogos[ci].isCustomName) {
                v2.currentLogoIndex[side] = ci;
                break;
              }
            }
            // 3-line sides (rc, rcr, bp, rf) need {line1, line2, line3} object
            if (side === 'rc' || side === 'rcr' || side === 'bp' || side === 'rf') {
              var lines = (e.text || '').split('\n');
              v2.customNames[side] = { line1: lines[0] || '', line2: lines[1] || '', line3: lines[2] || '' };
            } else {
              v2.customNames[side] = e.text;
            }
            v2.customFontStyle[side] = e.font || 'block';
            if (e.color) {
              v2.logoColors[side] = { 1: e.color };
            }
          }
        });
      });

      if (!state.containerEmbroidery) state.containerEmbroidery = {};
      state.containerEmbroidery._v2 = v2;

      // Sync VCP internal state so rig preview shows correct embroidery
      if (VCP && VCP.syncEmbroideryFromV2) VCP.syncEmbroideryFromV2(v2);
    }

    // Sync UI checkboxes
    var hwRadios = document.querySelectorAll('input[name="vc-hardwareFinish"]');
    for (var ri = 0; ri < hwRadios.length; ri++) {
      if (hwRadios[ri].value === state.hardwareFinish) hwRadios[ri].checked = true;
    }

    // Re-render and save
    renderTrimPickers();
    renderColorPreview();
    saveState();
    state.selectedDesignIndex = -1; // AI always creates in a new empty slot
    saveDesignToSlot('AI Design ' + (state.savedDesigns.length + 1));

    // Visual feedback
    var applyBtn = $('vc-ai-apply');
    if (applyBtn) {
      applyBtn.textContent = 'Applied!';
      applyBtn.disabled = true;
      setTimeout(function () {
        applyBtn.textContent = 'Apply to Container';
        applyBtn.disabled = false;
      }, 2000);
    }
  }

  function isLightColor(hex) {
    var c = hex.replace('#', '');
    if (c.length === 3) c = c[0] + c[0] + c[1] + c[1] + c[2] + c[2];
    var r = parseInt(c.substr(0, 2), 16);
    var g = parseInt(c.substr(2, 2), 16);
    var b = parseInt(c.substr(4, 2), 16);
    return (r * 299 + g * 587 + b * 114) / 1000 > 160;
  }

  /* ================================================================
     AI DESIGNER POPUP
     ================================================================ */
  // Abort signal for popup-scoped listeners; aborted on close so any pending
  // work (fetches, timers, etc.) can no-op instead of writing into a dead overlay.
  var aiPopupAbort = null;

  function openAIDesignerPopup() {
    // Remove any existing popup (also cancel its listeners)
    var existing = document.getElementById('vc-ai-popup-overlay');
    if (existing) existing.remove();
    if (aiPopupAbort) { try { aiPopupAbort.abort(); } catch (e) { /* silent */ } }
    aiPopupAbort = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var signal = aiPopupAbort ? aiPopupAbort.signal : undefined;

    var overlay = document.createElement('div');
    overlay.id = 'vc-ai-popup-overlay';
    overlay.className = 'vc-ai-popup-overlay';
    overlay.innerHTML =
      '<div class="vc-ai-popup">' +
        '<div class="vc-ai-popup-header">' +
          '<div class="vc-ai-popup-header-left">' +
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>' +
            '<h3 class="vc-ai-popup-title">AI Design Engine</h3>' +
            '<span class="vc-optional-badge">Beta</span>' +
          '</div>' +
          '<button type="button" class="vc-ai-popup-close" id="vc-ai-popup-close">&times;</button>' +
        '</div>' +

        '<div class="vc-ai-popup-body">' +
          '<label class="vc-ai-popup-label">Describe the look you want</label>' +
          '<textarea id="vc-ai-prompt" class="vc-ai-popup-textarea" maxlength="1000" rows="4" placeholder="e.g. Bold royal blue body with a neon orange yoke, white trim tape, black harness, gold embroidery \'SKYDIVE\' on the sidewalls..."></textarea>' +
          '<div class="vc-ai-popup-char-counter"><span id="vc-ai-char-count">0</span> / 1,000</div>' +

          '<div class="vc-ai-popup-actions">' +
            '<button type="button" class="vc-ai-popup-generate-btn" id="vc-ai-generate">' +
              '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10"/></svg>' +
              ' Generate Design' +
            '</button>' +
            '<button type="button" class="vc-ai-popup-regen-btn" id="vc-ai-regenerate" style="display:none;">' +
              '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/></svg>' +
              ' Regenerate' +
            '</button>' +
          '</div>' +

          '<div class="vc-ai-popup-loading" id="vc-ai-loading" style="display:none;">' +
            '<div class="vc-ai-spinner"></div>' +
            '<span>Generating your design\u2026</span>' +
            '<span style="font-size:12px;opacity:0.7;margin-top:6px;">This can take up to a minute</span>' +
          '</div>' +
          '<div class="vc-ai-popup-error" id="vc-ai-error" style="display:none;"></div>' +
          '<div class="vc-ai-popup-result" id="vc-ai-result" style="display:none;">' +
            '<div id="vc-ai-description"></div>' +
          '</div>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);

    // Bind events (all scoped to aiPopupAbort so they auto-remove on close)
    var listenerOpts = signal ? { signal: signal } : undefined;

    var closeBtn = document.getElementById('vc-ai-popup-close');
    closeBtn.addEventListener('click', closeAIPopup, listenerOpts);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeAIPopup();
    }, listenerOpts);

    var promptEl = document.getElementById('vc-ai-prompt');
    var charCount = document.getElementById('vc-ai-char-count');
    if (promptEl && charCount) {
      promptEl.addEventListener('input', function () { charCount.textContent = this.value.length; }, listenerOpts);
      promptEl.focus();
    }

    var genBtn = document.getElementById('vc-ai-generate');
    var regenBtn = document.getElementById('vc-ai-regenerate');
    if (genBtn) genBtn.addEventListener('click', handleAIGenerate, listenerOpts);
    if (regenBtn) regenBtn.addEventListener('click', handleAIGenerate, listenerOpts);

    // Prevent body scroll
    document.body.style.overflow = 'hidden';
  }

  function closeAIPopup() {
    var overlay = document.getElementById('vc-ai-popup-overlay');
    if (overlay) overlay.remove();
    if (aiPopupAbort) { try { aiPopupAbort.abort(); } catch (e) { /* silent */ } aiPopupAbort = null; }
    document.body.style.overflow = '';
  }

  function handleAIGenerate() {
    var promptEl = document.getElementById('vc-ai-prompt');
    var loadingEl = document.getElementById('vc-ai-loading');
    var errorEl = document.getElementById('vc-ai-error');
    var resultEl = document.getElementById('vc-ai-result');
    var regenBtn = document.getElementById('vc-ai-regenerate');
    var genBtn = document.getElementById('vc-ai-generate');

    if (!promptEl || !promptEl.value.trim()) {
      if (errorEl) { errorEl.textContent = 'Please describe a color design first.'; errorEl.style.display = ''; }
      return;
    }

    if (loadingEl) loadingEl.style.display = '';
    if (errorEl) errorEl.style.display = 'none';
    if (resultEl) resultEl.style.display = 'none';
    if (genBtn) genBtn.disabled = true;
    if (regenBtn) regenBtn.disabled = true;

    callGeminiAPI(promptEl.value.trim(), function (result) {
      if (loadingEl) loadingEl.style.display = 'none';
      if (genBtn) genBtn.disabled = false;
      if (regenBtn) regenBtn.disabled = false;

      if (result.error) {
        if (errorEl) { errorEl.textContent = result.error; errorEl.style.display = ''; }
      } else {
        // Show result in popup
        if (resultEl) {
          resultEl.style.display = '';
          var descEl = document.getElementById('vc-ai-description');
          if (descEl) {
            descEl.innerHTML =
              '<h4 class="vc-ai-popup-design-name">' + escHtml(result.data.name || 'AI Design') + '</h4>' +
              '<p class="vc-ai-popup-design-desc">' + escHtml(result.data.description || '') + '</p>';
          }
        }
        if (regenBtn) regenBtn.style.display = '';

        // Auto-apply and close popup
        lastAIDesign = result.data;
        applyAIDesignToRig();

        // Close AI popup after brief delay, then open Color Designer with AI colors loaded
        setTimeout(function () {
          closeAIPopup();
          // Open the Color Designer popup so the user can review/adjust and save
          setTimeout(function () {
            openColorDesignerPopup();
          }, 300);
        }, 1200);
      }
    });
  }

  /* ================================================================
     STAGE 7: EMBROIDERY RENDERING
     ================================================================ */
  function renderEmbroidery() {
    var list = $('vc-embroidery-list');
    if (!list) return;
    list.innerHTML = '';
    state.embroidery.forEach(function (loc, idx) {
      var item = document.createElement('div');
      item.className = 'vc-embroidery-item' + (loc.enabled ? ' active' : '');
      item.dataset.index = idx;
      item.innerHTML =
        '<label class="vc-embroidery-header">' +
          '<input type="checkbox"' + (loc.enabled ? ' checked' : '') + ' data-emb-idx="' + idx + '"> ' +
          loc.label +
        '</label>' +
        '<div class="vc-embroidery-input">' +
          '<input type="text" placeholder="Text or design\u2026" value="' + (loc.text || '') + '" data-emb-text="' + idx + '">' +
        '</div>';
      list.appendChild(item);
    });
  }

  /* ================================================================
     SUMMARY
     ================================================================ */
  function renderSummary() {
    var html = '';

    // Shared configuration banner
    if (state.isSharedConfig) {
      html += '<div class="vc-shared-banner">';
      html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20"><path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>';
      html += '<div><strong>Shared Configuration</strong><br>You\'re viewing someone\'s custom UPT Vector 3 rig design.</div>';
      html += '<button type="button" class="vc-shared-banner-btn" onclick="window.location.href=window.location.pathname">Start Your Own</button>';
      html += '</div>';
    }

    // Stage 1
    var previousVectorSerial = getPreviousVectorSerial();
    var measRows;
    if (previousVectorSerial) {
      measRows = [row('Previous Vector S/N', previousVectorSerial)];
      html += summarySection('Previous Vector Measurements', measRows);
    } else {
      measRows = [
        row('Total Jumps', state.jumpCount || state.jumpCount === 0 ? String(state.jumpCount) : '—'),
        row('Canopy Courses', String(state.canopyCourses || 0)),
        row('DZ Altitude', (state.dzAltitude || 0) + ' ' + (state.dzAltUnit || 'm')),
        row('Height', val(state.height, 'cm')),
        row('Weight', val(state.weight, 'kg')),
        row('Chest', val(state.chest, 'cm')),
        row('Waist', val(state.waist, 'cm')),
        row('Torso (ASIS)', val(state.torso, 'cm')),
        row('Leg Pad', val(state.legPad, 'cm')),
        row('Inseam', val(state.inseam, 'cm')),
        row('Sex', state.sex || 'Male')
      ];
      html += summarySection('Body Measurements', measRows);
    }

    // Stage 2
    var patData = PATTERNS[state.pattern] || {};
    var patLabel = patData.name || state.pattern;
    var freePatterns = ['standard', 'v-split', 'tri-v-split', 'full-custom'];
    if (freePatterns.indexOf(state.pattern) === -1) patLabel += ' (+' + formatContainerPrice(SURCHARGES.pattern) + ')';
    if (state.pattern === 'full-custom') patLabel += ' (Included)';
    var colorRows = [row('Pattern', patLabel)];
    (state.zoneColors || []).forEach(function (c, i) {
      colorRows.push(row((patData.zones || [])[i] || 'Zone ' + (i + 1), colorName(c)));
    });
    // Advanced color designer zones (if used)
    try {
      if (state.containerColorMap && Object.keys(state.containerColorMap).length > 0 && window.VectorColorPopup) {
        var zoneKeys = window.VectorColorPopup.ALL_ZONE_IDS || [];
        var zoneCount = 0;
        zoneKeys.forEach(function (zid) {
          if (state.containerColorMap[zid]) {
            var cObj = window.VectorColorPopup.colorById(state.containerColorMap[zid]);
            colorRows.push(row('Zone ' + zid, cObj ? cObj.sc : state.containerColorMap[zid]));
            zoneCount++;
          }
        });
        if (zoneCount > 0) colorRows.push(row('Zones Colored', String(zoneCount)));
      }
    } catch (e) { /* safe */ }
    colorRows.push(row('Binding Tape', colorName(state.bindingColor)));
    colorRows.push(row('Webbing', colorName(state.webbingColor)));
    if (state.contrastStitch) colorRows.push(row('Contrast Stitching', colorName(state.stitchColor)));
    // Container Design section hidden — design preview above covers this visually
    // html += summarySection('Container Design', colorRows);

    // Stage 3
    var harnessRows = [
      row('Harness', labelFromId(state.harnessType)),
      row('Leg Pads', labelFromId(state.legPadConfig))
    ];
    if (state.rolledEdge) harnessRows.push(row('Rolled Edge', 'Yes'));
    if (state.minus2) harnessRows.push(row('-2" Off The Top', 'Yes'));
    if (state.legPadCovers) harnessRows.push(row('Leg Pad Covers', 'Yes'));
    harnessRows.push(row('Backpad', labelFromId(state.backpad)));
    harnessRows.push(row('Stabilizers', capitalize(state.stabilizers)));
    html += summarySection('Harness & Comfort', harnessRows);

    // Stage 4
    var handleStr = labelFromId(state.mainHandle) || '—';
    var pcColorStr = '';
    if (state.pcHandleColor1 || state.pcHandleColor2) {
      var hcParts = [];
      if (state.pcHandleColor1) hcParts.push(state.pcHandleColor1);
      if (state.pcHandleColor2) hcParts.push(state.pcHandleColor2);
      pcColorStr = hcParts.join(' / ');
    }
    var deployRows = [
      row('P.C. Handle', handleStr),
      row('Main D-Bag', labelFromId(state.mainDBag)),
      row('Pilot Chute', state.pilotChuteFabric.toUpperCase() + ' / ' + labelFromId(state.pilotChuteSize)),
      row('Reserve Handle', labelFromId(state.reserveHandle)),
      row('Emergency', labelFromId(state.emergencySystem)),
      row('Risers', labelFromId(state.riserType)),
      row('Rings', labelFromId(state.ringType)),
      row('Riser Covers', labelFromId(state.riserCovers)),
      row('Riser Length', labelFromId(state.riserLength)),
      row('Toggles', labelFromId(state.toggleType)),
      row('Hook Knife', state.hookKnife === 'yes' ? 'Included' : 'None')
    ];
    if (pcColorStr) deployRows.splice(1, 0, row('Handle Colors', pcColorStr));
    html += summarySection('Deployment Systems', deployRows);

    // Stage 5 — canopy & AAD with price lookups
    var mainSize = state.mainCanopySize ? ' (' + state.mainCanopySize + ' sq ft)' : '';
    var reserveSize = state.reserveCanopySize ? ' (' + state.reserveCanopySize + ' sq ft)' : '';
    var containerLabel = state.containerSize ? 'UPT Vector ' + state.containerSize + (state.containerManual ? ' (manual)' : (state.containerFit ? ' (' + state.containerFit + ' fit)' : '')) : 'Not yet determined';

    // Look up product prices
    var mainCanopyPrice = '';
    if (state.includeMainCanopy && state.mainCanopyModel) {
      var mainProd = findShopifyProduct(state.mainCanopyModel, window.vcMainCanopyProducts);
      if (mainProd) {
        var mainVar = null;
        if (state.mainCanopySize && mainProd.variants) {
          var ms = String(state.mainCanopySize);
          for (var mi = 0; mi < mainProd.variants.length; mi++) {
            if (mainProd.variants[mi].size === ms || (mainProd.variants[mi].title && mainProd.variants[mi].title.indexOf(ms) !== -1)) { mainVar = mainProd.variants[mi]; break; }
          }
        }
        mainCanopyPrice = ' \u2014 ' + (mainVar ? mainVar.price_formatted : mainProd.price_formatted);
      }
    }
    var reserveCanopyPrice = '';
    if (state.includeReserveCanopy && state.reserveCanopyModel) {
      var resProd = findShopifyProduct(state.reserveCanopyModel, window.vcReserveCanopyProducts);
      if (resProd) {
        var resVar = null;
        if (state.reserveCanopySize && resProd.variants) {
          var rs = String(state.reserveCanopySize);
          for (var ri = 0; ri < resProd.variants.length; ri++) {
            if (resProd.variants[ri].size === rs || (resProd.variants[ri].title && resProd.variants[ri].title.indexOf(rs) !== -1)) { resVar = resProd.variants[ri]; break; }
          }
        }
        reserveCanopyPrice = ' \u2014 ' + (resVar ? resVar.price_formatted : resProd.price_formatted);
      }
    }
    var aadLabel = 'None selected';
    var aadPrice = '';
    if (state.aad) {
      var aadObj = AAD_OPTIONS.find(function (a) { return a.id === state.aad; });
      aadLabel = aadObj ? aadObj.name : '\u2014';
      var aadProd = findAADProduct(state.aad);
      if (aadProd) aadPrice = ' \u2014 ' + aadProd.price_formatted;
    }

    html += summarySection('Canopy & Sizing', [
      row('Main Canopy', !state.includeMainCanopy ? 'Already owned' : (state.mainCanopyModel ? (SHORT_MFG[state.mainCanopyBrand] || state.mainCanopyBrand || '') + ' \u2013 ' + state.mainCanopyModel + mainSize + mainCanopyPrice : '\u2014')),
      row('Reserve Canopy', !state.includeReserveCanopy ? 'Already owned' : (state.reserveCanopyModel ? (SHORT_MFG[state.reserveCanopyBrand] || state.reserveCanopyBrand || '') + ' \u2013 ' + state.reserveCanopyModel + reserveSize + reserveCanopyPrice : '\u2014')),
      row('Container Size', containerLabel),
      row('AAD', aadLabel + aadPrice)
    ]);

    // Stage 6
    if (state.isWingsuit) {
      var wsItems = [];
      if (state.wsDynamicCorners) wsItems.push('Dynamic Corners');
      if (state.wsBridle) wsItems.push('WS Pilot Chute & Bridle');
      if (state.wsSemiStowless) wsItems.push('U-Stow Semi-Stowless D-Bag');
      if (state.wsDash1Shape) wsItems.push('DASH-1 Container Shape');
      html += summarySection('Wingsuit Pack', [row('Features', wsItems.join(', ') || 'None selected')]);
    }

    // Stage 7
    var hw = state.hardwareFinish === 'black' ? 'Black Hardware' : 'Standard (Stainless/Nickel)';
    var embRows = [row('Hardware', hw)];
    if (state.jcStitching) embRows.push(row('JC Stitching', 'Yes (' + colorName(state.jcColor || 'em-black') + ')'));
    if (state.contrastStitch) embRows.push(row('Contrast Stitching', 'Yes (' + colorName(state.stitchColor || 'em-black') + ')'));
    if (state.centerFlapPiping) embRows.push(row('Center Flap Piping', 'Yes'));
    // V2 embroidery summary
    if (state.containerEmbroidery && state.containerEmbroidery._v2 && window.VectorColorPopup) {
      var _embV2 = state.containerEmbroidery._v2;
      var _VCP_L = window.VectorColorPopup.EMB_LOGOS || {};
      var _SIDE_N = { yk:'Yoke', sw:'Side Wall L', swr:'Side Wall R', rc:'Ring Cover L', rcr:'Ring Cover R', hcut:'Cutaway Handle', hres:'Reserve Handle', bp:'Back Pad', rf:'Reserve Flap' };
      Object.keys(_embV2.currentLogoIndex || {}).forEach(function(side) {
        var logos = _VCP_L[side];
        if (!logos) return;
        var logo = logos[_embV2.currentLogoIndex[side]];
        if (!logo || logo.name === 'none') return;
        embRows.push(row('Embroidery — ' + (_SIDE_N[side] || side), logo.name));
      });
    } else {
      state.embroidery.forEach(function (loc) {
        if (loc.enabled) embRows.push(row(loc.label, loc.text || '(design TBD)'));
      });
    }
    html += summarySection('Cosmetic & Hardware', embRows);

    // Special Instructions (if filled)
    if (state.specialInstructions) {
      html += summarySection('Special Instructions', [row('', state.specialInstructions)]);
    }

    dom.summaryContent.innerHTML = html;

    // Build full price breakdown
    var priceLines = [];

    // Base rig
    priceLines.push({ label: 'UPT Vector 3 Container', amount: getLocalizedBasePrice() });

    // Itemized surcharges
    var surchargeItems = getSurchargeBreakdown();
    for (var si = 0; si < surchargeItems.length; si++) {
      priceLines.push({
        label: surchargeItems[si].label,
        amount: localizeContainerPrice(surchargeItems[si].amount)
      });
    }

    // Main canopy
    if (state.includeMainCanopy && state.mainCanopyModel) {
      var _mp = findShopifyProduct(state.mainCanopyModel, window.vcMainCanopyProducts);
      if (_mp) {
        var _mv = null;
        if (state.mainCanopySize && _mp.variants) {
          var _ms = String(state.mainCanopySize);
          for (var _mi = 0; _mi < _mp.variants.length; _mi++) {
            if (_mp.variants[_mi].size === _ms || (_mp.variants[_mi].title && _mp.variants[_mi].title.indexOf(_ms) !== -1)) { _mv = _mp.variants[_mi]; break; }
          }
        }
        var mainPrice = (_mv && _mv.price) ? _mv.price : (_mp.price || 0);
        priceLines.push({ label: 'Main Canopy — ' + state.mainCanopyModel, amount: mainPrice });
      }
    }

    // Reserve canopy
    if (state.includeReserveCanopy && state.reserveCanopyModel) {
      var _rp = findShopifyProduct(state.reserveCanopyModel, window.vcReserveCanopyProducts);
      if (_rp) {
        var _rv = null;
        if (state.reserveCanopySize && _rp.variants) {
          var _rs = String(state.reserveCanopySize);
          for (var _ri = 0; _ri < _rp.variants.length; _ri++) {
            if (_rp.variants[_ri].size === _rs || (_rp.variants[_ri].title && _rp.variants[_ri].title.indexOf(_rs) !== -1)) { _rv = _rp.variants[_ri]; break; }
          }
        }
        var resPrice = (_rv && _rv.price) ? _rv.price : (_rp.price || 0);
        priceLines.push({ label: 'Reserve Canopy — ' + state.reserveCanopyModel, amount: resPrice });
      }
    }

    // AAD
    if (state.aad) {
      var _ap = findAADProduct(state.aad);
      if (_ap && _ap.price) priceLines.push({ label: 'AAD — ' + state.aad, amount: _ap.price });
    }

    // Calculate total
    var grandTotal = 0;
    for (var pi = 0; pi < priceLines.length; pi++) grandTotal += priceLines[pi].amount;
    var deposit = Math.ceil(grandTotal * 0.25);

    // Build HTML
    var ph = '<div class="vc-price-title">Price Estimate <span style="font-size:13px;font-weight:400;opacity:0.7;margin-left:8px;">Lead time 24+ weeks</span></div>';
    ph += '<div class="vc-price-lines">';
    for (var pl = 0; pl < priceLines.length; pl++) {
      var isBase = (pl === 0);
      ph += '<div class="vc-price-line' + (isBase ? ' vc-price-line-base' : '') + '">' +
        '<span>' + priceLines[pl].label + '</span>' +
        '<span>' + formatMoney(priceLines[pl].amount) + '</span>' +
      '</div>';
    }
    // Promotion: Black Hardware free (48h countdown)
    if (state.hardwareFinish === 'black') {
      var bhSaved = localizeContainerPrice(SURCHARGES['black-hardware']);
      var timerSpan = '<span class="vc-price-promo-timer" id="vc-price-hw-timer"></span>';
      ph += '<div class="vc-price-line vc-price-line-promo">' +
        '<span>Black Hardware <span class="vc-price-promo-tag">PROMO</span> ' + timerSpan + '</span>' +
        '<span><s class="vc-price-was">' + formatMoney(bhSaved) + '</s> FREE</span>' +
      '</div>';
    }
    ph += '</div>';
    ph += '<div class="vc-price-total">' +
      '<span>Total</span><span>' + formatMoney(grandTotal) + '</span>' +
    '</div>';
    ph += '<div class="vc-price-deposit">' +
      '<span>Deposit (25%)</span><span>' + formatMoney(deposit) + '</span>' +
    '</div>';
    dom.priceEstimate.innerHTML = ph;

    // Show the info bar (kept for confirm button visibility logic)
    var infoBar = dom.container.querySelector('.vc-summary-info-bar');
    if (infoBar) infoBar.style.display = '';

    // Render design preview(s) above the summary
    renderSummaryDesignPreview();

    // Update design confirmation card
    updateDesignConfirmCard();
  }

  function renderSummaryDesignPreview() {
    var container = document.getElementById('vc-summary-design-preview');
    if (!container) return;
    container.innerHTML = '';

    // Auto-create a design from current state if none saved yet
    if (!state.savedDesigns || state.savedDesigns.length === 0) {
      var autoMap = state.containerColorMap && Object.keys(state.containerColorMap).length > 0
        ? JSON.parse(JSON.stringify(state.containerColorMap))
        : null;
      // Build colorMap from zoneColors + PATTERN_ZONE_MAP if popup was never used
      if (!autoMap && state.zoneColors && state.zoneColors.length > 0) {
        autoMap = {};
        var patZones = PATTERN_ZONE_MAP[state.pattern || 'standard'] || [];
        patZones.forEach(function (group) {
          var color = state.zoneColors[group.idx] || 'black';
          group.ids.forEach(function (id) { autoMap[id] = color; });
        });
        // Also add trim tape and webbing zones
        var trimIds = ['t1a','t1b','t2a','t2b','t3a','t3b','t4','t5','t6a','t6b','t7'];
        trimIds.forEach(function (id) { if (state.bindingColor) autoMap['trim:' + id] = state.bindingColor; });
        if (state.webbingColor) {
          ['hw1','hw2','hw3','hw4','hw5','hw6'].forEach(function (id) { autoMap['harness:' + id] = state.webbingColor; });
        }
      }
      if (autoMap && Object.keys(autoMap).length > 0) {
        state.savedDesigns = [{
          pattern: state.pattern || 'standard',
          colorMap: autoMap,
          bindingColor: state.bindingColor,
          name: 'Design 1',
          timestamp: Date.now()
        }];
        state.selectedDesignIndex = 0;
        saveState();
      }
    }
    if (!state.savedDesigns || state.savedDesigns.length === 0) return;

    var VCP = window.VectorColorPopup;
    var lookupColor = VCP ? VCP.colorById : function (id) { return findColorObjById(id); };
    var urls = window.VCP_RIG_SVG_URLS || {};
    var pNames = {
      'standard':'Standard','half-and-half':'Half & Half','diagonal':'Diagonal',
      'v-split':'V-Split','tri-v-split':'Tri-color V-Split','triple-v-split':'Triple V-Split',
      'lightning':'Lightning Split','triple-lightning':'Triple Lightning','zigzag':'Zig-zag'
    };

    // Design selector buttons + edit button bar
    var btnBar = document.createElement('div');
    btnBar.className = 'vc-summary-design-btns';
    if (state.savedDesigns.length > 1) {
      state.savedDesigns.forEach(function (design, idx) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'vc-summary-design-btn' + (idx === state.selectedDesignIndex ? ' active' : '');
        btn.textContent = design.name || ('Design ' + (idx + 1));
        btn.addEventListener('click', function () {
          selectDesign(idx);
          renderSummary();
        });
        btnBar.appendChild(btn);
      });
    }
    container.appendChild(btnBar);

    // Show only the selected design's preview
    var selIdx = state.selectedDesignIndex || 0;
    if (selIdx >= state.savedDesigns.length) selIdx = 0;
    var design = state.savedDesigns[selIdx];
    if (!design) return;

    var card = document.createElement('div');
    card.className = 'vc-summary-preview-card';

    // Header: design name + pattern
    var header = document.createElement('div');
    header.className = 'vc-summary-preview-header';
    header.innerHTML = '<strong>' + escHtml(design.name || 'Design ' + (selIdx + 1)) + '</strong>' +
      '<span class="vc-summary-preview-pattern">' + escHtml(pNames[design.pattern] || design.pattern || '') + '</span>';
    card.appendChild(header);

    // Use captured PNGs when available (accurate screenshots from Color Designer)
    var viewLabels = { back: 'Back', front: 'Front', right: 'Right', left: 'Left' };
    var viewOrder = ['back', 'front', 'right', 'left'];
    var hasMultiView = design.previewPngs && (design.previewPngs.back || design.previewPngs.front);

    if (hasMultiView) {
      var viewsGrid = document.createElement('div');
      viewsGrid.className = 'vc-summary-preview-views';
      viewOrder.forEach(function (key) {
        var src = design.previewPngs[key];
        if (!src) return;
        var viewCard = document.createElement('div');
        viewCard.className = 'vc-summary-preview-view';
        var imgWrap = document.createElement('div');
        imgWrap.className = 'vc-summary-preview-img-wrap';
        var img = document.createElement('img');
        img.src = src;
        img.alt = viewLabels[key] + ' view';
        img.className = 'vc-summary-preview-img';
        imgWrap.appendChild(img);
        viewCard.appendChild(imgWrap);
        var label = document.createElement('div');
        label.className = 'vc-summary-preview-label';
        label.textContent = viewLabels[key];
        viewCard.appendChild(label);
        viewsGrid.appendChild(viewCard);
      });
      card.appendChild(viewsGrid);
    } else {
      // Fallback: render live SVG views when no PNGs available
      var summaryViewsId = 'vc-summary-views-' + selIdx;
      var svgGrid = document.createElement('div');
      svgGrid.className = 'vc-summary-preview-views vc-compare-views';
      svgGrid.id = summaryViewsId;
      card.appendChild(svgGrid);
    }

    container.appendChild(card);

    // Load SVG views only when no PNGs available
    if (!hasMultiView) {
      loadSummaryViews('vc-summary-views-' + selIdx, design.pattern, design.colorMap);
    }
  }

  function loadSummaryViews(containerId, pattern, colorMap) {
    var viewsEl = document.getElementById(containerId);
    if (!viewsEl) return;

    var svgUrls = window.VCP_RIG_SVG_URLS || {};
    var url = svgUrls[pattern || 'standard'] || window.VCP_RIG_SVG_URL;
    if (!url) return;

    var VCP = window.VectorColorPopup;
    var lookupColor = VCP ? VCP.colorById : function (id) { return findColorObjById(id); };

    function renderViews(svgMarkup) {
      viewsEl.innerHTML = '';
      var viewKeys = ['back', 'front', 'right', 'left'];
      viewKeys.forEach(function (key) {
        var viewCard = document.createElement('div');
        viewCard.className = 'vc-summary-preview-view';
        var svgWrap = document.createElement('div');
        svgWrap.className = 'vc-summary-preview-img-wrap';
        svgWrap.innerHTML = svgMarkup;
        var svg = svgWrap.querySelector('svg');
        if (svg) {
          svg.removeAttribute('width');
          svg.removeAttribute('height');
          svg.style.width = '100%';
          svg.style.height = 'auto';
          svg.setAttribute('viewBox', RIG_VIEWS[key].viewBox);
          applyColorsToSlotSvg(svg, colorMap, lookupColor, VCP);
        }
        viewCard.appendChild(svgWrap);
        var label = document.createElement('div');
        label.className = 'vc-summary-preview-label';
        label.textContent = RIG_VIEWS[key].label;
        viewCard.appendChild(label);
        viewsEl.appendChild(viewCard);
      });
    }

    if (rigPreviewCache[pattern || 'standard']) {
      renderViews(rigPreviewCache[pattern || 'standard']);
    } else {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4 || xhr.status !== 200) return;
        rigPreviewCache[pattern || 'standard'] = xhr.responseText;
        renderViews(xhr.responseText);
      };
      xhr.send();
    }
  }

  function summarySection(title, rows) {
    return '<div class="vc-summary-section"><h3>' + title + '</h3>' + rows.join('') + '</div>';
  }

  function row(label, value) {
    return '<div class="vc-summary-row"><span class="vc-summary-label">' + label + '</span><span class="vc-summary-value">' + value + '</span></div>';
  }

  function val(v, unit) {
    return v ? v + ' ' + unit : '—';
  }

  function calculateEstimate() {
    var total = 0;
    if (state.harnessType === 'vgh') total += SURCHARGES['vgh'];
    if (state.rolledEdge) total += SURCHARGES['rolled-edge'];
    if (state.legPadCovers) total += SURCHARGES['leg-pad-covers'];
    if (state.backpad === '3d-spacer') total += SURCHARGES['3d-spacer'];
    if (state.backpad === 'babylon') total += SURCHARGES['babylon'];
    if (state.stabilizers === 'padded') total += SURCHARGES['padded-stabilizers'];
    if (state.stabilizers === 'soft') total += SURCHARGES['soft-stabilizers'];
    if (state.reserveHandle === 'soft-pillow') total += SURCHARGES['reserve-soft-handle'];
    if (state.emergencySystem === 'rsl') total += SURCHARGES['rsl'];
    if (state.emergencySystem === 'skyhook') total += SURCHARGES['skyhook'];
    if (state.riserType === 'louie-loops') total += SURCHARGES['louie-loops'];
    if (state.riserType === 'low-drag-louie') total += SURCHARGES['low-drag-louie'];
    if (state.hookKnife === 'yes') total += SURCHARGES['hook-knife'];
    // Pilot chute handle surcharges (plastic-handle is included)
    if (state.mainHandle && SURCHARGES[state.mainHandle]) total += SURCHARGES[state.mainHandle];
    // Main D-Bag surcharges (standard is included)
    // Note: if wsSemiStowless is active and mainDBag is u-stow, we only charge once (via ws-semi-stowless below)
    if (state.mainDBag && SURCHARGES[state.mainDBag] && !(state.wsSemiStowless && state.mainDBag === 'u-stow')) total += SURCHARGES[state.mainDBag];
    // Black Hardware is FREE (promotion) — do not charge
    if (state.jcStitching) total += SURCHARGES['jc-stitching'];
    if (state.contrastStitch) total += SURCHARGES['contrast-stitching'];
    if (state.centerFlapPiping) total += SURCHARGES['center-flap-piping'];
    if (state.wsDynamicCorners) total += SURCHARGES['ws-dynamic-corners'];
    // WS Pilot Chute & Bridle is included at no extra cost
    if (state.wsSemiStowless) total += SURCHARGES['ws-semi-stowless'];
    var freePatterns = ['standard', 'v-split', 'tri-v-split', 'full-custom'];
    if (freePatterns.indexOf(state.pattern) === -1) total += SURCHARGES['pattern'];
    // Embroidery surcharges (per-side pricing, "none" = free)
    if (state.containerEmbroidery && state.containerEmbroidery._v2) {
      var embV2 = state.containerEmbroidery._v2;
      var VCP_L = window.VectorColorPopup ? window.VectorColorPopup.EMB_LOGOS : null;
      var embSidePrices = { yk: 0, sw: 39, swr: 39, rc: 24, rcr: 24, hcut: 24, hres: 24, bp: 24, rf: 39 };
      if (embV2.currentLogoIndex && VCP_L) {
        Object.keys(embV2.currentLogoIndex).forEach(function(side) {
          var sideLogos = VCP_L[side];
          if (!sideLogos) return;
          var logo = sideLogos[embV2.currentLogoIndex[side]];
          if (!logo || logo.name === 'none') return;
          if (embSidePrices[side]) total += embSidePrices[side];
        });
      }
    }
    return total;
  }

  /* ---- Itemized surcharge breakdown for price overview ---- */
  function getSurchargeBreakdown() {
    var items = [];
    function add(label, amount) { if (amount) items.push({ label: label, amount: amount }); }
    if (state.harnessType === 'vgh') add('Variable Geometry Harness', SURCHARGES['vgh']);
    if (state.rolledEdge) add('Rolled-edge Leg Pads', SURCHARGES['rolled-edge']);
    if (state.legPadCovers) add('Leg Pad Covers', SURCHARGES['leg-pad-covers']);
    if (state.backpad === '3d-spacer') add('3D Spacer Backpad', SURCHARGES['3d-spacer']);
    if (state.backpad === 'babylon') add('Babylon Backpad', SURCHARGES['babylon']);
    if (state.stabilizers === 'padded') add('Padded Stabilizers', SURCHARGES['padded-stabilizers']);
    if (state.stabilizers === 'soft') add('Soft Stabilizers', SURCHARGES['soft-stabilizers']);
    if (state.reserveHandle === 'soft-pillow') add('Soft Pillow Reserve Handle', SURCHARGES['reserve-soft-handle']);
    if (state.emergencySystem === 'rsl') add('RSL', SURCHARGES['rsl']);
    if (state.emergencySystem === 'skyhook') add('Skyhook', SURCHARGES['skyhook']);
    if (state.riserType === 'louie-loops') add('Louie Loops Risers', SURCHARGES['louie-loops']);
    if (state.riserType === 'low-drag-louie') add('Low-drag Louie Risers', SURCHARGES['low-drag-louie']);
    if (state.hookKnife === 'yes') add('Hook Knife', SURCHARGES['hook-knife']);
    // Pilot chute handle surcharges
    if (state.mainHandle && SURCHARGES[state.mainHandle]) add(labelFromId(state.mainHandle) + ' Handle', SURCHARGES[state.mainHandle]);
    // Main D-Bag surcharges (avoid double charge when WS semi-stowless sets u-stow)
    if (state.mainDBag && SURCHARGES[state.mainDBag] && !(state.wsSemiStowless && state.mainDBag === 'u-stow')) add(labelFromId(state.mainDBag) + ' D-Bag', SURCHARGES[state.mainDBag]);
    // Black Hardware handled as promotion (below)
    if (state.jcStitching) add('Jump Cycle Stitching', SURCHARGES['jc-stitching']);
    if (state.contrastStitch) add('Contrast Stitching', SURCHARGES['contrast-stitching']);
    if (state.centerFlapPiping) add('Center Flap Piping', SURCHARGES['center-flap-piping']);
    if (state.wsDynamicCorners) add('WS Dynamic Corners', SURCHARGES['ws-dynamic-corners']);
    if (state.wsSemiStowless) add('U-Stow Semi-stowless D-bag', SURCHARGES['ws-semi-stowless']);
    var freePatterns = ['standard', 'v-split', 'tri-v-split', 'full-custom'];
    if (freePatterns.indexOf(state.pattern) === -1) add('Premium Pattern (' + (PATTERN_NAMES[state.pattern] || state.pattern) + ')', SURCHARGES['pattern']);
    // Embroidery per-side
    if (state.containerEmbroidery && state.containerEmbroidery._v2) {
      var embV2 = state.containerEmbroidery._v2;
      var VCP_L = window.VectorColorPopup ? window.VectorColorPopup.EMB_LOGOS : null;
      var embSidePrices = { yk: 0, sw: 39, swr: 39, rc: 24, rcr: 24, hcut: 24, hres: 24, bp: 24, rf: 39 };
      var SIDE_NAMES = { yk: 'Yoke', sw: 'Side Wall L', swr: 'Side Wall R', rc: 'Ring Cover L', rcr: 'Ring Cover R', hcut: 'Cutaway Handle', hres: 'Reserve Handle', bp: 'Back Pad', rf: 'Reserve Flap' };
      if (embV2.currentLogoIndex && VCP_L) {
        Object.keys(embV2.currentLogoIndex).forEach(function(side) {
          var sideLogos = VCP_L[side];
          if (!sideLogos) return;
          var logo = sideLogos[embV2.currentLogoIndex[side]];
          if (!logo || logo.name === 'none') return;
          if (embSidePrices[side]) add('Embroidery — ' + (SIDE_NAMES[side] || side), embSidePrices[side]);
        });
      }
    }
    return items;
  }

  /* ---- Calculate full rig total (surcharges + canopies + AAD) ---- */
  function calculateTotal() {
    var total = getLocalizedBasePrice() + localizeContainerPrice(calculateEstimate()); // localized container + surcharges

    // Main canopy price
    if (state.includeMainCanopy && state.mainCanopyModel) {
      var mp = findShopifyProduct(state.mainCanopyModel, window.vcMainCanopyProducts);
      if (mp) {
        var mv = null;
        if (state.mainCanopySize && mp.variants) {
          for (var i = 0; i < mp.variants.length; i++) {
            if (mp.variants[i].size === state.mainCanopySize || (mp.variants[i].title && mp.variants[i].title.indexOf(state.mainCanopySize) !== -1)) {
              mv = mp.variants[i]; break;
            }
          }
        }
        total += (mv && mv.price) ? mv.price : (mp.price || 0);
      }
    }

    // Reserve canopy price
    if (state.includeReserveCanopy && state.reserveCanopyModel) {
      var rp = findShopifyProduct(state.reserveCanopyModel, window.vcReserveCanopyProducts);
      if (rp) {
        var rv = null;
        if (state.reserveCanopySize && rp.variants) {
          for (var j = 0; j < rp.variants.length; j++) {
            if (rp.variants[j].size === state.reserveCanopySize || (rp.variants[j].title && rp.variants[j].title.indexOf(state.reserveCanopySize) !== -1)) {
              rv = rp.variants[j]; break;
            }
          }
        }
        total += (rv && rv.price) ? rv.price : (rp.price || 0);
      }
    }

    // AAD price
    if (state.aad) {
      var ap = findAADProduct(state.aad);
      if (ap && ap.price) total += ap.price;
    }

    return total;
  }

  /* ---- DESIGN CONFIRMATION CARD ---- */
  function updateDesignConfirmCard() {
    var confirmBtn = document.getElementById('vc-design-confirm-btn');
    var ctasWrap = document.querySelector('.vc-summary-ctas');
    var card = document.getElementById('vc-design-confirm');
    if (!card) return;

    // Always reset generating state (may have been stuck from previous session)
    card.classList.remove('vc-generating');

    // Reflect current confirm state
    card.classList.toggle('vc-confirmed', !!state.designConfirmed);
    if (confirmBtn) {
      var textEl = confirmBtn.querySelector('.vc-design-confirm-text');
      if (textEl) textEl.textContent = state.designConfirmed
        ? 'Design confirmed — you\'re all set!'
        : 'Confirm Design & Get Price Estimate';
    }
    // Disable/enable CTAs based on confirmation
    if (ctasWrap) {
      ctasWrap.classList.toggle('vc-ctas-locked', !state.designConfirmed);
    }
    // Show/hide pricing sections based on confirmation
    var infoBar = document.getElementById('vc-summary-info-bar');
    if (infoBar) infoBar.style.display = state.designConfirmed ? '' : 'none';
    if (dom.priceEstimate) dom.priceEstimate.style.display = state.designConfirmed ? '' : 'none';

    // Hide contact form if already captured
    var contactSection = document.getElementById('vc-confirm-contact');
    if (contactSection) {
      contactSection.style.display = state.contactCaptured ? 'none' : '';
    }
  }

  /* ================================================================
     UPT ORDER DATA BUILDER
     Converts full configurator state → flat UPT-format object
     matching their official order form / VOS system exactly.
     ================================================================ */
  function buildUPTOrderData() {
    var VCP = window.VectorColorPopup;
    var lookupSC = function (colorId) {
      if (!colorId) return 'BLK';
      // For trim/harness/embroidery prefixed IDs, strip prefix and look up cordura SC
      var base = colorId.replace(/^(hw-|tt-|em-)/, '');
      // Check embroidery thread shortcodes first
      if (UPT_MAP.threadSC[colorId]) return UPT_MAP.threadSC[colorId];
      // Check VCP color lookup
      if (VCP && VCP.colorById) {
        var c = VCP.colorById(colorId);
        if (c && c.sc) return c.sc;
        // Try base ID for hw-/tt- prefixed
        c = VCP.colorById(base);
        if (c && c.sc) return c.sc;
      }
      // Fallback: capitalize the base name
      return base.toUpperCase().substring(0, 3);
    };

    var design = (state.savedDesigns && state.savedDesigns[state.selectedDesignIndex]) || {};
    var colorMap = design.colorMap || state.containerColorMap || {};
    var pattern = design.pattern || state.pattern || 'standard';

    // Container model
    var containerModel = state.containerSize || 'TBD';

    // Container parts — iterate in pattern-aware zone order
    var zoneOrder = getContainerZoneOrder(pattern);
    var containerParts = {};
    zoneOrder.forEach(function (zid) {
      var uptName = UPT_MAP.zones[zid];
      // Rename base panels when split partner exists
      if (zid === 'c2' && zoneOrder.indexOf('c2b') !== -1) uptName = '2A';
      if (zid === 'c4' && zoneOrder.indexOf('c4b') !== -1) uptName = '4A';
      containerParts[uptName] = lookupSC(colorMap[zid]);
    });

    // Leg pads (cordura)
    var legPads = {
      'Right': lookupSC(colorMap['rpad']),
      'Left':  lookupSC(colorMap['lpad'])
    };

    // Trim tape
    var trimTape = {};
    UPT_MAP.trimOrder.forEach(function (tid) {
      var uptName = UPT_MAP.trim[tid];
      trimTape[uptName] = lookupSC(colorMap[tid]);
    });

    // Leg pad trim
    var legPadTrim = {
      'T Right': lookupSC(colorMap['tlegr']),
      'T Left':  lookupSC(colorMap['tlegl'])
    };

    // Center flap
    var centerFlap = {};
    UPT_MAP.flapOrder.forEach(function (fid) {
      if (colorMap[fid]) {
        centerFlap[UPT_MAP.flaps[fid]] = lookupSC(colorMap[fid]);
      }
    });

    // Embroidery — map V2 state to UPT format (structured data for PDF swatches)
    var embroidery = [];
    var embData = (design.embroidery && design.embroidery._v2) || (state.containerEmbroidery && state.containerEmbroidery._v2) || null;
    var VCP_LOGOS = (VCP && VCP.EMB_LOGOS) || {};
    // Readable logo name mapping
    var LOGO_DISPLAY = {
      'mi': 'MI Logo', 'mi_yh': 'MI Logo', 'mi_s': 'MI Logo', 'mi_outline': 'MI Outline',
      'mi_outline_s': 'MI Outline', 'mia_r': 'MI-A Logo',
      'v3hd': 'V3HD Logo', 'v3hd_yh': 'V3HD Logo', 'v3hd_s': 'V3HD Logo',
      'v3hd_r': 'V3HD Logo', 'v3hd2_r': 'V3HD-2 Logo',
      'v3hd_outline_s': 'V3HD Outline', 'v3hd_outline_r': 'V3HD Outline',
      'v3hd_large': 'V3HD Large', 'msv3_s': 'MSV3 Logo',
      'whcl_r': 'Wing Hook (L)', 'whcr_r': 'Wing Hook (R)',
      'whol_r': 'Wing Outline (L)', 'whor_r': 'Wing Outline (R)',
      'whol2_r': 'Wing Outline-2 (L)', 'whor2_r': 'Wing Outline-2 (R)',
      '3r_r': '3-Ring Logo', '3r_yh': '3-Ring Logo',
      'custom_name_s': 'Custom Text', 'custom_name_r': 'Custom Text',
      'custom_name_yh': 'Custom Text',
      'custom_logo_s': 'Custom Logo', 'custom_logo_r': 'Custom Logo'
    };
    var embAngle45Note = false;
    UPT_MAP.embSideOrder.forEach(function (side) {
      var uptLabel = UPT_MAP.embPositions[side];
      if (!embData) {
        embroidery.push({ position: uptLabel, rawLogoId: 'none', logoName: 'none', colorSCs: [] });
        return;
      }
      var logoIdx = (embData.currentLogoIndex && embData.currentLogoIndex[side]) || 0;
      var logos = VCP_LOGOS[side];
      var logoName = 'none';
      var logoColorCount = 0;
      if (logos && logos[logoIdx]) {
        logoName = logos[logoIdx].name || 'none';
        logoColorCount = logos[logoIdx].colors || 0;
      }
      if (logoName === 'none') {
        embroidery.push({ position: uptLabel, rawLogoId: 'none', logoName: 'none', colorSCs: [] });
        return;
      }
      // Thread colors — only take the number of slots this logo actually uses
      var colorsObj = (embData.logoColors && embData.logoColors[side]) || {};
      var colorSCs = [];
      for (var ci = 1; ci <= logoColorCount; ci++) {
        var c = colorsObj[ci] || colorsObj[String(ci)];
        if (c && c !== 'none') colorSCs.push(UPT_MAP.threadSC[c] || lookupSC(c));
      }
      // Custom text (may be string or {line1, line2, line3} object)
      var customText = '';
      if (logoName.indexOf('custom_name') === 0 && embData.customNames && embData.customNames[side]) {
        var cn = embData.customNames[side];
        if (typeof cn === 'string') {
          customText = cn;
        } else if (typeof cn === 'object') {
          var lines = [];
          if (cn.line1) lines.push(cn.line1);
          if (cn.line2) lines.push(cn.line2);
          if (cn.line3) lines.push(cn.line3);
          customText = lines.join(' / ');
        }
      }
      // Font style for custom names (block/script)
      var fontStyle = '';
      if (logoName.indexOf('custom_name') === 0 && embData.customFontStyle && embData.customFontStyle[side]) {
        fontStyle = embData.customFontStyle[side];
      }
      // Check 45-degree angle for side walls
      if ((side === 'sw' || side === 'swr') && embData.angle45 && embData.angle45[side]) {
        embAngle45Note = true;
      }
      var displayName = LOGO_DISPLAY[logoName] || logoName;
      embroidery.push({ position: uptLabel, rawLogoId: logoName, logoName: displayName, colorSCs: colorSCs, customText: customText, fontStyle: fontStyle });
    });

    // JC Stitching & Contrast Stitching (structured for PDF color swatches)
    var jcStitchData = null;
    if (state.jcStitching) {
      jcStitchData = { label: 'JC Stitching', colorSC: lookupSC(state.jcColor) };
    }
    var contrastStitchData = null;
    if (state.contrastStitch) {
      contrastStitchData = { label: 'Contrast Stitching', colorSC: lookupSC(state.stitchColor) };
    }

    // Handles
    var mainHandleType = state.mainHandle || 'plastic-handle';
    var pcFabric = state.pilotChuteFabric || 'f111';
    var pcSize = state.pilotChuteSize || 'standard';
    var handles = {
      reserve: UPT_MAP.reserveHandles[state.reserveHandle] || labelFromId(state.reserveHandle || 'metal-d'),
      cutaway: lookupSC(colorMap['hcut']),
      mainDeployment: UPT_MAP.mainHandles[mainHandleType] || mainHandleType.toUpperCase(),
      pilotChute: (UPT_MAP.pcFabric[pcFabric] || pcFabric.toUpperCase()) + ' (black) ' + (UPT_MAP.pcSize[pcSize] || pcSize),
      pcHandle: (function () {
        var hLabel = UPT_MAP.mainHandles[mainHandleType] || mainHandleType.toUpperCase();
        var c1 = state.pcHandleColor1 || '';
        var c2 = state.pcHandleColor2 || '';
        if (c1 && c2) return hLabel + ' (' + c1 + ' / ' + c2 + ')';
        if (c1) return hLabel + ' (' + c1 + ')';
        return hLabel;
      })()
    };

    // Harness / risers — try state.webbingColor, then harness zone from colorMap, then first hw zone
    var harnessColorId = colorMap['harness:harness'] || colorMap['harness'] || state.webbingColor || null;
    var harness = lookupSC(harnessColorId);
    var risers = lookupSC(harnessColorId);
    var riserLength = UPT_MAP.riserLengths[state.riserLength] || ((state.riserLength || '21') + ' inch');
    var ringWebbing = UPT_MAP.rings[state.ringType] || labelFromId(state.ringType || 'type-17');
    var toggles = UPT_MAP.toggles[state.toggleType] || (state.toggleType ? state.toggleType.toUpperCase() : 'VELCRO');

    // Measurements
    var previousSerialNumber = getPreviousVectorSerial();
    var measurements = {
      units: 'cm / Kg',
      height: previousSerialNumber ? '' : (state.height || ''),
      weight: previousSerialNumber ? '' : (state.weight || ''),
      chest: previousSerialNumber ? '' : (state.chest || ''),
      waist: previousSerialNumber ? '' : (state.waist || ''),
      torso: previousSerialNumber ? '' : (state.torso || ''),
      legPad: previousSerialNumber ? '' : (state.legPad || ''),
      inseam: previousSerialNumber ? '' : (state.inseam || ''),
      sex: previousSerialNumber ? '' : (state.sex || 'Male')
    };

    // Canopies
    var mainCanopyStr = '';
    if (state.mainCanopyBrand && state.mainCanopyModel) {
      var SHORT = { 'Performance Designs':'PD','Fluid Wings':'Fluid','NZ Aerosports / JYRO':'JYRO','Icarus World':'Icarus','Aerodyne':'Aerodyne','Squirrel':'Squirrel' };
      mainCanopyStr = (SHORT[state.mainCanopyBrand] || state.mainCanopyBrand) + ' ' + state.mainCanopyModel;
      if (state.mainCanopySize) mainCanopyStr += ' ' + state.mainCanopySize;
    }
    var reserveCanopyStr = '';
    if (state.reserveCanopyBrand && state.reserveCanopyModel) {
      var RSHORT = { 'Performance Designs':'PD','Aerodyne':'Aerodyne','Icarus':'Icarus','Mars':'Mars' };
      reserveCanopyStr = (RSHORT[state.reserveCanopyBrand] || state.reserveCanopyBrand) + ' ' + state.reserveCanopyModel;
      if (state.reserveCanopySize) reserveCanopyStr += ' ' + state.reserveCanopySize;
    }

    // Options list
    var options = [];
    if (state.emergencySystem === 'rsl' || state.emergencySystem === 'skyhook') options.push(UPT_MAP.emergency[state.emergencySystem] || 'Skyhook RSL');
    if (state.riserCovers === 'magnetic') options.push('Magnetic riser covers');
    if (state.riserCovers === 'tuck-tab') options.push('Tuck-tab riser covers');
    if (state.backpad && state.backpad.indexOf('3d') >= 0) options.push('3D spacer foam backpad/leg pads');
    if (state.hookKnife === 'yes' || state.hookKnife === true) options.push('Hook knife');
    if (state.mainDBag === 'semi-stowless') options.push('V-Stow bag');
    if (state.mainDBag === 'stowless') options.push('Stowless bag');
    if (state.wsBridle) options.push('Wingsuit bridle length');
    if (state.wsDynamicCorners) options.push('Dynamic corners');
    if (state.wsSemiStowless) options.push('Semi-stowless D-bag');
    if (state.centerFlapPiping) {
      var pipParts = [];
      ['pb','pc','pd','pe','pf','pg'].forEach(function (z) {
        var pipKey = 'piping:' + z;
        if (colorMap[pipKey]) pipParts.push((UPT_MAP.piping[z] || z.toUpperCase()) + ': ' + lookupSC(colorMap[pipKey]));
      });
      options.push('Center flap piping' + (pipParts.length ? ' (' + pipParts.join(', ') + ')' : ''));
    }
    if (state.contrastStitch) options.push('Contrast stitching (' + lookupSC(state.stitchColor) + ')');
    if (state.jcStitching) options.push('JC stitching (' + lookupSC(state.jcColor) + ')');

    // Piping zone colors
    var pipingColors = {};
    if (state.centerFlapPiping) {
      ['pb','pc','pd','pe','pf','pg'].forEach(function (z) {
        var pipKey = 'piping:' + z;
        if (colorMap[pipKey]) pipingColors[UPT_MAP.piping[z] || z.toUpperCase()] = lookupSC(colorMap[pipKey]);
      });
    }

    return {
      containerModel: containerModel + ' MICRON',
      pattern: UPT_MAP.patterns[pattern] || pattern.toUpperCase(),
      containerParts: containerParts,
      trimTape: trimTape,
      legPads: legPads,
      legPadTrim: legPadTrim,
      centerFlap: centerFlap,
      pipingColors: pipingColors,
      embroidery: embroidery,
      embAngle45Note: embAngle45Note,
      jcStitch: jcStitchData,
      contrastStitch: contrastStitchData,
      handles: handles,
      harness: harness,
      risers: risers,
      riserType: (function () {
        var rt = state.riserType || 'standard';
        if (rt === 'louie-loops') return 'Louie Loops';
        if (rt === 'low-drag-louie') return 'Low-drag Louie Loops';
        return 'Standard';
      })(),
      riserLength: riserLength,
      ringWebbing: ringWebbing,
      toggles: toggles,
      measurements: measurements,
      mainCanopy: mainCanopyStr || 'TBD',
      reserveCanopy: reserveCanopyStr || 'TBD',
      options: options,
      specialInstructions: state.specialInstructions || '',
      previousSerialNumber: previousSerialNumber,
      // Metadata
      customerEmail: state.userEmail || '',
      customerPhone: state.userPhone || '',
      designName: design.name || 'Design 1',
      timestamp: new Date().toISOString()
    };
  }

  /* ================================================================
     PDF GENERATION — UPT Order Form
     Uses jsPDF to create a pixel-accurate replica of UPT's official
     order form (Letter size, portrait) from buildUPTOrderData().
     ================================================================ */

  /**
   * Capture the 4-view rig diagram from the summary SVGs as a PNG data URL.
   * @param {function(string|null)} callback — receives PNG data URL or null
   */
  function captureRigDiagramPNG(callback) {
    var viewsGrid = document.querySelector('.vc-summary-preview-views');
    if (!viewsGrid) { console.warn('[VC] captureRigDiagramPNG: .vc-summary-preview-views not found'); callback(null); return; }

    // Try PNG images first (captured screenshots from Color Designer)
    var imgEls = viewsGrid.querySelectorAll('img.vc-summary-preview-img');

    // Fallback: try SVGs if no PNGs found
    if (imgEls.length === 0) {
      var svgEls = viewsGrid.querySelectorAll('svg');
      if (svgEls.length > 0) {
        console.log('[VC] captureRigDiagramPNG: using SVG fallback,', svgEls.length, 'SVGs');
        var gap = 20; var images = []; var loaded2 = 0; var failed2 = false;
        for (var s = 0; s < svgEls.length; s++) {
          (function (idx, svgEl) {
            var clone = svgEl.cloneNode(true);
            clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
            var svgStr = new XMLSerializer().serializeToString(clone);
            var dataUrl = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgStr);
            var drawImg = new Image();
            drawImg.onload = function () { images[idx] = drawImg; loaded2++; if (loaded2 === svgEls.length && !failed2) composeSvgCanvas(); };
            drawImg.onerror = function () { if (!failed2) { failed2 = true; callback(null); } };
            drawImg.src = dataUrl;
          })(s, svgEls[s]);
        }
        function composeSvgCanvas() {
          var viewH = 1200; var natW = 480; var natH = 800;
          var scale = viewH / natH; var viewW = Math.round(natW * scale);
          var totalW = images.length * viewW + (images.length - 1) * gap;
          var canvas = document.createElement('canvas'); canvas.width = totalW; canvas.height = viewH;
          var ctx = canvas.getContext('2d');
          for (var j = 0; j < images.length; j++) ctx.drawImage(images[j], j * (viewW + gap), 0, viewW, viewH);
          callback(canvas.toDataURL('image/png'));
        }
        return;
      }
      console.warn('[VC] captureRigDiagramPNG: no images or SVGs found'); callback(null); return;
    }

    console.log('[VC] captureRigDiagramPNG: found', imgEls.length, 'images in preview grid');

    var gap = 20;
    var images = [];
    var loaded = 0;
    var failed = false;

    for (var i = 0; i < imgEls.length; i++) {
      (function (idx, srcImg) {
        var drawImg = new Image();
        drawImg.onload = function () {
          images[idx] = drawImg;
          loaded++;
          if (loaded === imgEls.length && !failed) composeCanvas();
        };
        drawImg.onerror = function () {
          console.error('[VC] captureRigDiagramPNG: failed to load image', idx);
          if (!failed) { failed = true; callback(null); }
        };
        drawImg.src = srcImg.src;
      })(i, imgEls[i]);
    }

    function composeCanvas() {
      // Use natural dimensions of first image to determine aspect ratio
      var natW = images[0].naturalWidth || 480;
      var natH = images[0].naturalHeight || 800;
      var viewH = 1200; // target height in px for crisp PDF
      var scale = viewH / natH;
      var viewW = Math.round(natW * scale);
      var totalW = images.length * viewW + (images.length - 1) * gap;

      var canvas = document.createElement('canvas');
      canvas.width = totalW;
      canvas.height = viewH;
      var ctx = canvas.getContext('2d');

      for (var j = 0; j < images.length; j++) {
        var x = j * (viewW + gap);
        ctx.drawImage(images[j], x, 0, viewW, viewH);
      }

      var png = canvas.toDataURL('image/png');
      console.log('[VC] captureRigDiagramPNG: success,', images.length, 'views,', natW + 'x' + natH, 'natural, canvas', totalW + 'x' + viewH);
      callback(png);
    }
  }

  /**
   * Generate the UPT Order Form PDF.
   * @param {function(Blob, string)} callback — receives (pdfBlob, pdfDataUrl)
   */
  function generateUPTOrderPDF(callback) {
    console.log('[VC] generateUPTOrderPDF: starting...');
    var orderData;
    try {
      orderData = buildUPTOrderData();
      console.log('[VC] buildUPTOrderData succeeded:', orderData.containerModel);
    } catch (e) {
      console.error('[VC] buildUPTOrderData CRASHED:', e.message, e.stack);
      if (callback) callback(null, null);
      return;
    }

    captureRigDiagramPNG(function (rigPng) {
      var jsPDF = window.jspdf && window.jspdf.jsPDF;
      if (!jsPDF) {
        console.error('[VC] jsPDF not loaded — attempting dynamic reload');
        // Attempt dynamic reload of jsPDF (SRI-pinned — same hash as the Liquid <script>)
        var s = document.createElement('script');
        s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
        s.integrity = 'sha512-qZvrmS2ekKPF2mSznTQsxqPgnpkI4DNTlrdUmTzrDgektczlKNRRhy5X5AAOnx5S09ydFYWWNSfcEqDTTHgtNA==';
        s.crossOrigin = 'anonymous';
        s.referrerPolicy = 'no-referrer';
        s.onload = function () {
          jsPDF = window.jspdf && window.jspdf.jsPDF;
          if (!jsPDF) { console.error('[VC] jsPDF still not available after reload'); if (callback) callback(null, null); return; }
          buildPDF(jsPDF, orderData, rigPng, callback);
        };
        s.onerror = function () { console.error('[VC] jsPDF CDN unreachable'); if (callback) callback(null, null); };
        document.head.appendChild(s);
        return;
      }
      buildPDF(jsPDF, orderData, rigPng, callback);
    });
  }

  function buildPDF(jsPDF, orderData, rigPng, callback) {
    try {

      var doc = new jsPDF({ unit: 'mm', format: 'letter', orientation: 'portrait' });
      // Letter: 215.9 x 279.4 mm
      var pw = 215.9, ph = 279.4;
      var ml = 10, mr = 10, mt = 10;
      var cw = pw - ml - mr; // content width
      var y = mt;

      // ---- Font helpers ----
      function setFont(style, size) {
        doc.setFont('helvetica', style);
        doc.setFontSize(size);
      }
      function setColor(r, g, b) {
        doc.setTextColor(r || 0, g || 0, b || 0);
        doc.setDrawColor(r || 0, g || 0, b || 0);
      }

      // ---- Section header (bold, underline) ----
      function sectionHeader(text, x, yy) {
        setFont('bold', 9);
        setColor(0, 0, 0);
        doc.text(text, x, yy);
        var tw = doc.getTextWidth(text);
        doc.setLineWidth(0.3);
        doc.line(x, yy + 0.5, x + tw, yy + 0.5);
        return yy + 5;
      }

      // ---- Key: Value row ----
      function kvRow(key, val, x, yy, keyW) {
        keyW = keyW || 22;
        setFont('normal', 7.5);
        setColor(0, 0, 0);
        doc.text(key + ':', x, yy);
        doc.text(val || '', x + keyW, yy);
        return yy + 3.5;
      }

      // ---- Color swatch (small rounded rect) ----
      function colorSwatch(sc, x, yy) {
        // Map shortcode → hex for common colors
        var scHex = {
          'WHT':'#f0f0f0','BLK':'#1a1a1a','SMK':'#6b6b6b','SIL':'#b0b0b0',
          'NEYL':'#e8f520','NeYEL':'#e8f520','YEL':'#f0c808','GLD':'#c8a415',
          'NEOR':'#ff6b1a','NeORG':'#ff6b1a','ORG':'#e0601a','RED':'#cc0000',
          'NEPK':'#ff3399','NePNK':'#ff3399','FUS':'#cc0066','PNK':'#ff88b4',
          'BUR':'#6d1a2d','PUR':'#6a1b9a','LAV':'#b388d9',
          'SKYBL':'#6bb5e0','LTBL':'#63b3ed','NEBL':'#1a8cff','NeBL':'#1a8cff',
          'RBL':'#0044cc','NBL':'#0a1744','TEL':'#178582',
          'NEGR':'#39e639','NeGRN':'#39e639','KGR':'#2a9d2a','FGR':'#1a5c1a',
          'OD':'#556b2f','BRN':'#6b3a1f','BGE':'#d4c5a9',
          'TAN':'#c2a770','COY':'#8b7355','WDL':'#4a5d23','DSC':'#c2a97e',
          'DDC':'#b8a88a','MPD':'#a89570','MPW':'#4b5320','MTC':'#7c7a4e',
          'BMC':'#2a2a28','CMT':'#5e6b4e','GAL':'#1a0a3e',
          'KRM':'#3d5c3a','KRH':'#8a7d5a','KRT':'#2a2a2a','KRR':'#5a5a5a'
        };
        var hex = scHex[sc] || '#cccccc';
        var r = parseInt(hex.substr(1, 2), 16);
        var g = parseInt(hex.substr(3, 2), 16);
        var b = parseInt(hex.substr(5, 2), 16);
        doc.setFillColor(r, g, b);
        doc.roundedRect(x, yy - 2.2, 3, 2.5, 0.5, 0.5, 'F');
        // Border for light colors
        if (sc === 'WHT' || sc === 'SIL' || sc === 'BGE' || sc === 'NEYL') {
          doc.setDrawColor(180, 180, 180);
          doc.setLineWidth(0.15);
          doc.roundedRect(x, yy - 2.2, 3, 2.5, 0.5, 0.5, 'S');
        }
      }

      // ---- Color row with swatch ----
      function colorRow(name, sc, x, yy) {
        colorSwatch(sc, x, yy);
        setFont('normal', 7.5);
        setColor(0, 0, 0);
        doc.text(name + ': ' + sc, x + 4, yy);
        return yy + 3.5;
      }

      // ================================================================
      //  PAGE 1 — HEADER
      // ================================================================
      setColor(0, 0, 0);

      // Row 1: Dealer / Customer
      setFont('bold', 8);
      doc.text('DEALER NAME:', ml, y);
      doc.text('CUSTOMER NAME / PO#:', ml + 90, y);
      setFont('normal', 8);
      doc.text('Skydive Shop', ml + 32, y);
      var custName = orderData.customerEmail || '';
      doc.text(custName, ml + 130, y);
      y += 5;

      // Row 2: OFFICE USE ONLY
      setFont('bold', 7);
      doc.text('OFFICE USE ONLY:', pw / 2, y, { align: 'center' });
      y += 4;

      // Row 3: Codes
      setFont('bold', 7);
      doc.text('DEALER CODE:', ml, y);
      doc.text('SERIAL NUMBER:', ml + 65, y);
      doc.text('SALES ORDER NUMBER:', ml + 130, y);
      y += 4;

      // Row 4: Dates
      doc.text('RECEIVE DATE:', ml, y);
      doc.text('PROMISE DATE:', ml + 65, y);
      doc.text('REVIEWED:', ml + 130, y);
      y += 5;

      // Separator
      doc.setLineWidth(0.3);
      doc.line(ml, y, pw - mr, y);
      y += 4;

      // Row 5-6: Canopy info
      setFont('bold', 8);
      doc.text('Main Canopy:', ml, y);
      setFont('normal', 8);
      doc.text(orderData.mainCanopy, ml + 28, y);
      // Checkboxes
      doc.rect(ml + 70, y - 3, 3, 3);
      setFont('normal', 7);
      doc.text('UPT to order', ml + 74, y);
      doc.rect(ml + 95, y - 3, 3, 3);
      doc.text('Assembly Required', ml + 99, y);
      y += 5;

      setFont('bold', 8);
      doc.text('Reserve Canopy:', ml, y);
      setFont('normal', 8);
      doc.text(orderData.reserveCanopy, ml + 32, y);
      doc.rect(ml + 70, y - 3, 3, 3);
      setFont('normal', 7);
      doc.text('UPT to order', ml + 74, y);
      y += 6;

      // Separator
      doc.setLineWidth(0.2);
      doc.line(ml, y, pw - mr, y);
      y += 3;

      // ================================================================
      //  4-VIEW RIG DIAGRAM
      // ================================================================
      var diagramY = y;

      // View labels
      setFont('bold', 7);
      var viewLabels = ['BACK', 'FRONT', 'RIGHT', 'LEFT'];
      var viewSpacing = (cw - 8) / 4;
      for (var vi = 0; vi < 4; vi++) {
        doc.text(viewLabels[vi], ml + 4 + vi * viewSpacing + viewSpacing / 2, y, { align: 'center' });
      }
      y += 2;

      if (rigPng) {
        var imgW = cw - 8;
        // Each view is 480x800 (3:5 ratio), 4 views + 3 gaps of 20px at 1200px height
        // Composite = (4*720 + 60) x 1200 = 2940 x 1200 → aspect ≈ 2.45
        // Use a known aspect ratio based on our composite dimensions
        var tmpImg = new Image();
        tmpImg.src = rigPng;
        var imgAspect = (tmpImg.naturalWidth && tmpImg.naturalHeight) ? tmpImg.naturalWidth / tmpImg.naturalHeight : 2.45;
        var imgH = imgW / imgAspect;
        // Cap max height to avoid overflowing the page
        if (imgH > 95) imgH = 95;
        doc.addImage(rigPng, 'PNG', ml + 4, y, imgW, imgH);
        y += imgH + 2;
      } else {
        y = diagramY + 12;
      }

      // ================================================================
      //  MODEL LINE
      // ================================================================
      setFont('bold', 12);
      setColor(0, 0, 0);
      doc.text(orderData.containerModel + ': ' + orderData.pattern, ml, y);
      y += 7;

      // ================================================================
      //  3-COLUMN DATA LAYOUT
      // ================================================================
      var colW = cw / 3;
      var col1x = ml;
      var col2x = ml + colW;
      var col3x = ml + colW * 2;
      var dataStartY = y;

      // ---- COLUMN 1: Container Parts ----
      var y1 = sectionHeader('Container Parts', col1x, dataStartY);
      var pdfPattern = orderData.pattern || 'STANDARD';
      // Reverse-lookup pattern key from UPT name
      var patKey = 'standard';
      Object.keys(UPT_MAP.patterns).forEach(function(k) {
        if (UPT_MAP.patterns[k] === pdfPattern) patKey = k;
      });
      var pdfZoneOrder = getContainerZoneOrder(patKey);
      for (var zi = 0; zi < pdfZoneOrder.length; zi++) {
        var zid = pdfZoneOrder[zi];
        var uptLabel = UPT_MAP.zones[zid];
        // Rename when split partner exists
        if (zid === 'c2' && pdfZoneOrder.indexOf('c2b') !== -1) uptLabel = '2A';
        if (zid === 'c4' && pdfZoneOrder.indexOf('c4b') !== -1) uptLabel = '4A';
        var sc = orderData.containerParts[uptLabel] || orderData.containerParts[UPT_MAP.zones[zid]] || 'BLK';
        y1 = colorRow(uptLabel, sc, col1x, y1);
      }

      // Leg Pads (below Container Parts)
      y1 += 2;
      y1 = sectionHeader('Leg Pads', col1x, y1);
      y1 = colorRow('Right', orderData.legPads['Right'] || 'BLK', col1x, y1);
      y1 = colorRow('Left', orderData.legPads['Left'] || 'BLK', col1x, y1);

      // Embroidery (below Leg Pads) — VOS single-line format
      y1 += 2;
      y1 = sectionHeader('Embroidery', col1x, y1);
      for (var ei = 0; ei < orderData.embroidery.length; ei++) {
        var emb = orderData.embroidery[ei];
        if (emb.rawLogoId === 'none') continue;

        // Build VOS-format line: "(7C) YOKE: v3hd_yh - WHT, NePNK"
        var embLine = emb.position + ': ' + emb.rawLogoId;
        if (emb.colorSCs && emb.colorSCs.length > 0) {
          embLine += ' - ' + emb.colorSCs.join(', ');
        }
        // Font style for custom names (block/script)
        if (emb.fontStyle) {
          embLine += ' - ' + emb.fontStyle;
        }
        if (emb.customText) {
          embLine += ' - Custom ' + emb.customText;
        }
        if (emb.rawLogoId.indexOf('custom_logo') === 0) {
          embLine += ' - logo';
        }

        // Color swatch from first thread color
        if (emb.colorSCs && emb.colorSCs.length > 0) {
          colorSwatch(emb.colorSCs[0], col1x, y1);
        }

        setFont('normal', 6.5);
        setColor(0, 0, 0);
        doc.text(embLine, col1x + 4, y1);
        y1 += 3.2;
      }

      // 45-degree angle note
      if (orderData.embAngle45Note) {
        y1 += 1;
        setFont('italic', 6.5);
        setColor(0, 0, 0);
        doc.text('NOTE: Side Wall embroidery at 45 degrees ANGLE', col1x, y1);
        y1 += 3.2;
      }

      // JC Stitching (with color swatch) — single line
      if (orderData.jcStitch) {
        y1 += 1;
        colorSwatch(orderData.jcStitch.colorSC, col1x, y1);
        setFont('normal', 6.5);
        setColor(0, 0, 0);
        doc.text('JC Stitching: ' + orderData.jcStitch.colorSC, col1x + 4, y1);
        y1 += 3.2;
      }

      // Contrast Stitching (with color swatch) — single line
      if (orderData.contrastStitch) {
        colorSwatch(orderData.contrastStitch.colorSC, col1x, y1);
        setFont('normal', 6.5);
        setColor(0, 0, 0);
        doc.text('Contrast Stitching: ' + orderData.contrastStitch.colorSC, col1x + 4, y1);
        y1 += 3.2;
      }

      // ---- COLUMN 2: Trim Tape ----
      var y2 = sectionHeader('Trim Tape', col2x, dataStartY);
      var trimOrder = UPT_MAP.trimOrder;
      for (var ti = 0; ti < trimOrder.length; ti++) {
        var tid = trimOrder[ti];
        var tName = UPT_MAP.trim[tid];
        var tsc = orderData.trimTape[tName] || 'BLK';
        y2 = colorRow(tName, tsc, col2x, y2);
      }
      // Leg pad trim
      y2 = colorRow('T Right', orderData.legPadTrim['T Right'] || 'BLK', col2x, y2);
      y2 = colorRow('T Left', orderData.legPadTrim['T Left'] || 'BLK', col2x, y2);

      // ---- COLUMN 3: Center Flap, Handles, Deployment, Pilot Chute, Measurements, Options ----
      var y3 = sectionHeader('Center flap', col3x, dataStartY);
      var flapKeys = Object.keys(orderData.centerFlap);
      for (var fi = 0; fi < flapKeys.length; fi++) {
        y3 = colorRow(flapKeys[fi], orderData.centerFlap[flapKeys[fi]], col3x, y3);
      }

      // Piping colors
      if (orderData.pipingColors && Object.keys(orderData.pipingColors).length > 0) {
        y3 += 2;
        y3 = sectionHeader('Piping', col3x, y3);
        var pipKeys = Object.keys(orderData.pipingColors);
        for (var pi = 0; pi < pipKeys.length; pi++) {
          y3 = colorRow(pipKeys[pi], orderData.pipingColors[pipKeys[pi]], col3x, y3);
        }
      }

      // Handles
      y3 += 2;
      y3 = sectionHeader('Handles', col3x, y3);
      y3 = kvRow('Reserve', orderData.handles.reserve, col3x, y3, 18);
      y3 = kvRow('Cutaway', orderData.handles.cutaway, col3x, y3, 18);

      // Main Deployment
      y3 += 2;
      y3 = sectionHeader('Main Deployment', col3x, y3);
      setFont('normal', 7.5);
      doc.text(orderData.handles.mainDeployment, col3x, y3);
      y3 += 4;

      // Pilot Chute
      setFont('bold', 7.5);
      doc.text('Pilot chute', col3x, y3);
      setFont('normal', 7.5);
      doc.text(orderData.handles.pilotChute, col3x + 22, y3);
      y3 += 3.5;
      // Wingsuit bridle line (if applicable)
      if (orderData.options.indexOf('Wingsuit bridle length') >= 0) {
        setFont('normal', 7);
        doc.text('Wingsuit bridle length', col3x + 22, y3);
        y3 += 3.5;
      }
      setFont('bold', 7.5);
      doc.text('P.C. Handle:', col3x, y3);
      setFont('normal', 7.5);
      doc.text(orderData.handles.pcHandle, col3x + 22, y3);

      // ================================================================
      //  PAGE 2 — HARNESS / RISERS / SPECIAL INSTRUCTIONS
      // ================================================================
      doc.addPage();
      y = mt;

      // Header repeat
      setFont('normal', 7);
      setColor(150, 150, 150);
      doc.text(new Date().toLocaleDateString() + ', ' + new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }), ml, y);
      doc.text('UPT Vector 3 — Order Form', pw / 2, y, { align: 'center' });
      setColor(0, 0, 0);
      y += 7;

      // ---- PAGE 2: 2-COLUMN LAYOUT ----
      var p2col1x = ml;
      var p2col2x = ml + cw / 2 + 5;
      var p2y1 = y;
      var p2y2 = y;

      // ---- LEFT COLUMN: Measurements + Options ----
      p2y1 = sectionHeader('Measurements', p2col1x, p2y1);
      var meas = orderData.measurements;
      if (orderData.previousSerialNumber) {
        p2y1 = kvRow('Previous Vector S/N', orderData.previousSerialNumber, p2col1x, p2y1, 18);
      } else {
        p2y1 = kvRow('Units', meas.units, p2col1x, p2y1, 18);
        p2y1 = kvRow('Height', String(meas.height), p2col1x, p2y1, 18);
        p2y1 = kvRow('Weight', String(meas.weight), p2col1x, p2y1, 18);
        p2y1 = kvRow('Chest', String(meas.chest), p2col1x, p2y1, 18);
        p2y1 = kvRow('Waist', String(meas.waist), p2col1x, p2y1, 18);
        p2y1 = kvRow('Torso', String(meas.torso), p2col1x, p2y1, 18);
        p2y1 = kvRow('Leg Pad', String(meas.legPad), p2col1x, p2y1, 18);
        p2y1 = kvRow('Inseam', String(meas.inseam), p2col1x, p2y1, 18);
        p2y1 = kvRow('Sex', meas.sex, p2col1x, p2y1, 18);
      }

      p2y1 += 3;
      p2y1 = sectionHeader('Options', p2col1x, p2y1);
      for (var oi = 0; oi < orderData.options.length; oi++) {
        setFont('normal', 7);
        doc.text(orderData.options[oi], p2col1x, p2y1);
        p2y1 += 3.2;
      }
      p2y1 += 2;
      setFont('normal', 7);
      doc.text('Main: ' + orderData.mainCanopy, p2col1x, p2y1);
      p2y1 += 3.2;
      doc.text('Reserve: ' + orderData.reserveCanopy, p2col1x, p2y1);

      // ---- RIGHT COLUMN: Harness + Risers ----
      p2y2 = sectionHeader('Harness', p2col2x, p2y2);
      colorSwatch(orderData.harness, p2col2x + 24, p2y2);
      setFont('normal', 8);
      doc.text(orderData.harness, p2col2x + 29, p2y2);
      p2y2 += 6;

      // Risers box
      doc.setLineWidth(0.3);
      doc.rect(p2col2x, p2y2 - 3, cw / 2.5, 27);
      p2y2 = sectionHeader('Risers', p2col2x + 2, p2y2);
      p2y2 = kvRow('Type', '* ' + orderData.riserType, p2col2x + 2, p2y2, 24);
      p2y2 = kvRow('Riser Length', orderData.riserLength, p2col2x + 2, p2y2, 24);
      p2y2 = kvRow('Ring/webbing', orderData.ringWebbing, p2col2x + 2, p2y2, 24);
      p2y2 = kvRow('Toggles', orderData.toggles, p2col2x + 2, p2y2, 24);

      // ---- Special Instructions (full width, below both columns) ----
      var siY = Math.max(p2y1, p2y2) + 8;
      setFont('bold', 9);
      doc.text('Special Instructions', ml, siY);
      siY += 2;
      doc.setLineWidth(0.3);
      doc.rect(ml, siY, cw, 30);
      if (orderData.specialInstructions) {
        setFont('normal', 8);
        var siLines = doc.splitTextToSize(orderData.specialInstructions, cw - 4);
        doc.text(siLines, ml + 2, siY + 5);
      }

      // ================================================================
      //  OUTPUT
      // ================================================================
      var pdfBlob = doc.output('blob');
      console.log('[VC] PDF blob size:', pdfBlob.size, 'bytes');
      if (pdfBlob.size < 1024) {
        console.warn('[VC] PDF blob suspiciously small (' + pdfBlob.size + ' bytes) — may be corrupt');
      }
      var pdfDataUrl = doc.output('dataurlstring');
      if (callback) callback(pdfBlob, pdfDataUrl);
    } catch (e) {
      console.error('[VC] PDF generation error:', e);
      if (callback) callback(null, null);
    }
  }

  // Expose for external use (e.g., confirm flow, testing)
  window.generateUPTOrderPDF = generateUPTOrderPDF;

  /* ---- PLAIN TEXT SUMMARY (for sharing) ---- */
  function buildSummaryText() {
    var l = [];
    l.push('=== UPT Vector 3 Configuration ===');
    l.push('');
    var previousVectorSerial = getPreviousVectorSerial();
    if (previousVectorSerial) {
      l.push('-- Previous Vector Measurements --');
      l.push('Previous Vector S/N: ' + previousVectorSerial);
    } else {
      l.push('-- Body Measurements --');
      l.push('Total Jumps: ' + (state.jumpCount || state.jumpCount === 0 ? state.jumpCount : '—'));
      l.push('Canopy Courses: ' + (state.canopyCourses || 0));
      l.push('DZ Altitude: ' + (state.dzAltitude || 0) + ' ' + (state.dzAltUnit || 'm'));
      l.push('Height: ' + val(state.height, 'cm'));
      l.push('Weight: ' + val(state.weight, 'kg'));
      l.push('Chest: ' + val(state.chest, 'cm'));
      l.push('Waist: ' + val(state.waist, 'cm'));
      l.push('Torso (ASIS-to-Throat): ' + val(state.torso, 'cm'));
      l.push('Leg Pad: ' + val(state.legPad, 'cm'));
      l.push('Inseam: ' + val(state.inseam, 'cm'));
      l.push('Sex: ' + (state.sex || 'Male'));
    }
    l.push('');

    var patData = PATTERNS[state.pattern] || {};
    l.push('-- Container Design --');
    var freePatterns = ['standard', 'v-split', 'tri-v-split', 'full-custom'];
    l.push('Pattern: ' + (patData.name || state.pattern) + (freePatterns.indexOf(state.pattern) === -1 ? ' (+' + formatContainerPrice(SURCHARGES.pattern) + ')' : (state.pattern === 'full-custom' ? ' (Included)' : '')));
    (state.zoneColors || []).forEach(function (c, i) {
      l.push(((patData.zones || [])[i] || 'Zone') + ': ' + colorName(c));
    });
    l.push('Binding: ' + colorName(state.bindingColor));
    l.push('Webbing: ' + colorName(state.webbingColor));
    if (state.contrastStitch) l.push('Stitching: ' + colorName(state.stitchColor));
    l.push('');

    l.push('-- Harness & Comfort --');
    l.push('Harness: ' + labelFromId(state.harnessType));
    l.push('Leg Pads: ' + labelFromId(state.legPadConfig));
    if (state.rolledEdge) l.push('Rolled Edge: Yes');
    if (state.minus2) l.push('-2" Off The Top: Yes');
    if (state.legPadCovers) l.push('Leg Pad Covers: Yes');
    l.push('Backpad: ' + labelFromId(state.backpad));
    l.push('Stabilizers: ' + capitalize(state.stabilizers));
    l.push('');

    l.push('-- Deployment Systems --');
    l.push('Main Handle: ' + (labelFromId(state.mainHandle) || '—'));
    l.push('Main D-Bag: ' + labelFromId(state.mainDBag));
    l.push('Pilot Chute: ' + state.pilotChuteFabric.toUpperCase() + ' / ' + labelFromId(state.pilotChuteSize));
    l.push('Reserve Handle: ' + labelFromId(state.reserveHandle));
    l.push('Emergency: ' + labelFromId(state.emergencySystem));
    l.push('Risers: ' + labelFromId(state.riserType));
    l.push('Rings: ' + labelFromId(state.ringType));
    l.push('Riser Covers: ' + labelFromId(state.riserCovers));
    l.push('Riser Length: ' + labelFromId(state.riserLength));
    l.push('Toggles: ' + labelFromId(state.toggleType));
    l.push('Hook Knife: ' + (state.hookKnife === 'yes' ? 'Included' : 'None'));
    l.push('');

    l.push('-- Canopy & Sizing --');
    l.push('Main: ' + (!state.includeMainCanopy ? 'Already owned - not included' : (state.mainCanopyModel ? (SHORT_MFG[state.mainCanopyBrand] || state.mainCanopyBrand || '') + ' - ' + state.mainCanopyModel + (state.mainCanopySize ? ' (' + state.mainCanopySize + ' sq ft)' : '') : 'Not selected')));
    l.push('Reserve: ' + (!state.includeReserveCanopy ? 'Already owned - not included' : (state.reserveCanopyModel ? (SHORT_MFG[state.reserveCanopyBrand] || state.reserveCanopyBrand || '') + ' - ' + state.reserveCanopyModel + (state.reserveCanopySize ? ' (' + state.reserveCanopySize + ' sq ft)' : '') : 'Not selected')));
    var aadObj = state.aad ? AAD_OPTIONS.find(function (a) { return a.id === state.aad; }) : null;
    l.push('AAD: ' + (aadObj ? aadObj.name : 'None selected'));
    l.push('Container: ' + (state.containerSize ? 'UPT Vector ' + state.containerSize + (state.containerManual ? ' (manual)' : '') : 'TBD'));
    l.push('');

    if (state.isWingsuit) {
      l.push('-- Wingsuit Pack --');
      var wsf = [];
      if (state.wsDynamicCorners) wsf.push('Dynamic Corners');
      if (state.wsBridle) wsf.push('WS Pilot Chute & Bridle');
      if (state.wsSemiStowless) wsf.push('U-Stow Semi-Stowless D-Bag');
      if (state.wsDash1Shape) wsf.push('DASH-1 Shape');
      l.push('Features: ' + (wsf.join(', ') || 'None'));
      l.push('');
    }

    l.push('-- Cosmetic & Hardware --');
    l.push('Hardware: ' + (state.hardwareFinish === 'black' ? 'Black' : 'Standard Stainless/Nickel'));
    if (state.jcStitching) l.push('JC Stitching: Yes (' + (state.jcColor || 'em-black') + ')');
    if (state.contrastStitch) l.push('Contrast Stitching: Yes (' + (state.stitchColor || 'em-black') + ')');
    if (state.centerFlapPiping) l.push('Center Flap Piping: Yes');
    state.embroidery.forEach(function (loc) {
      if (loc.enabled) l.push('Embroidery (' + loc.label + '): ' + (loc.text || 'TBD'));
    });
    // V2 embroidery details from Container Color Designer
    if (state.containerEmbroidery && state.containerEmbroidery._v2) {
      var v2e = state.containerEmbroidery._v2;
      var VCP_LOGOS = window.VectorColorPopup ? window.VectorColorPopup.EMB_LOGOS : null;
      if (v2e.currentLogoIndex && VCP_LOGOS) {
        Object.keys(v2e.currentLogoIndex).forEach(function(side) {
          var sideLogos = VCP_LOGOS[side];
          if (!sideLogos) return;
          var logo = sideLogos[v2e.currentLogoIndex[side]];
          if (!logo || logo.name === 'none') return;
          var colors = v2e.logoColors && v2e.logoColors[side] ? Object.values(v2e.logoColors[side]).join('+') : '';
          l.push('Embroidery ' + side + ': ' + logo.name + (colors ? ' (' + colors + ')' : ''));
        });
      }
    }
    l.push('');

    if (state.pcHandleColor1 || state.pcHandleColor2) {
      var hcParts = [];
      if (state.pcHandleColor1) hcParts.push(state.pcHandleColor1);
      if (state.pcHandleColor2) hcParts.push(state.pcHandleColor2);
      l.push('P.C. Handle Colors: ' + hcParts.join(' / '));
    }
    if (state.specialInstructions) {
      l.push('');
      l.push('-- Special Instructions --');
      l.push(state.specialInstructions);
    }
    l.push('');

    l.push('Estimated surcharges: ' + formatMoney(localizeContainerPrice(calculateEstimate())));
    return l.join('\n');
  }

  function showShareFeedback(btn, msg) {
    if (!btn) return;
    var orig = btn.innerHTML;
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg> ' + msg;
    btn.classList.add('vc-share-copied');
    setTimeout(function () {
      btn.innerHTML = orig;
      btn.classList.remove('vc-share-copied');
    }, 2000);
  }

  /* ---- Expert Contact & Contract Quote ---- */
  function expertWhatsApp() {
    var shareUrl = generateClientShareUrl();
    var text = buildSummaryText();
    var contact = state.userEmail ? '\n\nMy contact: ' + state.userEmail + ' / ' + state.userPhone : '';
    var body = 'Hi,\n\nI\'ve configured a UPT Vector 3 and would like your expert advice on my rig choices.' + contact + '\n\nView my configuration:\n' + shareUrl + '\n\n' + text;
    var num = dom.container.dataset.whatsapp || '34644271547';
    window.open('https://wa.me/' + num + '?text=' + encodeURIComponent(body), '_blank');
  }

  function expertEmail() {
    var shareUrl = generateClientShareUrl();
    var text = buildSummaryText();
    var contact = state.userEmail ? '\n\nMy contact: ' + state.userEmail + ' / ' + state.userPhone : '';
    var body = 'Hi,\n\nI\'ve configured a UPT Vector 3 and would like your expert advice on my rig choices.' + contact + '\n\nView my configuration:\n' + shareUrl + '\n\n' + text;
    var email = dom.container.dataset.email || 'info@skydiveshop.com';
    window.location.href = 'mailto:' + email +
      '?subject=' + encodeURIComponent('UPT Vector 3 — Expert Rig Advice Request') +
      '&body=' + encodeURIComponent(body);
  }

  function requestQuote() {
    var shareUrl = generateClientShareUrl();
    var text = buildSummaryText();
    var contact = state.userEmail ? '\n\nMy contact: ' + state.userEmail + ' / ' + state.userPhone : '';
    var body = 'Hello,\n\nI would like to request a quote / contract for the following UPT Vector 3 configuration:' + contact + '\n\nView my configuration:\n' + shareUrl + '\n\n' + text +
      '\n\nPlease send me pricing, lead time, and deposit details.\n\nThank you.';
    var email = dom.container.dataset.email || 'info@skydiveshop.com';
    window.location.href = 'mailto:' + email +
      '?subject=' + encodeURIComponent('UPT Vector 3 Configuration Request — Quote') +
      '&body=' + encodeURIComponent(body);
  }

  /* ================================================================
     ADD TO CART — exports full configuration as line item properties
     ================================================================ */
  function buildCartProperties() {
    var VCP = window.VectorColorPopup;
    var lookupColor = VCP ? VCP.colorById : function (id) { return findColorObjById(id); };
    var props = {};

    // Colors: compressed zone→shortcode pairs
    var colorParts = [];
    var cMap = state.containerColorMap || {};
    Object.keys(cMap).forEach(function(key) {
      var c = lookupColor(cMap[key]);
      var sc = c ? (c.sc || c.id) : cMap[key];
      colorParts.push(key + ':' + sc);
    });
    props['_Design Colors'] = colorParts.join(',');

    // Pattern
    props['_Pattern'] = state.pattern || 'standard';

    // Container size
    props['_Container Size'] = state.containerSize || 'TBD';

    // Embroidery
    var embParts = [];
    if (state.containerEmbroidery && state.containerEmbroidery._v2) {
      var v2 = state.containerEmbroidery._v2;
      var EMB_LOGOS = VCP ? VCP.EMB_LOGOS : null;
      if (v2.currentLogoIndex && EMB_LOGOS) {
        Object.keys(v2.currentLogoIndex).forEach(function(side) {
          var idx = v2.currentLogoIndex[side];
          var sideLogos = EMB_LOGOS[side];
          if (!sideLogos) return;
          var logo = sideLogos[idx];
          var logoName = logo ? logo.name : 'none';
          if (logoName === 'none') return;
          var colors = v2.logoColors && v2.logoColors[side] ? Object.values(v2.logoColors[side]).join('+') : '';
          embParts.push(side + ':' + logoName + '/' + colors);
        });
      }
    }
    props['_Embroidery'] = embParts.join(',') || 'none';

    // Piping
    var pipParts = [];
    ['pb','pc','pd','pe','pf','pg'].forEach(function(z) {
      var colorId = cMap['piping:' + z];
      if (colorId) {
        var c = lookupColor(colorId);
        pipParts.push(z + ':' + (c ? (c.sc || c.id) : colorId));
      }
    });
    props['_Piping'] = pipParts.join(',') || 'none';

    // Cosmetic options
    var opts = [];
    opts.push('hw:' + (state.hardwareFinish === 'black' ? 'black' : 'std'));
    opts.push('jc:' + (state.jcStitching ? 'yes:' + (state.jcColor || 'em-black') : 'no'));
    if (state.contrastStitch) opts.push('stitch:' + (state.stitchColor || 'em-black'));
    // Deployment options
    if (state.mainHandle) opts.push('main-handle:' + state.mainHandle);
    opts.push('dbag:' + (state.mainDBag || 'standard'));
    opts.push('pc-fabric:' + (state.pilotChuteFabric || 'f111'));
    opts.push('pc-size:' + (state.pilotChuteSize || 'standard'));
    opts.push('res-handle:' + (state.reserveHandle || 'metal-d'));
    opts.push('toggles:' + (state.toggleType || 'tru-lok'));
    if (state.hookKnife === 'yes') opts.push('hook-knife:yes');
    // Wingsuit options
    if (state.wsDynamicCorners) opts.push('ws-dc:yes');
    if (state.wsBridle) opts.push('ws-bridle:yes');
    if (state.wsSemiStowless) opts.push('ws-semi:yes');
    if (state.wsDash1Shape) opts.push('ws-dash1:yes');
    props['_Options'] = opts.join(',');

    // Surcharge
    props['_Surcharge'] = formatMoney(localizeContainerPrice(calculateEstimate()));
    var pricing = getPricingContext();
    props['_Currency'] = pricing.currencyCode;
    props['_Pricing Country'] = pricing.countryCode;

    // Full text summary
    props['_Configuration Summary'] = buildSummaryText();

    return props;
  }

  /* ---- Add to cart on first entry (contact form submit) ---- */
  var cartMutationQueue = Promise.resolve();

  function queueCartMutation(task) {
    var operation = cartMutationQueue.then(task, task);
    // Keep the queue usable after a failed request while still returning the
    // original operation (and its error) to the caller.
    cartMutationQueue = operation.catch(function() {});
    return operation;
  }

  function cartResponseError(res, fallbackMessage) {
    return res.json().catch(function() { return {}; }).then(function(body) {
      throw new Error(body.description || body.message || fallbackMessage + ' (' + res.status + ')');
    });
  }

  function getConfiguratorCartLineKeys(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var savedKey = state.cartItemKey;
    var sessionId = state.sessionId;
    var keys = [];

    items.forEach(function(item) {
      var props = item && item.properties ? item.properties : {};
      var isSavedLine = !!savedKey && item.key === savedKey;
      var isSameSession = !!sessionId && props['_Session ID'] === sessionId;
      if ((isSavedLine || isSameSession) && item.key && keys.indexOf(item.key) === -1) {
        keys.push(item.key);
      }
    });

    return keys;
  }

  function clearConfiguratorCartLines() {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
    .then(function(res) {
      if (!res.ok) return cartResponseError(res, 'Unable to read cart');
      return res.json();
    })
    .then(function(cart) {
      var keys = getConfiguratorCartLineKeys(cart);
      if (!keys.length) {
        // The remembered key belongs to an expired/cleared/re-keyed cart. It
        // is safe to forget it because there is no matching current cart line.
        state.cartItemKey = '';
        saveState();
        return cart;
      }

      var updates = {};
      keys.forEach(function(key) { updates[key] = 0; });
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function(res) {
        if (!res.ok) return cartResponseError(res, 'Unable to remove previous configurator item');
        return res.json();
      }).then(function(updatedCart) {
        state.cartItemKey = '';
        saveState();
        return updatedCart;
      });
    });
  }

  function addConfiguratorCartLine(variantId, quantity, props, fallbackMessage) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{
        id: parseInt(variantId, 10),
        quantity: quantity,
        properties: props
      }] })
    })
    .then(function(res) {
      if (!res.ok) return cartResponseError(res, fallbackMessage || 'Unable to add configurator item');
      return res.json();
    })
    .then(function(data) {
      if (data.items && data.items[0] && data.items[0].key) {
        state.cartItemKey = data.items[0].key;
        saveState();
      }
      return data;
    });
  }

  var depositPriceMinorCache = {};

  function getStorefrontProductJsonUrl(handle) {
    var root = '/';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root || '/';
    }
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'products/' + handle + '.js';
  }

  function fetchDepositUnitPriceMinor(variantId) {
    var pricing = getPricingContext();
    var cacheKey = [variantId, pricing.countryCode, pricing.currencyCode].join('|');
    if (depositPriceMinorCache[cacheKey]) return Promise.resolve(depositPriceMinorCache[cacheKey]);

    return fetch(getStorefrontProductJsonUrl('upt-vector-rig-deposit-payment'), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Unable to verify deposit product price');
      return res.json();
    })
    .then(function(product) {
      var variants = product && product.variants ? product.variants : [];
      var variant = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(variantId)) { variant = variants[i]; break; }
      }
      if (!variant && variants.length === 1) variant = variants[0];
      var priceMinor = variant ? Number(variant.price) : NaN;
      if (!isFinite(priceMinor) || priceMinor <= 0) throw new Error('Unable to verify deposit product price');
      depositPriceMinorCache[cacheKey] = priceMinor;
      return priceMinor;
    });
  }

  function resolveDepositCartPlan(depositVariantId, targetDeposit) {
    if (!depositVariantId) {
      return Promise.resolve({ quantity: 1, unitPrice: targetDeposit, chargedDeposit: targetDeposit });
    }
    return fetchDepositUnitPriceMinor(depositVariantId).then(function(unitMinor) {
      var targetMinor = Math.max(1, Math.ceil((Number(targetDeposit) || 0) * 100));
      var quantity = Math.max(1, Math.ceil(targetMinor / unitMinor));
      var chargedDeposit = (quantity * unitMinor) / 100;
      return {
        quantity: quantity,
        unitPrice: unitMinor / 100,
        chargedDeposit: chargedDeposit
      };
    });
  }

  function addToCartInitial() {
    var variantId = dom.container.dataset.productVariant;
    if (!variantId) return; // no product configured

    var props = {
      '_Session ID': state.sessionId,
      '_Email': state.userEmail,
      '_Phone': state.userPhone,
      '_Status': 'Configuring...'
    };

    queueCartMutation(function() {
      return addConfiguratorCartLine(variantId, 1, props, 'Cart add failed');
    })
    .then(function() {
      trackEvent('vc_cart_add_initial', {});
    })
    .catch(function(err) { console.error('Initial cart add failed:', err); });
  }

  /* ---- Update cart item properties with current configuration ---- */
  function updateCartProperties() {
    if (!state.cartItemKey) return;
    var variantId = dom.container.dataset.productVariant;
    if (!variantId) return;

    var props = buildCartProperties();
    props['_Email'] = state.userEmail;
    props['_Phone'] = state.userPhone;
    props['_Session ID'] = state.sessionId;

    // Shopify doesn't support updating properties directly. Serialize cart
    // mutations and resolve the line from the current cart before replacing it.
    queueCartMutation(function() {
      return clearConfiguratorCartLines().then(function() {
        return addConfiguratorCartLine(variantId, 1, props, 'Re-add failed');
      });
    })
    .catch(function(err) { console.error('Cart properties update failed:', err); });
  }

  /* ---- Final update + redirect to checkout ---- */
  function addToCart() {
    // The deposit variant is priced at one unit of the active market currency.
    var depositVariantId = dom.container.dataset.depositVariant;
    var fallbackVariantId = dom.container.dataset.productVariant;
    var variantId = depositVariantId || fallbackVariantId;
    if (!variantId) {
      alert('No product variant configured. Please contact the shop owner.');
      return;
    }

    var props = buildCartProperties();
    props['_Email'] = state.userEmail;
    props['_Phone'] = state.userPhone;
    props['_Session ID'] = state.sessionId;
    props['_Status'] = 'Complete';

    // Calculate total and 25% target deposit in the active storefront currency.
    var total = calculateTotal();
    if (!isFinite(total) || total <= 0) {
      alert('Pricing is temporarily unavailable for this market. Please refresh or contact the shop.');
      return;
    }
    var deposit = Math.ceil(total * 0.25); // Round up to a whole active-currency unit
    props['_Total Estimate'] = formatMoney(total);
    props['_Deposit (25%)'] = formatMoney(deposit);

    var addBtn = $('vc-add-to-cart');
    if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Calculating deposit...'; }

    // Persist buyer info on the cart as attributes so the merchant always sees
    // email/phone/name on the order in Shopify Admin. Checkout prefill itself no
    // longer works on the new Checkout Extensibility (see 2026-04-17 notes),
    // so the customer retypes on the checkout page — we accept that for now.
    var cust = window.vcCustomer;
    var fullNameAttr = '';
    if (cust && (cust.firstName || cust.lastName)) {
      fullNameAttr = ((cust.firstName || '') + ' ' + (cust.lastName || '')).trim();
    } else if (state.customerName) {
      fullNameAttr = state.customerName;
    }
    var cartAttrs = {};
    if (state.userEmail) cartAttrs['Customer Email'] = state.userEmail;
    if (state.userPhone) cartAttrs['Customer Phone'] = state.userPhone;
    if (fullNameAttr) cartAttrs['Customer Name'] = fullNameAttr;

    var depositPlan = null;

    // Resolve the deposit product's actual Shopify Markets unit price before
    // adding to cart. The deposit variant is a €1 product, but outside EUR it can
    // be TWD 32, USD 0.83, etc.; quantity must be target deposit / actual unit.
    resolveDepositCartPlan(depositVariantId, deposit)
    .then(function(plan) {
      depositPlan = plan;
      props['_Deposit Product Unit'] = formatMoney(plan.unitPrice);
      props['_Deposit Quantity'] = String(plan.quantity);
      props['_Deposit Charged'] = formatMoney(plan.chargedDeposit);

      // Resolve against the current cart so a stale localStorage key cannot block
      // checkout. The shared queue also prevents initial/update/final requests
      // from re-keying the line underneath each other.
      return queueCartMutation(function() {
        return clearConfiguratorCartLines().then(function() {
          return addConfiguratorCartLine(variantId, plan.quantity, props, 'Unable to add deposit');
        });
      });
    })
    .then(function() {
      if (addBtn) { addBtn.textContent = 'Going to Checkout...'; }
      var pricing = getPricingContext();
      trackEvent('vc_cart_update_final', {
        total_amount: total,
        deposit_amount: deposit,
        deposit_charged_amount: depositPlan ? depositPlan.chargedDeposit : deposit,
        deposit_quantity: depositPlan ? depositPlan.quantity : null,
        deposit_unit_price: depositPlan ? depositPlan.unitPrice : null,
        surcharge_amount: localizeContainerPrice(calculateEstimate()),
        currency: pricing.currencyCode,
        pricing_country: pricing.countryCode,
        // Preserve the legacy EUR fields only where they remain semantically true.
        total_eur: pricing.currencyCode === 'EUR' ? total : null,
        deposit_eur: pricing.currencyCode === 'EUR' ? deposit : null,
        surcharge_eur: calculateEstimate()
      });
      apiPost('/api/funnel/cart-add', { cartProperties: props });

      var attrPromise = Object.keys(cartAttrs).length
        ? fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: cartAttrs })
          }).catch(function () { /* non-fatal */ })
        : Promise.resolve();

      attrPromise.then(function () {
        window.location.href = '/checkout';
      });
    })
    .catch(function(err) {
      console.error('Cart update failed:', err, '| variant:', variantId, '| deposit:', depositVariantId);
      if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Checkout & Pay Deposit'; }
      alert('Failed to update cart. Please try again.\n(' + err.message + ')');
    });
  }

  /* ================================================================
     CONTACT CAPTURE (Summary Stage)
     ================================================================ */
  function loadContact() {
    try {
      var raw = localStorage.getItem(CONTACT_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      if (data.email && data.phone && data.sessionId) {
        state.userEmail = data.email;
        state.userPhone = data.phone;
        state.userCountryCode = data.countryCode || '+34';
        state.whatsappOptIn = data.whatsappOptIn || false;
        state.sessionId = data.sessionId;
        state.contactCaptured = true;
      }
    } catch (e) { /* silent */ }
  }

  function saveContact() {
    var digits = document.getElementById('vc-gate-phone').value.replace(/[\s\-\(\)]/g, '');
    var cc = document.getElementById('vc-gate-cc').value;
    var isLoggedIn = window.vcCustomer && window.vcCustomer.loggedIn;
    var emailEl = document.getElementById('vc-gate-email');
    var email = isLoggedIn ? window.vcCustomer.email : (emailEl ? emailEl.value.trim() : '');

    state.userEmail = email;
    state.userCountryCode = cc;
    state.userPhone = cc + digits;
    state.whatsappOptIn = document.getElementById('vc-gate-optin').checked;
    state.contactCaptured = true;

    if (!state.sessionId) state.sessionId = generateUUID();

    try {
      localStorage.setItem(CONTACT_KEY, JSON.stringify({
        email: state.userEmail,
        phone: state.userPhone,
        countryCode: state.userCountryCode,
        whatsappOptIn: state.whatsappOptIn,
        sessionId: state.sessionId,
        capturedAt: new Date().toISOString()
      }));
    } catch (e) { /* silent */ }
  }

  function validateContactForm() {
    var errors = [];
    var isLoggedIn = window.vcCustomer && window.vcCustomer.loggedIn;
    var emailEl = document.getElementById('vc-gate-email');
    var phoneEl = document.getElementById('vc-gate-phone');
    var optinEl = document.getElementById('vc-gate-optin');
    var emailErr = document.getElementById('vc-gate-email-error');
    var phoneErr = document.getElementById('vc-gate-phone-error');
    var optinErr = document.getElementById('vc-gate-optin-error');

    // Clear previous errors
    [emailEl, phoneEl].forEach(function (el) { if (el) el.classList.remove('vc-input-error'); });
    [emailErr, phoneErr, optinErr].forEach(function (el) { if (el) el.textContent = ''; });

    // Email (skip when logged in — email comes from Shopify account)
    if (!isLoggedIn) {
      var email = emailEl ? emailEl.value.trim() : '';
      if (!email) {
        errors.push('email');
        if (emailEl) emailEl.classList.add('vc-input-error');
        if (emailErr) emailErr.textContent = 'Please enter your email address';
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errors.push('email');
        if (emailEl) emailEl.classList.add('vc-input-error');
        if (emailErr) emailErr.textContent = 'Please enter a valid email address';
      }
    }

    // Phone
    var digits = phoneEl ? phoneEl.value.replace(/[\s\-\(\)]/g, '') : '';
    if (!digits) {
      errors.push('phone');
      if (phoneEl) phoneEl.classList.add('vc-input-error');
      if (phoneErr) phoneErr.textContent = 'Please enter your phone number';
    } else if (digits.length < 7 || digits.length > 15 || !/^\d+$/.test(digits)) {
      errors.push('phone');
      if (phoneEl) phoneEl.classList.add('vc-input-error');
      if (phoneErr) phoneErr.textContent = 'Please enter a valid phone number (7-15 digits)';
    }

    // Terms & Conditions
    if (optinEl && !optinEl.checked) {
      errors.push('optin');
      if (optinErr) optinErr.textContent = 'Please agree to the Terms & Conditions to continue';
    }

    return { valid: errors.length === 0, errors: errors };
  }

  function initContactCapture() {
    var emailEl = document.getElementById('vc-gate-email');
    var phoneEl = document.getElementById('vc-gate-phone');
    var ccEl = document.getElementById('vc-gate-cc');

    // Pre-fill from Shopify customer data
    if (window.vcCustomer && window.vcCustomer.email && emailEl) {
      emailEl.value = window.vcCustomer.email;
    }

    // Pre-fill from stored contact if partially available
    if (state.userEmail && emailEl && !emailEl.value) {
      emailEl.value = state.userEmail;
    }
    if (state.userCountryCode && ccEl) {
      ccEl.value = state.userCountryCode;
    }
    if (state.userPhone && phoneEl && !phoneEl.value) {
      // Strip country code prefix to show just the local number
      var stored = state.userPhone || '';
      var cc = state.userCountryCode || '';
      if (cc && stored.indexOf(cc) === 0) stored = stored.substring(cc.length);
      phoneEl.value = stored;
    }

    // Allow Enter key in contact fields to trigger confirm button
    [emailEl, phoneEl].forEach(function (el) {
      if (el) {
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            var btn = document.getElementById('vc-design-confirm-btn');
            if (btn) btn.click();
          }
        });
      }
    });
  }

  /**
   * Capture contact during design confirmation on the summary stage.
   * Validates, saves, sends funnel-entry API, adds to cart.
   * Returns true if contact is valid (or was already captured).
   */
  function captureContactOnConfirm() {
    if (state.contactCaptured) return true;

    var result = validateContactForm();
    if (!result.valid) {
      var emailEl = document.getElementById('vc-gate-email');
      var phoneEl = document.getElementById('vc-gate-phone');
      if (result.errors[0] === 'email' && emailEl) emailEl.focus();
      else if (result.errors[0] === 'phone' && phoneEl) phoneEl.focus();
      return false;
    }

    saveContact();
    addToCartInitial();
    trackEvent('vc_contact_form_submit', { has_shopify_acct: !!(window.vcCustomer && window.vcCustomer.loggedIn) });
    apiPost('/api/funnel/register', { shopifyCustomerId: (window.vcCustomer && window.vcCustomer.id) || null });

    // Notify Telegram: new funnel entry
    if (VC_API_URL) {
      try {
        var entryPayload = JSON.stringify({ email: state.userEmail || '', phone: state.userPhone || '' });
        fetch(VC_API_URL + '/funnel-entry', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: entryPayload, keepalive: true }).catch(function() {});
      } catch (e) { /* silent */ }
    }

    // Hide contact form after successful capture
    var contactSection = document.getElementById('vc-confirm-contact');
    if (contactSection) contactSection.style.display = 'none';

    return true;
  }

  /* ================================================================
     ORDER PIPELINE — PDF + Telegram + Email + Customer Preview
     Triggered when user confirms their design.
     ================================================================ */

  /**
   * Send the PDF + metadata to the Cloudflare Worker for Telegram + email delivery.
   * @param {Blob} pdfBlob - The PDF file as a Blob
   * @param {Object} orderData - UPT order data from buildUPTOrderData()
   * @param {string|null} configId - Share link config ID (optional)
   * @param {function(boolean)} callback - Success/fail callback
   */
  function sendOrderToWorker(pdfBlob, orderData, configId, callback) {
    if (!VC_API_URL) { if (callback) callback(false); return; }

    // Convert blob to base64
    var reader = new FileReader();
    reader.onloadend = function () {
      var base64 = reader.result.split(',')[1]; // strip data:...;base64, prefix
      console.log('[VC] PDF base64 length:', base64 ? base64.length : 0, 'chars');
      if (!base64 || base64.length < 100) {
        console.error('[VC] PDF base64 is empty or too small — aborting send');
        if (callback) callback(false);
        return;
      }
      if (base64.substring(0, 7) !== 'JVBERi0') {
        console.warn('[VC] PDF base64 does not start with JVBERi0 (%PDF-1.) — may be corrupt. Starts with:', base64.substring(0, 20));
      }
      var payload = {
        pdfBase64: base64,
        customerEmail: orderData.customerEmail || state.userEmail || '',
        customerName: state.customerName || '',
        customerPhone: state.userPhone || '',
        containerModel: orderData.containerModel || '',
        pattern: orderData.pattern || '',
        jumpCount: state.jumpCount || '',
        canopyCourses: state.canopyCourses || '',
        mainCanopy: orderData.mainCanopy || '',
        reserveCanopy: orderData.reserveCanopy || '',
        configId: configId || '',
        shareUrl: configId ? generateShareUrl(configId) : ''
      };
      var xhr = new XMLHttpRequest();
      xhr.open('POST', VC_API_URL + '/order', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function () {
        if (callback) callback(xhr.status === 200);
      };
      xhr.onerror = function () { if (callback) callback(false); };
      xhr.send(JSON.stringify(payload));
    };
    reader.onerror = function () { if (callback) callback(false); };
    reader.readAsDataURL(pdfBlob);
  }

  /**
   * Full order pipeline: PDF → save config → send to Telegram + email → show preview.
   * Called when user clicks "Confirm this design".
   */
  function triggerOrderPipeline() {
    console.log('[VC] triggerOrderPipeline: starting order pipeline...');
    var confirmCard = document.getElementById('vc-design-confirm');
    if (!confirmCard) { console.error('[VC] triggerOrderPipeline: confirm card not found'); return; }

    // Show loading spinner
    confirmCard.classList.add('vc-generating');

    // Step 1: Generate PDF
    generateUPTOrderPDF(function (pdfBlob, pdfDataUrl) {
      if (!pdfBlob) {
        confirmCard.classList.remove('vc-generating');
        confirmCard.classList.add('vc-confirmed');
        var textEl = confirmCard.querySelector('.vc-design-confirm-text');
        if (textEl) {
          textEl.textContent = 'Design confirmed! Your configuration has been saved. We\'ll contact you shortly.';
          textEl.style.color = '#b45309';
        }
        console.error('[VC] PDF generation failed — design confirmed without PDF. Check if jsPDF loaded from CDN.');

        // Still proceed with config save + preview even without PDF
        saveConfigToWorker(function (configId) {
          var shareUrl = configId ? generateShareUrl(configId) : generateClientShareUrl();
          confirmCard.classList.remove('vc-generating');
          confirmCard.classList.add('vc-confirmed');
          showOrderPreview(null, shareUrl, buildUPTOrderData());
        });
        return;
      }

      // Step 2: Save config for share link
      saveConfigToWorker(function (configId) {
        var shareUrl = configId ? generateShareUrl(configId) : generateClientShareUrl();

        // Step 3: Send to Worker (Telegram + email)
        var orderData = buildUPTOrderData();
        if (VC_API_URL) {
          sendOrderToWorker(pdfBlob, orderData, configId, function (ok) {
            if (ok) { console.log('[VC] Order sent to Telegram + email'); }
            else { console.warn('[VC] Order delivery may have failed — backend not reachable'); }
          });
        } else {
          console.info('[VC] No backend URL configured — PDF generated locally only');
        }

        // Hide spinner, show confirmed state
        confirmCard.classList.remove('vc-generating');
        confirmCard.classList.add('vc-confirmed');
        var textEl = confirmCard.querySelector('.vc-design-confirm-text');
        if (textEl) textEl.textContent = 'Design confirmed — you\'re all set!';

        // Step 4: Show customer preview
        showOrderPreview(pdfDataUrl, shareUrl, orderData);
      });
    });
  }

  /**
   * Show customer-facing order preview (rig image + key specs + share link).
   * Does NOT show full color data — that stays in the PDF for the shop.
   */
  function showOrderPreview(pdfDataUrl, shareUrl, orderData) {
    // Remove any existing preview
    var existing = document.getElementById('vc-order-preview');
    if (existing) existing.remove();

    var wrap = document.createElement('div');
    wrap.id = 'vc-order-preview';
    wrap.className = 'vc-order-preview';

    var html = '';
    html += '<div class="vc-order-preview-header">';
    html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="28" height="28"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>';
    html += '<div>';
    html += '<h3>Design Confirmed</h3>';
    html += '<p>Your UPT Vector 3 configuration has been saved. We\'ll review it and contact you via email and WhatsApp.</p>';
    html += '</div>';
    html += '</div>';

    // Visual rig preview
    var selDesign = state.savedDesigns && state.savedDesigns[state.selectedDesignIndex || 0];
    if (selDesign && selDesign.previewPngs) {
      html += '<div class="vc-order-preview-rig vc-order-preview-rig-grid">';
      ['back','front','right','left'].forEach(function (k) {
        if (selDesign.previewPngs[k]) {
          html += '<img src="' + selDesign.previewPngs[k] + '" alt="' + k + ' view" class="vc-order-preview-rig-img" />';
        }
      });
      html += '</div>';
    } else if (selDesign && selDesign.previewPng) {
      html += '<div class="vc-order-preview-rig">';
      html += '<img src="' + selDesign.previewPng + '" alt="Your rig design" class="vc-order-preview-rig-img" />';
      html += '</div>';
    }

    // Key specs (customer-safe — no full color data)
    html += '<div class="vc-order-preview-specs">';
    html += '<div class="vc-order-preview-spec"><strong>Container:</strong> ' + (orderData.containerModel || 'TBD') + '</div>';
    html += '<div class="vc-order-preview-spec"><strong>Pattern:</strong> ' + (orderData.pattern || '') + '</div>';
    html += '<div class="vc-order-preview-spec"><strong>Main Canopy:</strong> ' + (orderData.mainCanopy || 'TBD') + '</div>';
    html += '<div class="vc-order-preview-spec"><strong>Reserve:</strong> ' + (orderData.reserveCanopy || 'TBD') + '</div>';
    if (orderData.options && orderData.options.length > 0) {
      html += '<div class="vc-order-preview-spec"><strong>Options:</strong> ' + orderData.options.join(', ') + '</div>';
    }
    html += '</div>';

    // Share row — QR (desktop only) + action buttons
    html += '<div class="vc-order-preview-share-row">';
    if (shareUrl) {
      // Desktop-only QR code of the share URL. Hidden on tablet/phone via CSS.
      // Generated by api.qrserver.com (simple <img>, no JS library needed).
      var qrSrc = 'https://api.qrserver.com/v1/create-qr-code/?size=180x180&margin=2&data=' +
        encodeURIComponent(shareUrl);
      html += '<div class="vc-order-preview-qr" aria-hidden="true">';
      html += '<img src="' + qrSrc + '" alt="QR code to open this configuration on a phone" class="vc-order-preview-qr-img" loading="lazy" />';
      html += '<span class="vc-order-preview-qr-label">Scan to send to your phone &mdash; easy to share on WhatsApp</span>';
      html += '</div>';
    }
    html += '<div class="vc-order-preview-actions">';
    // PDF download removed — order PDF is internal only
    if (shareUrl) {
      // Copy share link button
      html += '<button type="button" class="vc-order-preview-btn vc-order-preview-share" id="vc-order-copy-link">';
      html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>';
      html += ' Copy Share Link';
      html += '</button>';
      // WhatsApp share button
      html += '<button type="button" class="vc-order-preview-btn vc-order-preview-wa" id="vc-order-wa-share">';
      html += '<svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.625.846 5.059 2.284 7.034L.789 23.492a.5.5 0 00.612.638l4.684-1.232A11.945 11.945 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-2.238 0-4.308-.725-5.993-1.953l-.352-.258-3.28.863.88-3.215-.282-.448A9.956 9.956 0 012 12C2 6.486 6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z"/></svg>';
      html += ' Share via WhatsApp';
      html += '</button>';
    }
    html += '</div>';
    html += '</div>';

    wrap.innerHTML = html;

    // Wire up button handlers (avoids inline onclick + escaping issues)
    if (shareUrl) {
      var copyBtn = wrap.querySelector('#vc-order-copy-link');
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          navigator.clipboard.writeText(shareUrl).then(function () {
            copyBtn.textContent = 'Copied!';
            setTimeout(function () { copyBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg> Copy Share Link'; }, 2000);
          });
        });
      }
      var waBtn = wrap.querySelector('#vc-order-wa-share');
      if (waBtn) {
        waBtn.addEventListener('click', function () {
          var msg = 'Check out my UPT Vector 3 configuration: ' + shareUrl;
          window.open('https://wa.me/?text=' + encodeURIComponent(msg), '_blank');
        });
      }
    }

    // Insert after the confirm card
    var confirmCard = document.getElementById('vc-design-confirm');
    if (confirmCard && confirmCard.parentNode) {
      confirmCard.parentNode.insertBefore(wrap, confirmCard.nextSibling);
    }

  }

  /* ================================================================
     PHASE 6 – SEND ORDER FORM (legacy)
     ================================================================ */
  function sendOrderForm() {
    var btn = $('vc-send-order-form');
    if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }

    var props = buildCartProperties();
    var fullConfig = {
      measurements: {
        jumpCount: state.jumpCount, canopyCourses: state.canopyCourses, dzAltitude: state.dzAltitude, dzAltUnit: state.dzAltUnit,
        height: state.height, weight: state.weight, chest: state.chest, waist: state.waist,
        torso: state.torso, legPad: state.legPad, inseam: state.inseam
      },
      pattern: state.pattern,
      containerColorMap: state.containerColorMap,
      embroidery: state.containerEmbroidery,
      harness: { harnessType: state.harnessType, legPadConfig: state.legPadConfig, rolledEdge: state.rolledEdge, minus2: state.minus2, legPadCovers: state.legPadCovers, backpad: state.backpad, stabilizers: state.stabilizers },
      deployment: { mainHandle: state.mainHandle, mainDBag: state.mainDBag, pilotChuteFabric: state.pilotChuteFabric, pilotChuteSize: state.pilotChuteSize, reserveHandle: state.reserveHandle, emergencySystem: state.emergencySystem, riserType: state.riserType, ringType: state.ringType, riserCovers: state.riserCovers, riserLength: state.riserLength, toggleType: state.toggleType, hookKnife: state.hookKnife },
      canopy: { mainCanopyBrand: state.mainCanopyBrand, mainCanopyModel: state.mainCanopyModel, mainCanopySize: state.mainCanopySize, reserveCanopyBrand: state.reserveCanopyBrand, reserveCanopyModel: state.reserveCanopyModel, reserveCanopySize: state.reserveCanopySize, containerSize: state.containerSize, aad: state.aad },
      wingsuit: { isWingsuit: state.isWingsuit, wsDynamicCorners: state.wsDynamicCorners, wsBridle: state.wsBridle, wsSemiStowless: state.wsSemiStowless, wsDash1Shape: state.wsDash1Shape },
      cosmetic: { hardwareFinish: state.hardwareFinish, jcStitching: state.jcStitching, jcColor: state.jcColor, contrastStitch: state.contrastStitch, stitchColor: state.stitchColor, centerFlapPiping: state.centerFlapPiping },
      savedDesigns: (state.savedDesigns || []).map(function(d) { return { name: d.name, pattern: d.pattern }; }),
      surcharge: calculateEstimate(),
      summaryText: buildSummaryText(),
      cartProperties: props
    };

    trackEvent('vc_order_form_send', { design_name: (state.savedDesigns[0] || {}).name || '' });

    var base = getBackendUrl();
    if (base) {
      fetch(base + '/api/funnel/order-complete', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sessionId: state.sessionId,
          email: state.userEmail,
          phone: state.userPhone,
          customerName: state.customerName || '',
          fullConfiguration: fullConfig,
          timestamp: new Date().toISOString()
        })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Order form send failed');
        if (btn) { btn.textContent = 'Order Form Sent!'; }
        showOrderFormConfirmation();
      })
      .catch(function() {
        if (btn) { btn.disabled = false; btn.textContent = 'Confirm & Send Order Form'; }
        alert('Failed to send order form. Please try again or contact support.');
      });
    } else {
      // No backend — show confirmation anyway
      if (btn) { btn.textContent = 'Order Form Sent!'; }
      showOrderFormConfirmation();
    }
  }

  function showOrderFormConfirmation() {
    var msg = document.getElementById('vc-order-confirm-msg');
    if (msg) msg.style.display = '';
  }

  /* ================================================================
     PHASE 5 – EXIT DETECTION (abandoned cart)
     ================================================================ */
  var exitTracked = false;
  function trackExitIntent() {
    if (exitTracked) return;
    if (state.currentStage >= 1 && state.contactCaptured) {
      exitTracked = true;
      trackEvent('vc_exit_intent', { stage_name: 'vc-stage-' + state.currentStage });
      if (state.currentStage >= 6) {
        // User reached late stages — send summary-exit for abandoned cart recovery
        apiPost('/api/funnel/summary-exit', { designSummary: buildSummaryText(), lastStage: state.currentStage });
      }
    }
  }

  /* ================================================================
     PERSISTENCE (localStorage)
     ================================================================ */
  var STORAGE_KEY = 'vc-vector3-config-v2';
  // Bump when the shape of `state` changes incompatibly (e.g. containerColorMap key format).
  // Saved payloads with a different STATE_VERSION are discarded on load instead of shallow-merged.
  var STATE_VERSION = 1;

  function saveState() {
    try {
      var payload = { _v: STATE_VERSION, state: state };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) { /* silent */ }
  }

  function loadState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var parsed = JSON.parse(raw);

      // Back-compat: a legacy payload is a bare state object (no _v wrapper).
      // Only load it if it looks valid and has no _v field. Otherwise require a match.
      var saved;
      if (parsed && typeof parsed === 'object' && parsed._v !== undefined) {
        if (parsed._v !== STATE_VERSION) {
          console.warn('[VC] Saved state version ' + parsed._v + ' != current ' + STATE_VERSION + ' — discarding');
          localStorage.removeItem(STORAGE_KEY);
          return;
        }
        saved = parsed.state || {};
      } else {
        saved = parsed || {};
      }

      Object.keys(state).forEach(function (key) {
        if (saved.hasOwnProperty(key)) state[key] = saved[key];
      });
    } catch (e) { /* silent */ }
  }

  /* ---- State serialization for share/config links ---- */
  var CONFIG_SHARE_FIELDS = [
    'pattern','containerColorMap','savedDesigns','selectedDesignIndex',
    'containerSize','containerFit','containerManual',
    'harnessType','legPadConfig','rolledEdge','minus2','legPadCovers','backpad','stabilizers',
    'mainHandle','mainDBag','pilotChuteFabric','pilotChuteSize',
    'reserveHandle','emergencySystem','riserType',
    'ringType','riserCovers','riserLength','toggleType','hookKnife',
    'mainCanopyBrand','mainCanopyModel','mainCanopySize',
    'reserveCanopyBrand','reserveCanopyModel','reserveCanopySize',
    'includeMainCanopy','includeReserveCanopy','aad','exitWeight',
    'height','weight','chest','waist','torso','legPad','inseam','jumpCount',
    'canopyCourses','dzAltitude','dzAltUnit','sex','previousSerialNumber','specialInstructions',
    'pcHandleColor1','pcHandleColor2',
    'isWingsuit','wsDynamicCorners','wsBridle','wsSemiStowless','wsDash1Shape',
    'hardwareFinish','jcStitching','jcColor','centerFlapPiping',
    'contrastStitch','stitchColor','bindingColor','webbingColor',
    'containerEmbroidery','designConfirmed','colorDesignerSaved'
  ];

  function serializeState() {
    var data = {};
    CONFIG_SHARE_FIELDS.forEach(function (key) {
      if (state[key] !== undefined && state[key] !== null && state[key] !== '') {
        data[key] = state[key];
      }
    });
    return JSON.stringify(data);
  }

  function deserializeState(jsonStr) {
    try {
      var data = typeof jsonStr === 'string' ? JSON.parse(jsonStr) : jsonStr;
      CONFIG_SHARE_FIELDS.forEach(function (key) {
        if (data.hasOwnProperty(key)) state[key] = data[key];
      });
      // Ensure savedDesigns is an array
      if (!Array.isArray(state.savedDesigns)) state.savedDesigns = [];
      if (state.selectedDesignIndex >= state.savedDesigns.length) state.selectedDesignIndex = 0;
      return true;
    } catch (e) {
      console.error('[VC] deserializeState error:', e);
      return false;
    }
  }

  // Worker API URL
  var VC_API_URL = window.VC_API_URL || 'https://vc-order-api.young-sky-a2c1.workers.dev';

  function saveConfigToWorker(callback) {
    if (!VC_API_URL) { if (callback) callback(null); return; }
    var payload = serializeState();
    var xhr = new XMLHttpRequest();
    xhr.open('POST', VC_API_URL + '/config', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function () {
      if (xhr.status === 200) {
        try {
          var resp = JSON.parse(xhr.responseText);
          if (callback) callback(resp.id || null);
        } catch (e) { if (callback) callback(null); }
      } else { if (callback) callback(null); }
    };
    xhr.onerror = function () { if (callback) callback(null); };
    xhr.send(payload);
  }

  function loadConfigFromWorker(configId, callback) {
    if (!VC_API_URL || !configId) { if (callback) callback(false); return; }
    var xhr = new XMLHttpRequest();
    xhr.open('GET', VC_API_URL + '/config/' + encodeURIComponent(configId), true);
    xhr.onload = function () {
      if (xhr.status === 200) {
        var ok = deserializeState(xhr.responseText);
        if (callback) callback(ok);
      } else { if (callback) callback(false); }
    };
    xhr.onerror = function () { if (callback) callback(false); };
    xhr.send();
  }

  /**
   * Synchronously load share link data from URL params.
   * Called during init() BEFORE stage determination.
   * Returns true if a config was restored, false otherwise.
   */
  function loadShareLinkData() {
    var params = new URLSearchParams(window.location.search);

    // Client-side share link: ?vcd=base64data (synchronous)
    var vcd = params.get('vcd');
    if (vcd) {
      try {
        var jsonStr = decodeURIComponent(escape(atob(vcd.replace(/-/g, '+').replace(/_/g, '/'))));
        var ok = deserializeState(jsonStr);
        if (ok) {
          console.log('[VC] Shared configuration restored from URL');
          return true;
        }
      } catch (e) {
        console.error('[VC] Failed to restore shared configuration:', e);
      }
    }

    // Backend share link: ?vc=configId (async — handled after init)
    var configId = params.get('vc');
    if (configId && VC_API_URL) {
      // Mark as shared so init bypasses the gate; async load will finish later
      loadConfigFromWorker(configId, function (ok) {
        if (ok) {
          restoreInputs();
          state.isSharedConfig = true;
          goToStage(8);
        } else {
          // Share link expired / 404 / network error — surface it and clean the URL
          // so a reload doesn't repeat the failed fetch.
          try {
            var cleanUrl = window.location.origin + window.location.pathname;
            window.history.replaceState({}, '', cleanUrl);
          } catch (e) { /* silent */ }
          if (dom && dom.errors) {
            showErrors(['Shared design link is no longer available (expired or not found). Starting a fresh configuration.']);
          } else {
            console.warn('[VC] Shared config load failed; continuing with default state');
          }
        }
      });
      return true; // Optimistically bypass gate; async will fill in data
    }

    return false;
  }

  function generateShareUrl(configId) {
    var base = window.location.origin + window.location.pathname;
    return base + '?vc=' + encodeURIComponent(configId);
  }

  /**
   * Generate a client-side share URL by encoding essential config state as base64.
   * Used when no backend is available. Strips heavy data (previewPng) to keep URL short.
   */
  function generateClientShareUrl() {
    // Build a compact state object — exclude heavy binary data
    var data = {};
    CONFIG_SHARE_FIELDS.forEach(function (key) {
      if (state[key] !== undefined && state[key] !== null && state[key] !== '') {
        data[key] = state[key];
      }
    });
    // Strip preview images from savedDesigns (too large for URL)
    if (data.savedDesigns) {
      data.savedDesigns = data.savedDesigns.map(function (d) {
        var copy = {};
        Object.keys(d).forEach(function (k) {
          if (k !== 'previewPng' && k !== 'previewPngs') copy[k] = d[k];
        });
        return copy;
      });
    }
    var jsonStr = JSON.stringify(data);
    // Base64 encode with URL-safe chars
    var b64 = btoa(unescape(encodeURIComponent(jsonStr))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    var base = window.location.origin + window.location.pathname;
    return base + '?vcd=' + b64;
  }

  /* ---- Restore form inputs from state ---- */
  function restoreInputs() {
    // Stage 1
    var fields1 = ['height', 'weight', 'chest', 'waist', 'torso', 'legPad', 'inseam'];
    fields1.forEach(function (f) { var el = $('vc-' + f); if (el && state[f]) el.value = state[f]; });
    var jumpEl = $('vc-jumpcount');
    if (jumpEl && (state.jumpCount || state.jumpCount === 0)) jumpEl.value = state.jumpCount;
    var coursesEl = $('vc-canopycourses');
    if (coursesEl) coursesEl.value = state.canopyCourses || 0;
    // Restore altitude unit toggle
    var savedUnit = state.dzAltUnit || 'm';
    var altToggleEl = $('vc-alt-unit-toggle');
    if (altToggleEl) {
      altToggleEl.querySelectorAll('.vc-unit-btn').forEach(function (b) {
        b.classList.toggle('vc-unit-active', b.dataset.unit === savedUnit);
      });
    }
    var altEl = $('vc-dzaltitude');
    var slA = $('vc-sl-dzaltitude');
    var rangeMaxEl = $('vc-alt-range-max');
    if (savedUnit === 'ft') {
      if (altEl) { altEl.max = '10000'; altEl.step = '100'; }
      if (slA) { slA.max = '10000'; slA.step = '100'; }
      if (rangeMaxEl) rangeMaxEl.textContent = '10,000 ft';
    } else {
      if (altEl) { altEl.max = '3048'; altEl.step = '50'; }
      if (slA) { slA.max = '3048'; slA.step = '50'; }
      if (rangeMaxEl) rangeMaxEl.textContent = '3,048 m';
    }
    if (altEl) altEl.value = state.dzAltitude || 0;
    // Restore slider positions
    var slJ = $('vc-sl-jumpcount');
    if (slJ) slJ.value = Math.min(state.jumpCount || 0, 3500);
    var slC = $('vc-sl-canopycourses');
    if (slC) slC.value = state.canopyCourses || 0;
    if (slA) slA.value = Math.min(state.dzAltitude || 0, parseFloat(slA.max));

    // Sex radio
    setRadio('sex', state.sex || 'Male');
    // Previous serial number
    var prevSerialEl = $('vc-previousSerial');
    if (prevSerialEl) prevSerialEl.value = state.previousSerialNumber || '';
    syncMeasurementMode();
    // Special instructions
    var specInstrEl = $('vc-specialInstructions');
    if (specInstrEl) specInstrEl.value = state.specialInstructions || '';

    // Stage 3
    var radios3 = ['harnessType', 'legPadConfig', 'backpad', 'stabilizers'];
    radios3.forEach(function (name) { setRadio(name, state[name]); });
    var lpcEl = $('vc-legPadCovers');
    if (lpcEl) lpcEl.checked = state.legPadCovers;
    var reEl = $('vc-rolledEdge');
    if (reEl) reEl.checked = state.rolledEdge;
    var m2El = $('vc-minus2');
    if (m2El) m2El.checked = state.minus2;

    // Stage 4
    // Backward compat: old mainHandles array → mainHandle string
    if (state.mainHandles && !state.mainHandle) {
      state.mainHandle = Array.isArray(state.mainHandles) ? state.mainHandles[0] : state.mainHandles;
      delete state.mainHandles;
    }
    setRadio('mainHandle', state.mainHandle || 'plastic-handle');
    // PC Handle colors
    var pcC1 = $('vc-pcHandleColor1');
    var pcC2 = $('vc-pcHandleColor2');
    if (pcC1) pcC1.value = state.pcHandleColor1 || '';
    if (pcC2) pcC2.value = state.pcHandleColor2 || '';
    // Show/hide handle color section (hidden for plastic-handle)
    var hcDiv = $('vc-pc-handle-colors');
    if (hcDiv) hcDiv.style.display = (state.mainHandle === 'plastic-handle') ? 'none' : '';
    setRadio('mainDBag', state.mainDBag);
    setRadio('pilotChuteFabric', state.pilotChuteFabric);
    setRadio('pilotChuteSize', state.pilotChuteSize);
    setRadio('reserveHandle', state.reserveHandle);
    // Backward compat: old 'skyhook-spectra' → skyhook
    if (state.emergencySystem === 'skyhook-spectra') {
      state.emergencySystem = 'skyhook';
    }
    // Backward compat: old 'ripcord' value → rsl
    if (state.emergencySystem === 'ripcord') {
      state.emergencySystem = 'rsl';
    }
    setRadio('emergencySystem', state.emergencySystem);
    // Backward compat: old 'type-8-large' → split first
    if (state.riserType === 'type-8-large') {
      state.riserType = 'type-8';
      state.ringType = 'large';
    }
    // Backward compat: type-17/type-8 moved from riser to ring
    if (state.riserType === 'type-17' || state.riserType === 'type-8') {
      state.ringType = state.riserType;
      state.riserType = 'standard';
    }
    // Backward compat: old ring values mini/large → type-17/type-8
    if (state.ringType === 'mini') state.ringType = 'type-17';
    if (state.ringType === 'large') state.ringType = 'type-8';
    setRadio('riserType', state.riserType);
    setRadio('ringType', state.ringType || 'type-17');
    setRadio('riserCovers', state.riserCovers || 'magnetic');
    // Backward compat: old 'standard'/'long'/'short' → numeric values
    if (state.riserLength === 'standard') state.riserLength = '21';
    if (state.riserLength === 'long') state.riserLength = '23';
    if (state.riserLength === 'short') state.riserLength = '19';
    setRadio('riserLength', state.riserLength || '21');
    setRadio('toggleType', state.toggleType || 'tru-lok');
    setRadio('hookKnife', state.hookKnife || 'yes');

    // Stage 5 (canopy include toggles + combined dropdowns)
    var inclMainCB = $('vc-include-main');
    if (inclMainCB) inclMainCB.checked = state.includeMainCanopy;
    var inclReserveCB = $('vc-include-reserve');
    if (inclReserveCB) inclReserveCB.checked = state.includeReserveCanopy;
    if (dom.mainCanopySelect && state.mainCanopyBrand && state.mainCanopyModel) {
      dom.mainCanopySelect.value = state.mainCanopyBrand + '||' + state.mainCanopyModel;
      renderSizeButtons('vc-main-size-buttons', state.mainCanopyModel, 'main');
    }
    if (dom.reserveCanopySelect && state.reserveCanopyBrand && state.reserveCanopyModel) {
      dom.reserveCanopySelect.value = state.reserveCanopyBrand + '||' + state.reserveCanopyModel;
      renderSizeButtons('vc-reserve-size-buttons', state.reserveCanopyModel, 'reserve');
    }
    setRadio('aad', state.aad);
    syncExitWeight();
    updateContainerResult();
    updateWingLoading();

    // Restore manual container override
    var manualToggle = $('vc-container-manual-toggle');
    if (manualToggle && state.containerManual) {
      manualToggle.checked = true;
      var picker = $('vc-container-manual-picker');
      var autoResult = $('vc-container-result');
      if (picker) picker.style.display = '';
      if (autoResult) autoResult.style.display = 'none';
      var manualSel = $('vc-container-manual-select');
      if (manualSel && state.containerSize) {
        manualSel.value = state.containerSize;
        showManualContainerInfo(state.containerSize);
      }
    }

    // Restore product cards + toggle visibility
    renderCanopyProductCard('vc-main-product-card', state.mainCanopyModel, state.mainCanopySize, window.vcMainCanopyProducts);
    renderCanopyProductCard('vc-reserve-product-card', state.reserveCanopyModel, state.reserveCanopySize, window.vcReserveCanopyProducts);
    updateCanopyToggleVisibility('main');
    updateCanopyToggleVisibility('reserve');

    // Stage 6
    var wsToggle = $('vc-wingsuit-toggle');
    if (wsToggle) {
      wsToggle.checked = state.isWingsuit;
      toggleWingsuit(state.isWingsuit);
      var wsCBs = ['wsDynamicCorners', 'wsBridle', 'wsSemiStowless', 'wsDash1Shape'];
      wsCBs.forEach(function (key) {
        var cb = $('vc-' + key);
        if (cb) cb.checked = state[key];
      });
      // Restore WS badge on U-Stow card
      if (state.wsSemiStowless) syncWingSuitDBag(true);
    }

    // Stage 7
    setRadio('hardwareFinish', state.hardwareFinish);
    var jcEl = $('vc-jcStitching');
    if (jcEl) jcEl.checked = state.jcStitching;
    var pipEl = $('vc-centerFlapPiping');
    if (pipEl) pipEl.checked = state.centerFlapPiping;

    // Stage 2 - contrast stitching
    var csCheck = $('vc-contrast-stitch');
    if (csCheck) {
      csCheck.checked = state.contrastStitch;
      var stPicker = $('vc-stitch-section');
      if (stPicker) stPicker.style.display = state.contrastStitch ? '' : 'none';
    }
  }

  function setRadio(name, value) {
    var radios = document.querySelectorAll('input[name="vc-' + name + '"]');
    for (var i = 0; i < radios.length; i++) {
      radios[i].checked = radios[i].value === value;
      updateCardSelected(radios[i]);
    }
  }

  function updateCardSelected(input) {
    var card = input.closest('.vc-option-card');
    if (card) {
      if (input.type === 'radio') {
        // Deselect siblings
        var parent = card.parentNode;
        var siblings = parent.querySelectorAll('.vc-option-card');
        for (var i = 0; i < siblings.length; i++) siblings[i].classList.remove('selected');
      }
      card.classList.toggle('selected', input.checked);
    }
  }

  function toggleWingsuit(enabled) {
    var opts = $('vc-ws-options');
    var toggle = $('vc-ws-toggle-wrap');
    if (opts) {
      opts.classList.toggle('visible', enabled);
    }
    if (toggle) {
      toggle.classList.toggle('active', enabled);
    }
  }

  /* ================================================================
     EVENT BINDING
     ================================================================ */

  function syncWingSuitDBag(checked) {
    var badge = $('vc-ustow-ws-badge');
    if (checked) {
      // Select U-Stow radio in Deploy stage
      state.mainDBag = 'u-stow';
      setRadio('mainDBag', 'u-stow');
      if (badge) badge.style.display = '';
    } else {
      if (badge) badge.style.display = 'none';
    }
  }

  function closeLightbox() {
    if (!dom.lightbox) return;
    dom.lightbox.classList.remove('open');
    dom.lightboxImg.style.width = '';
    dom.lightboxImg.style.height = '';
    document.body.style.overflow = '';
  }

  function bindEvents() {
    // Navigation
    dom.nextBtn.addEventListener('click', nextStage);
    dom.prevBtn.addEventListener('click', prevStage);

    // Summary navigation buttons
    var reconfigBtn = $('vc-summary-reconfigure');
    if (reconfigBtn) reconfigBtn.addEventListener('click', function () { goToStage(STAGE_ORDER[0]); });

    // Progress arrow buttons
    if (dom.progressPrev) {
      dom.progressPrev.addEventListener('click', function () { prevStage(); });
    }
    if (dom.progressNext) {
      dom.progressNext.addEventListener('click', function () {
        nextStage();
      });
    }

    // Progress bar
    dom.progressList.addEventListener('click', function (e) {
      var step = e.target.closest('.vc-progress-step');
      if (!step) return;
      var n = parseInt(step.dataset.step, 10);
      var nIdx = STAGE_ORDER.indexOf(n);
      var maxIdx = STAGE_ORDER.indexOf(state.maxVisited);
      if (nIdx >= 0 && nIdx <= maxIdx) goToStage(n);
    });
    dom.progressList.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        var step = e.target.closest('.vc-progress-step');
        if (step) {
          e.preventDefault();
          var n = parseInt(step.dataset.step, 10);
          var nIdx = STAGE_ORDER.indexOf(n);
          var maxIdx = STAGE_ORDER.indexOf(state.maxVisited);
          if (nIdx >= 0 && nIdx <= maxIdx) goToStage(n);
        }
      }
    });

    // Stage 1: inputs
    var sliderMap = {
      'vc-jumpcount': 'vc-sl-jumpcount',
      'vc-canopycourses': 'vc-sl-canopycourses',
      'vc-dzaltitude': 'vc-sl-dzaltitude'
    };
    dom.stage1.addEventListener('input', function (e) {
      var t = e.target;
      var map = {
        'vc-height': 'height', 'vc-weight': 'weight', 'vc-chest': 'chest',
        'vc-waist': 'waist', 'vc-torso': 'torso', 'vc-legPad': 'legPad', 'vc-inseam': 'inseam',
        'vc-jumpcount': 'jumpCount', 'vc-canopycourses': 'canopyCourses', 'vc-dzaltitude': 'dzAltitude'
      };
      if (map[t.id]) {
        var v = parseFloat(t.value); state[map[t.id]] = isNaN(v) ? '' : v;
        if (t.id === 'vc-weight') syncExitWeight();
        // Jump count / course / altitude changes still used by wing loading calc internally
        // Sync number input → slider
        if (sliderMap[t.id]) {
          var sl = $(sliderMap[t.id]);
          if (sl) sl.value = Math.min(parseFloat(t.value) || 0, parseFloat(sl.max));
        }
        saveState();
      }

      // Sync slider → number input
      var reverseSliderMap = {
        'vc-sl-jumpcount': { input: 'vc-jumpcount', key: 'jumpCount' },
        'vc-sl-canopycourses': { input: 'vc-canopycourses', key: 'canopyCourses' },
        'vc-sl-dzaltitude': { input: 'vc-dzaltitude', key: 'dzAltitude' }
      };
      if (reverseSliderMap[t.id]) {
        var cfg = reverseSliderMap[t.id];
        var inp = $(cfg.input);
        if (inp) inp.value = t.value;
        state[cfg.key] = parseFloat(t.value) || 0;
        // (max WL display removed)
        saveState();
      }

      // Text inputs: previous serial number
      if (t.id === 'vc-previousSerial') {
        state.previousSerialNumber = t.value;
        syncMeasurementMode();
        if (hasPreviousVectorSerial()) clearErrors();
        saveState();
      }
    });

    // Sex radio in Stage 1
    dom.stage1.addEventListener('change', function (e) {
      if (e.target.name === 'vc-sex') {
        state.sex = e.target.value;
        saveState();
      }
    });

    // Altitude unit toggle (m / ft)
    var altToggle = $('vc-alt-unit-toggle');
    if (altToggle) {
      altToggle.addEventListener('click', function (e) {
        var btn = e.target.closest('.vc-unit-btn');
        if (!btn || btn.classList.contains('vc-unit-active')) return;
        var unit = btn.dataset.unit;
        var prev = state.dzAltUnit || 'm';
        var val = parseFloat(state.dzAltitude) || 0;
        // Convert value
        if (prev === 'm' && unit === 'ft') val = Math.round(val * 3.28084);
        else if (prev === 'ft' && unit === 'm') val = Math.round(val / 3.28084);
        state.dzAltUnit = unit;
        state.dzAltitude = val;
        // Update active button
        altToggle.querySelectorAll('.vc-unit-btn').forEach(function (b) { b.classList.remove('vc-unit-active'); });
        btn.classList.add('vc-unit-active');
        // Update input/slider ranges
        var inp = $('vc-dzaltitude');
        var sl = $('vc-sl-dzaltitude');
        var rangeMax = $('vc-alt-range-max');
        if (unit === 'ft') {
          if (inp) { inp.max = '10000'; inp.step = '100'; inp.value = val; }
          if (sl) { sl.max = '10000'; sl.step = '100'; sl.value = Math.min(val, 10000); }
          if (rangeMax) rangeMax.textContent = '10,000 ft';
        } else {
          if (inp) { inp.max = '3048'; inp.step = '50'; inp.value = val; }
          if (sl) { sl.max = '3048'; sl.step = '50'; sl.value = Math.min(val, 3048); }
          if (rangeMax) rangeMax.textContent = '3,048 m';
        }
        // (max WL display removed)
        saveState();
      });
    }

    // Stage 2: patterns (event delegation)
    dom.patternGrid.addEventListener('click', function (e) {
      var card = e.target.closest('.vc-pattern-card');
      if (card) selectPattern(card.dataset.pattern);
    });
    dom.patternGrid.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        var card = e.target.closest('.vc-pattern-card');
        if (card) { e.preventDefault(); selectPattern(card.dataset.pattern); }
      }
    });

    // Stage 2: all swatch clicks (event delegation on stage 2)
    dom.stage2.addEventListener('click', handleSwatchClick);

    // Stage 2: contrast stitching toggle
    var csCheck = $('vc-contrast-stitch');
    if (csCheck) {
      csCheck.addEventListener('change', function () {
        state.contrastStitch = this.checked;
        var stSection = $('vc-stitch-section');
        if (stSection) stSection.style.display = this.checked ? '' : 'none';
        saveState();
      });
    }

    // Stage 2: Color Designer popup (uses outer-scope openColorDesignerPopup)
    var openColorPopup = $('vc-open-color-popup');
    if (openColorPopup) openColorPopup.addEventListener('click', openColorDesignerPopup);

    // Stage 2: 3D Preview popup
    var open3d = $('vc-open-3d-preview');
    if (open3d) {
      open3d.addEventListener('click', function () {
        if (window.VC3DPreview) window.VC3DPreview.open();
      });
    }

    // Stage 3: leg pad covers toggle
    var lpcCheck = $('vc-legPadCovers');
    if (lpcCheck) {
      lpcCheck.addEventListener('change', function () {
        state.legPadCovers = this.checked;
        saveState();
      });
    }

    // Stage 3: rolled edge checkbox
    var reCheck = $('vc-rolledEdge');
    if (reCheck) {
      reCheck.addEventListener('change', function () {
        state.rolledEdge = this.checked;
        saveState();
      });
    }

    // Stage 3: -2" off the top checkbox
    var m2Check = $('vc-minus2');
    if (m2Check) {
      m2Check.addEventListener('change', function () {
        state.minus2 = this.checked;
        saveState();
      });
    }

    // Stages 2, 4, 5, 7: radio/checkbox option cards (event delegation)
    [dom.stage2, dom.stage4, dom.stage5, dom.stage7].forEach(function (stageEl) {
      if (!stageEl) return;
      stageEl.addEventListener('change', function (e) {
        var t = e.target;
        var nameMap = {
          'vc-harnessType': 'harnessType',
          'vc-legPadConfig': 'legPadConfig',
          'vc-backpad': 'backpad',
          'vc-stabilizers': 'stabilizers',
          'vc-mainHandle': 'mainHandle',
          'vc-mainDBag': 'mainDBag',
          'vc-pilotChuteFabric': 'pilotChuteFabric',
          'vc-pilotChuteSize': 'pilotChuteSize',
          'vc-reserveHandle': 'reserveHandle',
          'vc-emergencySystem': 'emergencySystem',
          'vc-riserType': 'riserType',
          'vc-ringType': 'ringType',
          'vc-riserCovers': 'riserCovers',
          'vc-riserLength': 'riserLength',
          'vc-toggleType': 'toggleType',
          'vc-hookKnife': 'hookKnife',
          'vc-hardwareFinish': 'hardwareFinish',
          'vc-aad': 'aad'
        };

        if (nameMap[t.name]) {
          state[nameMap[t.name]] = t.value;
          updateCardSelected(t);
          // Show/hide PC handle colors based on handle type
          if (t.name === 'vc-mainHandle') {
            var hcDiv = $('vc-pc-handle-colors');
            if (hcDiv) hcDiv.style.display = (t.value === 'plastic-handle') ? 'none' : '';
          }
        }
        saveState();
      });
    });

    // PC Handle color dropdowns (Stage 5)
    var pcColor1 = $('vc-pcHandleColor1');
    var pcColor2 = $('vc-pcHandleColor2');
    if (pcColor1) pcColor1.addEventListener('change', function () { state.pcHandleColor1 = this.value; saveState(); });
    if (pcColor2) pcColor2.addEventListener('change', function () { state.pcHandleColor2 = this.value; saveState(); });

    // Stage 5: combined canopy dropdowns
    dom.mainCanopySelect.addEventListener('change', function () {
      var val = this.value;
      if (!val) {
        state.mainCanopyBrand = '';
        state.mainCanopyModel = '';
        state.mainCanopySize = '';
        var sc = $('vc-main-size-buttons');
        if (sc) { sc.innerHTML = ''; sc.style.display = 'none'; }
      } else {
        var parts = val.split('||');
        state.mainCanopyBrand = parts[0];
        state.mainCanopyModel = parts[1];
        state.mainCanopySize = '';
      }
      renderSizeButtons('vc-main-size-buttons', state.mainCanopyModel, 'main');
      updateContainerResult();
      updateWingLoading();
      renderCanopyProductCard('vc-main-product-card', state.mainCanopyModel, state.mainCanopySize, window.vcMainCanopyProducts);
      updateCanopyToggleVisibility('main');
      saveState();
    });
    dom.reserveCanopySelect.addEventListener('change', function () {
      var val = this.value;
      if (!val) {
        state.reserveCanopyBrand = '';
        state.reserveCanopyModel = '';
        state.reserveCanopySize = '';
        var sc = $('vc-reserve-size-buttons');
        if (sc) { sc.innerHTML = ''; sc.style.display = 'none'; }
      } else {
        var parts = val.split('||');
        state.reserveCanopyBrand = parts[0];
        state.reserveCanopyModel = parts[1];
        state.reserveCanopySize = '';
      }
      renderSizeButtons('vc-reserve-size-buttons', state.reserveCanopyModel, 'reserve');
      updateContainerResult();
      renderCanopyProductCard('vc-reserve-product-card', state.reserveCanopyModel, state.reserveCanopySize, window.vcReserveCanopyProducts);
      updateCanopyToggleVisibility('reserve');
      saveState();
    });

    // Canopy include toggles (state only — selector stays visible for rig sizing)
    var includeMainCB = $('vc-include-main');
    if (includeMainCB) {
      includeMainCB.addEventListener('change', function () {
        state.includeMainCanopy = this.checked;
        saveState();
      });
    }
    var includeReserveCB = $('vc-include-reserve');
    if (includeReserveCB) {
      includeReserveCB.addEventListener('change', function () {
        state.includeReserveCanopy = this.checked;
        saveState();
      });
    }

    // Size buttons click delegation
    dom.stage6.addEventListener('click', function (e) {
      var btn = e.target.closest('.vc-size-btn');
      if (!btn) return;
      var size = parseInt(btn.dataset.size, 10);
      var slot = btn.dataset.slot;
      if (slot === 'main') {
        state.mainCanopySize = size;
        renderSizeButtons('vc-main-size-buttons', state.mainCanopyModel, 'main');
        updateContainerResult();
        updateWingLoading();
        renderCanopyProductCard('vc-main-product-card', state.mainCanopyModel, state.mainCanopySize, window.vcMainCanopyProducts);
      } else if (slot === 'reserve') {
        state.reserveCanopySize = size;
        renderSizeButtons('vc-reserve-size-buttons', state.reserveCanopyModel, 'reserve');
        updateContainerResult();
        renderCanopyProductCard('vc-reserve-product-card', state.reserveCanopyModel, state.reserveCanopySize, window.vcReserveCanopyProducts);
        updateWingLoading();
      }
      saveState();
    });

    // Size buttons keyboard accessibility
    dom.stage6.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        var btn = e.target.closest('.vc-size-btn');
        if (btn) { e.preventDefault(); btn.click(); }
      }
    });

    // AAD
    dom.stage6.addEventListener('change', function (e) {
      if (e.target.name === 'vc-aad') {
        state.aad = e.target.value;
        var aadCards = document.querySelectorAll('.vc-aad-product-option');
        for (var ac = 0; ac < aadCards.length; ac++) {
          var inp = aadCards[ac].querySelector('input');
          aadCards[ac].classList.toggle('selected', inp && inp.checked);
        }
        saveState();
      }
    });

    // Manual container override toggle
    var manualToggle = $('vc-container-manual-toggle');
    if (manualToggle) {
      manualToggle.addEventListener('change', function () {
        state.containerManual = this.checked;
        var picker = $('vc-container-manual-picker');
        var autoResult = $('vc-container-result');
        if (this.checked) {
          if (picker) picker.style.display = '';
          if (autoResult) autoResult.style.display = 'none';
          var sel = $('vc-container-manual-select');
          if (sel && state.containerSize) sel.value = state.containerSize;
        } else {
          if (picker) picker.style.display = 'none';
          if (autoResult) autoResult.style.display = '';
          var infoEl = $('vc-container-manual-info');
          if (infoEl) infoEl.style.display = 'none';
          updateContainerResult();
        }
        saveState();
      });
    }

    // Manual container dropdown
    var manualSelect = $('vc-container-manual-select');
    if (manualSelect) {
      manualSelect.addEventListener('change', function () {
        showManualContainerInfo(this.value);
      });
    }

    // AI generate, logo search, logo upload — all handled inside the AI popup now (openAIDesignerPopup)

    // Stage 6: wingsuit toggle
    var wsToggle = $('vc-wingsuit-toggle');
    if (wsToggle) {
      wsToggle.addEventListener('change', function () {
        state.isWingsuit = this.checked;
        toggleWingsuit(this.checked);
        if (!this.checked) {
          state.wsDynamicCorners = false;
          state.wsBridle = false;
          state.wsSemiStowless = false;
          state.wsDash1Shape = false;
        }
        saveState();
      });
    }

    // Stage 6: WS checkboxes
    dom.stage3.addEventListener('change', function (e) {
      var wsMap = {
        'vc-wsDynamicCorners': 'wsDynamicCorners',
        'vc-wsBridle': 'wsBridle',
        'vc-wsSemiStowless': 'wsSemiStowless',
        'vc-wsDash1Shape': 'wsDash1Shape'
      };
      if (wsMap[e.target.id]) {
        state[wsMap[e.target.id]] = e.target.checked;

        // Auto-select U-Stow d-bag when WS semi-stowless is checked
        if (e.target.id === 'vc-wsSemiStowless') {
          syncWingSuitDBag(e.target.checked);
        }
        saveState();
      }
    });

    // Stage 7: embroidery
    dom.stage7.addEventListener('change', function (e) {
      var idx = e.target.dataset.embIdx;
      if (idx !== undefined) {
        state.embroidery[parseInt(idx, 10)].enabled = e.target.checked;
        var item = e.target.closest('.vc-embroidery-item');
        if (item) item.classList.toggle('active', e.target.checked);
        saveState();
      }
    });
    dom.stage7.addEventListener('input', function (e) {
      var idx = e.target.dataset.embText;
      if (idx !== undefined) {
        state.embroidery[parseInt(idx, 10)].text = e.target.value;
        saveState();
      }
    });

    // Stage 2: JC Stitching & Center Flap Piping toggles
    var jcCheck = $('vc-jcStitching');
    if (jcCheck) {
      jcCheck.addEventListener('change', function () {
        state.jcStitching = this.checked;
        saveState();
      });
    }
    var pipingCheck = $('vc-centerFlapPiping');
    if (pipingCheck) {
      pipingCheck.addEventListener('change', function () {
        state.centerFlapPiping = this.checked;
        saveState();
      });
    }


    // Expert + Contract
    var expertWA = $('vc-expert-whatsapp');
    var expertEM = $('vc-expert-email');
    var quoteBtn = $('vc-request-quote');
    if (expertWA) expertWA.addEventListener('click', expertWhatsApp);
    if (expertEM) expertEM.addEventListener('click', expertEmail);
    if (quoteBtn) quoteBtn.addEventListener('click', requestQuote);

    // Expert banner buttons (on all stages) — event delegation
    dom.container.addEventListener('click', function(e) {
      var waBtn = e.target.closest('.vc-expert-banner-wa');
      var callBtn = e.target.closest('.vc-expert-banner-call');
      if (waBtn) {
        var num = dom.container.dataset.whatsapp || '34644271547';
        var stageLabel = 'Stage ' + state.currentStage;
        var contact = state.userEmail ? '\n\nMy contact: ' + state.userEmail + ' / ' + state.userPhone : '';
        var config = buildSummaryText();
        var msg = 'Hi Ernestas,\n\nI\'m configuring a UPT Vector 3 (currently on ' + stageLabel + ') and would love your expert advice. 100% free consultation appreciated!' + contact + '\n\n' + config;
        window.open('https://wa.me/' + num + '?text=' + encodeURIComponent(msg), '_blank');
      }
      if (callBtn) {
        window.open('https://calendar.app.google/M7LXzPc3shNHPwog9', '_blank');
      }
    });
    var cartBtn = $('vc-add-to-cart');
    if (cartBtn) cartBtn.addEventListener('click', addToCart);

    var scheduleCallBtn = $('vc-schedule-call');
    if (scheduleCallBtn) scheduleCallBtn.addEventListener('click', function () {
      window.open('https://calendar.app.google/M7LXzPc3shNHPwog9', '_blank');
    });

    // Design confirmation from Summary (edit button is wired in renderSummaryDesignPreview)
    // Special Instructions textarea (on summary page)
    var specInstrTA = $('vc-specialInstructions');
    if (specInstrTA) {
      specInstrTA.addEventListener('input', function () {
        state.specialInstructions = this.value;
        saveState();
      });
    }

    var designConfirmBtn = $('vc-design-confirm-btn');
    if (designConfirmBtn) designConfirmBtn.addEventListener('click', function () {
      // If un-confirming, just toggle off
      if (state.designConfirmed) {
        state.designConfirmed = false;
        saveState();
        updateDesignConfirmCard();
        var existingPreview = document.getElementById('vc-order-preview');
        if (existingPreview) existingPreview.remove();
        return;
      }

      // Validate and capture contact info before confirming
      if (!captureContactOnConfirm()) return;

      state.designConfirmed = true;
      saveState();
      updateDesignConfirmCard();
      if (window.vcTrackEvent) {
        window.vcTrackEvent('vc_design_confirmed', { design: (state.savedDesigns[state.selectedDesignIndex] || {}).name || 'Design 1' });
      }
      // Trigger PDF generation + order delivery pipeline
      triggerOrderPipeline();
    });

    // Phase 6: Send Order Form button
    var orderFormBtn = $('vc-send-order-form');
    if (orderFormBtn) orderFormBtn.addEventListener('click', sendOrderForm);

    // Phase 5: Exit detection for abandoned cart recovery
    document.addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'hidden') trackExitIntent();
    });
    window.addEventListener('pagehide', trackExitIntent);

    // Inject expand buttons into card bodies (under the image, not on top of it)
    var imgWraps = dom.container.querySelectorAll('.vc-img-wrap');
    for (var iw = 0; iw < imgWraps.length; iw++) {
      var parentCard = imgWraps[iw].closest('.vc-option-card');
      var cardBody = parentCard ? parentCard.querySelector('.vc-option-card-body') : null;
      if (cardBody && !cardBody.querySelector('.vc-expand-btn')) {
        var eb = document.createElement('button');
        eb.type = 'button';
        eb.className = 'vc-expand-btn';
        eb.setAttribute('aria-label', 'Expand image');
        eb.innerHTML = '\u2922 <span>View</span>';
        cardBody.insertBefore(eb, cardBody.firstChild);
      }
    }

    // Lightbox: open only when clicking the expand button (image clicks select the card)
    dom.container.addEventListener('click', function (e) {
      var btn = e.target.closest('.vc-expand-btn');
      if (!btn) return;
      var card = btn.closest('.vc-option-card');
      if (!card) return;
      var img = card.querySelector('.vc-option-card-img') || card.querySelector('.vc-stitch-ref-img');
      if (!img) return;
      e.stopPropagation();
      e.preventDefault();
      dom.lightboxImg.src = img.src;
      dom.lightboxImg.alt = img.alt || '';
      // Show at 2x the card image size, capped to viewport
      var w = img.naturalWidth || img.offsetWidth;
      var h = img.naturalHeight || img.offsetHeight;
      dom.lightboxImg.style.width = (w * 2) + 'px';
      dom.lightboxImg.style.height = (h * 2) + 'px';
      dom.lightboxCaption.textContent = img.alt || '';
      dom.lightbox.classList.add('open');
      document.body.style.overflow = 'hidden';
    });

    // Lightbox: close on × button
    dom.lightboxClose.addEventListener('click', closeLightbox);

    // Lightbox: close on overlay background (not the image)
    dom.lightbox.addEventListener('click', function (e) {
      if (e.target === dom.lightbox) closeLightbox();
    });

    // Lightbox: close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && dom.lightbox.classList.contains('open')) closeLightbox();
    });
  }

  /* ================================================================
     DOM CACHING
     ================================================================ */
  function cacheDom() {
    dom.container = $('vc-container');
    dom.progressList = dom.container.querySelector('.vc-progress-list');
    dom.progressPrev = $('vc-progress-prev');
    dom.progressNext = $('vc-progress-next');
    dom.errors = $('vc-errors');
    dom.prevBtn = $('vc-prev');
    dom.nextBtn = $('vc-next');

    dom.stage1 = $('vc-stage-1');
    dom.stage2 = $('vc-stage-2');
    dom.stage3 = $('vc-stage-3');
    dom.stage4 = $('vc-stage-4');
    dom.stage5 = $('vc-stage-5');
    dom.stage6 = $('vc-stage-6');
    dom.stage7 = $('vc-stage-7');
    dom.stageSummary = $('vc-stage-summary');

    dom.patternGrid = $('vc-patterns');
    dom.colorPreviewPanel = $('vc-color-preview-panel');

    dom.mainCanopySelect = $('vc-main-canopy');
    dom.reserveCanopySelect = $('vc-reserve-canopy');

    dom.summaryContent = $('vc-summary-content');
    dom.priceEstimate = $('vc-price-estimate');

    // Lightbox
    dom.lightbox = $('vc-lightbox');
    dom.lightboxImg = $('vc-lightbox-img');
    dom.lightboxCaption = $('vc-lightbox-caption');
    dom.lightboxClose = $('vc-lightbox-close');
  }

  /* ================================================================
     INIT
     ================================================================ */
  /* ================================================================
     AUTH + GOOGLE SIGN-IN HELPERS
     ================================================================ */
  function initAuthGate() {
    // Google Identity Services integration
    if (window.vcGoogleClientId && typeof google !== 'undefined' && google.accounts) {
      initGoogleSignIn();
    } else if (window.vcGoogleClientId) {
      var gsiCheck = setInterval(function () {
        if (typeof google !== 'undefined' && google.accounts) {
          clearInterval(gsiCheck);
          initGoogleSignIn();
        }
      }, 200);
      setTimeout(function () { clearInterval(gsiCheck); }, 8000);
    }

    // Animate the Vector counter
    animateCounter('vc-gate-counter-num', 47, 1800);
  }

  function animateCounter(elementId, target, duration) {
    var el = document.getElementById(elementId);
    if (!el) return;
    var start = 0;
    var startTime = null;
    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      // Ease-out cubic for a satisfying deceleration
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(eased * target);
      el.textContent = current.toLocaleString();
      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }
    // Use IntersectionObserver to start animation when visible
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          observer.disconnect();
          requestAnimationFrame(step);
        }
      }, { threshold: 0.3 });
      observer.observe(el);
    } else {
      requestAnimationFrame(step);
    }
  }

  function initGoogleSignIn() {
    try {
      google.accounts.id.initialize({
        client_id: window.vcGoogleClientId,
        callback: handleGoogleCredential
      });
      var btnEl = document.getElementById('vc-gate-google-btn');
      if (btnEl) {
        google.accounts.id.renderButton(btnEl, {
          theme: 'outline',
          size: 'large',
          width: Math.min(btnEl.offsetWidth, 400),
          text: 'continue_with',
          shape: 'rectangular'
        });
      }
    } catch (e) {
      console.warn('Google Sign-In init failed:', e);
    }
  }

  function handleGoogleCredential(response) {
    // Decode JWT to get user profile and pre-fill contact form
    try {
      var b64 = response.credential.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
      var payload = JSON.parse(atob(b64));
      var email = payload.email || '';

      // Pre-fill the contact capture email field
      var emailEl = document.getElementById('vc-gate-email');
      if (emailEl && email) {
        emailEl.value = email;
      }

      // Store name in state for later use
      state.customerName = ((payload.given_name || '') + ' ' + (payload.family_name || '')).trim();

      // Focus the phone field so user just needs to enter their number
      var phoneEl = document.getElementById('vc-gate-phone');
      if (phoneEl) phoneEl.focus();
    } catch (e) {
      console.warn('Google credential decode failed:', e);
    }
  }

  /* ---- 48-hour Black Hardware Promo Countdown ---- */
  var hwPromoStartTime = null;
  var HW_PROMO_DURATION = 48 * 60 * 60 * 1000; // 48 hours

  function getHwPromoRemaining() {
    if (!hwPromoStartTime) {
      var STORAGE_KEY = 'vc_hw_promo_start';
      var startStr = localStorage.getItem(STORAGE_KEY);
      if (startStr) {
        hwPromoStartTime = parseInt(startStr, 10);
      } else {
        hwPromoStartTime = Date.now();
        localStorage.setItem(STORAGE_KEY, String(hwPromoStartTime));
      }
    }
    return HW_PROMO_DURATION - (Date.now() - hwPromoStartTime);
  }

  function formatHwTimer(remaining) {
    if (remaining <= 0) return 'Expired';
    var h = Math.floor(remaining / 3600000);
    var m = Math.floor((remaining % 3600000) / 60000);
    var s = Math.floor((remaining % 60000) / 1000);
    return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  function initHardwarePromoTimer() {
    var timerEl = document.getElementById('vc-hw-timer-text');
    var promoWrap = document.getElementById('vc-hw-promo');
    if (!timerEl || !promoWrap) return;

    function tick() {
      var remaining = getHwPromoRemaining();
      timerEl.textContent = formatHwTimer(remaining);
      // Also update cart price timer if visible
      var priceTimer = document.getElementById('vc-price-hw-timer');
      if (priceTimer) priceTimer.textContent = formatHwTimer(remaining);
      // Also update hero banner timer
      var heroTimer = document.getElementById('vc-hero-hw-timer');
      if (heroTimer) heroTimer.textContent = remaining > 0
        ? '\u23F1 Free Black Hardware upgrade promo \u2014 ' + formatHwTimer(remaining)
        : '';
      if (remaining <= 0) {
        promoWrap.classList.add('vc-hw-promo--expired');
        return;
      }
      setTimeout(tick, 1000);
    }
    tick();
  }

  function init() {
    cacheDom();
    localizeStaticOptionPrices();
    loadState();

    // Check for share link BEFORE stage determination
    var sharedConfig = loadShareLinkData();

    // Load contact data and generate session ID
    loadContact();
    if (!state.sessionId) state.sessionId = generateUUID();

    // Store Shopify customer data in state if available
    var isLoggedIn = window.vcCustomer && window.vcCustomer.loggedIn;
    if (isLoggedIn) {
      state.customerEmail = window.vcCustomer.email || '';
      state.customerName = (window.vcCustomer.firstName || '') + ' ' + (window.vcCustomer.lastName || '');
      state.customerName = state.customerName.trim();
      // Pre-fill userEmail from Shopify account if not yet captured
      if (!state.userEmail && state.customerEmail) {
        state.userEmail = state.customerEmail;
      }
    }

    // Determine starting stage
    if (sharedConfig) {
      // Shared config — jump to summary
      state.contactCaptured = true;
      state.isSharedConfig = true;
      state.currentStage = 8;
    } else if (state.currentStage === 0 || STAGE_ORDER.indexOf(state.currentStage) < 0) {
      // No valid saved stage — start at first configurator stage
      state.currentStage = STAGE_ORDER[0];
    }

    // Populate dynamic content
    renderPatternCards();
    renderTrimPickers();
    renderColorPreview();

    populateCombinedDropdown(dom.mainCanopySelect, MAIN_CANOPIES, 'Select main canopy\u2026');
    populateCombinedDropdown(dom.reserveCanopySelect, RESERVE_CANOPIES, 'Select reserve canopy\u2026');
    populateContainerDropdown();
    renderAADCards();

    renderEmbroidery();

    // Restore form state from loaded data
    restoreInputs();

    // Render color designer summary if saved colors exist
    try { renderColorPreview(); } catch (e) { /* safe */ }

    // Render saved designs cards
    try { renderSavedDesigns(); } catch (e) { /* safe */ }

    bindEvents();
    initHardwarePromoTimer();

    // Initialize contact capture (now in summary stage) + auth helpers
    initContactCapture();
    initAuthGate();

    // "Get Started" hero button — scroll to first configurator stage
    var getStartedBtn = document.getElementById('vc-hero-get-started');
    if (getStartedBtn) {
      getStartedBtn.addEventListener('click', function () {
        var stage2 = document.getElementById('vc-stage-2');
        if (stage2) stage2.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    // Feature cards inside the hero behave like the "Get Started" button —
    // clicking any of them scrolls to the Colors stage.
    var featureCards = document.querySelectorAll('.vc-gate-features--hero .vc-gate-feature-card');
    featureCards.forEach(function (card) {
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.style.cursor = 'pointer';
      var scrollToStage2 = function () {
        var stage2 = document.getElementById('vc-stage-2');
        if (stage2) stage2.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };
      card.addEventListener('click', scrollToStage2);
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); scrollToStage2(); }
      });
    });

    goToStage(state.currentStage);

    // Phase 7: Track page view
    trackEvent('vc_page_view', {
      referrer: document.referrer || '',
      returning_user: state.contactCaptured
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
